/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHÎžTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  historyLimit: 20,
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

// Optional browsing history must stay bounded and must not break purchasing
// when localStorage is full or unavailable after the initial capability check.
theme.recentlyViewed.trimHistory = function() {
  var history = theme.recentlyViewed.recent;
  var handles = Object.keys(history).filter(function(handle) {
    var entry = history[handle];
    return handle && handle !== 'undefined' && !/[/?#]/.test(handle) &&
      handle !== '__proto__' && handle !== 'constructor' && handle !== 'hasOwnProperty' &&
      entry && typeof entry === 'object' && !Array.isArray(entry) &&
      !theme.recentlyViewed.shouldExclude(handle);
  }).slice(-theme.recentlyViewed.historyLimit);
  var bounded = {};
  handles.forEach(function(handle) { bounded[handle] = history[handle]; });
  theme.recentlyViewed.recent = bounded;
};

theme.recentlyViewed.saveHistory = function() {
  theme.recentlyViewed.trimHistory();
  if (!theme.config.hasLocalStorage) { return; }
  try {
    window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
  } catch (error) {
    // A full optional history store must never stop PDP initialization.
  }
};

theme.recentlyViewed.shouldExclude = function(productOrHandle) {
  var handle = '';
  var productType = '';
  var tags = [];

  if (typeof productOrHandle === 'string') {
    handle = productOrHandle;
  } else if (productOrHandle) {
    handle = productOrHandle.handle || '';
    productType = productOrHandle.product_type || productOrHandle.type || '';

    if (Array.isArray(productOrHandle.tags)) {
      tags = productOrHandle.tags;
    } else if (typeof productOrHandle.tags === 'string') {
      tags = productOrHandle.tags.split(',');
    }
  }

  handle = String(handle).toLowerCase();
  productType = String(productType).toLowerCase();

  var hasStorefrontIgnoreTag = tags.some(function(tag) {
    return String(tag).trim().toLowerCase() === 'storefront-ignore';
  });

  return handle === 'shade-carrier-6-inches' ||
    handle.indexOf('shade-carrier-') === 0 ||
    productType === 'shade carriers' ||
    hasStorefrontIgnoreTag;
};

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var lockKey = namespace || '__mekhann_default_scroll_lock__';
      theme.a11y.scrollLocks = theme.a11y.scrollLocks || {};

      if (theme.a11y.scrollLocks[lockKey]) {
        return;
      }

      theme.a11y.scrollLocks[lockKey] = true;
      document.documentElement.classList.add('lock-scroll');

      if (Object.keys(theme.a11y.scrollLocks).length > 1) {
        return;
      }

      var body = document.body;
      var shouldFixBody = (theme.config && theme.config.bpSmall) ||
        document.documentElement.classList.contains('supports-touch');

      theme.a11y.scrollLockState = {
        scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow,
        fixed: shouldFixBody
      };

      if (shouldFixBody) {
        body.style.position = 'fixed';
        body.style.top = '-' + theme.a11y.scrollLockState.scrollY + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      }
    },
  
    unlockMobileScrolling: function(namespace, element) {
      var lockKey = namespace || '__mekhann_default_scroll_lock__';
      theme.a11y.scrollLocks = theme.a11y.scrollLocks || {};
      delete theme.a11y.scrollLocks[lockKey];

      if (Object.keys(theme.a11y.scrollLocks).length) {
        return;
      }

      document.documentElement.classList.remove('lock-scroll');

      var state = theme.a11y.scrollLockState;
      if (!state) {
        return;
      }

      var body = document.body;
      body.style.position = state.position;
      body.style.top = state.top;
      body.style.left = state.left;
      body.style.right = state.right;
      body.style.width = state.width;
      body.style.overflow = state.overflow;

      if (state.fixed) {
        window.scrollTo(0, state.scrollY);
      }

      theme.a11y.scrollLockState = null;
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  const trapFocusHandlers = {};
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function buildImagePath(string, widths) {
  
      if (string == null) return [];
  
      if (widths) {
        const imageUrls = [];
  
        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function(key) {
        return parseInt(key.substr(-1));
      },
  
      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function(variant) {
        return this._getCurrentOptions().reduce((count, {value, index}) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        },0)
      },
  
      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({value, index}) => {
            return variant[index] === value;
          });
  
          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },
  
      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function(lastSelectedOption) {
        if (!lastSelectedOption) return null;
  
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;
  
        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });
  
        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;
  
          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);
  
          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },
  
      _getVariantFromOptions: function(lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);
  
        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
  
      },
  
      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;
  
          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
          } else {
            input.value = variant[index];
          }
        }
      },
  
      _onSelectChange: function({srcElement}) {
        const previousVariant = this.currentVariant;
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
  
        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });
  
        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))
  
        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
  
        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index
        }
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
        document.dispatchEvent(new CustomEvent('variant:change', {detail}));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant, previousVariant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant && this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant, previousVariant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var url = new URL(window.location.href);
        // Keep the bag's fitting target and page context across size changes.
        // An old image deep link must not override the newly selected variant
        // when this URL is reloaded; a same-variant update can retain it.
        if (!previousVariant || String(previousVariant.id) !== String(variant.id)) {
          url.searchParams.delete('media');
        }
        url.searchParams.set('variant', variant.id);
        var newurl = url.toString();
        window.history.replaceState(Object.assign({}, window.history.state || {}, {path: newurl}), '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;
  
        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true
        theme.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }
  
  function checkIfVimeoIsReady () {
    let wait
    let timeout
  
    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }
  
        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)
  
      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }
  
  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }
  
    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }
  
      this.setAsLoading()
  
      if (theme.config.vimeoReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId
  
        this.videoPlayer = new Vimeo.Player(this.el, args)
  
        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },
  
      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')
  
        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }
  
        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }
  
        this.setAsLoaded()
  
        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })
  
        observer.observe(this.iframe)
      },
  
      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },
  
      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },
  
      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },
  
      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },
  
      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })
  
    return VimeoPlayer
  })()
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  /* MEKHANN_RC6_HELPERS_START */
  theme.mekhannBuild = 'V2.18.3-PDP-BUILDER-GATE2-CANDIDATE-2026-09-01';
  theme.getMekhannDisplayUrl = function(variantUrl, mediaId) {
    if (!variantUrl) return '';
    if (!mediaId) return variantUrl;

    try {
      var parsedUrl = new URL(variantUrl, window.location.origin);
      parsedUrl.searchParams.set('media', mediaId);
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      var separator = variantUrl.indexOf('?') === -1 ? '?' : '&';
      return variantUrl + separator + 'media=' + encodeURIComponent(mediaId);
    }
  };
  theme.getLampshadeTouchIntent = function(deltaX, deltaY) {
    var horizontalDistance = Math.abs(deltaX);
    var verticalDistance = Math.abs(deltaY);

    if (verticalDistance > 8 && verticalDistance > horizontalDistance * 1.1) {
      return 'vertical';
    }

    if (horizontalDistance > 18 && horizontalDistance > verticalDistance * 1.25) {
      return 'horizontal';
    }

    return 'pending';
  };

  theme.isMekhannCommonMediaGroup = function(group) {
    var normalizedGroup = String(group || 'all').toLowerCase();
    return normalizedGroup === 'common' || normalizedGroup.slice(-7) === '_common';
  };

  theme.chooseMekhannMedia = function(mediaItems, selectedGroup, selectedSize, selectedMediaId) {
    selectedGroup = String(selectedGroup || 'all');
    selectedSize = String(selectedSize || 'all');
    selectedMediaId = String(selectedMediaId || '');
    var allowCommonMedia = selectedSize === 'all';

    var eligible = mediaItems.filter(function(item) {
      var group = String(item.group || 'all');
      var size = String(item.size || 'all');
      var isCommon = theme.isMekhannCommonMediaGroup(group);
      var matchesColour = selectedGroup === 'all' ?
        (group === 'all' || isCommon) :
        (group === selectedGroup || (isCommon && allowCommonMedia));
      var matchesSize = selectedSize === 'all' || size === 'all' || size === selectedSize;

      return matchesColour && matchesSize;
    });

    if (!eligible.length) {
      return mediaItems[0] || null;
    }

    function firstMatch(predicate) {
      return eligible.find(predicate) || null;
    }

    // Exact colour + exact size is the strongest merchant intent. Liquid has
    // already classified any variant-assigned placeholder as that variant's
    // media; only genuinely unassigned accessory images remain common.
    return firstMatch(function(item) {
      return !theme.isMekhannCommonMediaGroup(item.group) &&
        String(item.group || 'all') === selectedGroup &&
        selectedSize !== 'all' && String(item.size || 'all') === selectedSize;
    }) || firstMatch(function(item) {
      return !theme.isMekhannCommonMediaGroup(item.group) &&
        String(item.id) === selectedMediaId;
    }) || firstMatch(function(item) {
      return !theme.isMekhannCommonMediaGroup(item.group) &&
        (selectedGroup === 'all' || String(item.group || 'all') === selectedGroup);
    }) || firstMatch(function(item) {
      return !theme.isMekhannCommonMediaGroup(item.group);
    }) || firstMatch(function(item) {
      return String(item.id) === selectedMediaId;
    }) || eligible[0];
  };
  /* MEKHANN_RC6_HELPERS_END */

  // Preserve native page scrolling until a card gesture is clearly horizontal.
  (function() {
    var e = !1;
    var t;
    var activeSlider;
    var productCardIntent = 'pending';
  
    document.body.addEventListener('touchstart', function(i) {
      activeSlider = i.target.closest('.flickity-slider');
      productCardIntent = 'pending';
      if (!activeSlider) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    }, true)
  
    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        var horizontalDistance = Math.abs(n.x);
        var verticalDistance = Math.abs(n.y);
        var isProductCardGallery = activeSlider && activeSlider.closest('[data-mobile-product-track]');

        if (isProductCardGallery) {
          if (productCardIntent === 'pending') {
            productCardIntent = theme.getLampshadeTouchIntent(n.x, n.y);
          }

          if (productCardIntent === 'vertical') {
            // Stop Flickity seeing a vertical page-scroll gesture. Do not call
            // preventDefault: the browser must retain native vertical scroll.
            i.stopPropagation();
            return;
          }

          if (productCardIntent === 'horizontal') {
            i.preventDefault();
          }
          return;
        }

        if (horizontalDistance > Flickity.defaults.dragThreshold && horizontalDistance > verticalDistance * 1.25) {
          i.preventDefault();
        }
      }
    }, { passive: !1, capture: true })

    function resetTouchIntent() {
      e = !1;
      activeSlider = null;
      productCardIntent = 'pending';
    }

    document.body.addEventListener('touchend', resetTouchIntent, true);
    document.body.addEventListener('touchcancel', resetTouchIntent, true);
  })();
  

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
      this.generation = 0;
      this.controller = null;
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true, options = {}) {
        var self = this;
        var generation = ++this.generation;
        if (this.controller) this.controller.abort();
        this.controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var controller = this.controller;
        var params = options.replaceParams ? new URLSearchParams(newParams) :
          this.getUpdatedParams(new URLSearchParams(window.location.search), newParams);
        params.delete('section_id');
        params.delete('sections');
        var timedOut = false;
        var timer;
        var timeout = new Promise(function(resolve, reject) {
          timer = window.setTimeout(function() {
            timedOut = true;
            if (controller) controller.abort();
            reject(new Error('Collection request timed out'));
          }, options.timeoutMs || 15000);
        });
        var requests = this.sections.map(function(section) {
          var requestParams = new URLSearchParams(params);
          requestParams.set('section_id', section.sectionId);
          var url = basePath + '?' + requestParams.toString();
          var cached = self.cachedSections.find(function(entry) { return entry.url === url; });
          if (cached) return Promise.resolve({ section: section, url: url, html: cached.html, cached: true });
          return fetch(url, { signal: controller ? controller.signal : undefined })
            .then(function(response) {
              if (!response.ok) throw new Error('Collection request failed (' + response.status + ')');
              return response.text();
            })
            .then(function(html) { return { section: section, url: url, html: html, cached: false }; });
        });
        return Promise.race([Promise.all(requests), timeout]).then(function(responses) {
          if (generation !== self.generation) return { applied: false, stale: true };
          // Validate every requested section before altering the currently usable view.
          var prepared = responses.map(function(response) {
            var dom = new DOMParser().parseFromString(response.html, 'text/html');
            var ids = Array.isArray(response.section.nodeId) ? response.section.nodeId : [response.section.nodeId];
            if (!ids.every(function(id) {
              var incoming = dom.getElementById(id);
              var mounted = document.getElementById(id);
              if (!incoming || !mounted) return false;
              var incomingOwner = incoming.closest('[data-section-id]');
              var mountedOwner = mounted.closest('[data-section-id]');
              return incomingOwner && mountedOwner &&
                incomingOwner.getAttribute('data-section-id') === response.section.sectionId &&
                mountedOwner.getAttribute('data-section-id') === response.section.sectionId;
            })) {
              throw new Error('Collection response is missing its expected section');
            }
            response.dom = dom;
            return response;
          });
          prepared.forEach(function(response) {
            self.renderSection(response.dom, response.section);
            if (!response.cached) self.cachedSections.push({ url: response.url, html: response.html });
          });
          // Page-local history cache; never retain an unbounded collection of full HTML pages.
          if (self.cachedSections.length > 12) self.cachedSections = self.cachedSections.slice(-12);
          if (updateURLHash) self.updateURLHash(params, options.replaceHistory);
          return { applied: true, searchParams: params };
        }).catch(function(error) {
          if (generation !== self.generation) return { applied: false, stale: true };
          if (timedOut) error = new Error('Collection request timed out');
          throw error;
        }).finally(function() {
          window.clearTimeout(timer);
          if (generation === self.generation) self.controller = null;
        });
      },

      renderSection: function(dom, section) {
        if (this.onReplace) {
          this.onReplace(dom, section);
        } else {
          var ids = Array.isArray(section.nodeId) ? section.nodeId : [section.nodeId];
          ids.forEach(function(id) { document.getElementById(id).innerHTML = dom.getElementById(id).innerHTML; });
        }
        return section;
      },

      getUpdatedParams: function(currentParams, newParams) {
        var next = new URLSearchParams(currentParams);
        // Filter forms describe the complete selected filter set. Iterate a snapshot,
        // not the live URLSearchParams iterator whose cursor moves after delete().
        Array.from(new Set(Array.from(next.keys()))).forEach(function(key) {
          if (key.indexOf('filter.') === 0 || key === 'page' || key === 'section_id' || key === 'sections' || newParams.has(key)) {
            next.delete(key);
          }
        });
        for (const [key, value] of newParams.entries()) {
          if (value !== '' && !next.getAll(key).includes(value)) next.append(key, value);
        }
        return next;
      },

      updateURLHash: function(searchParams, replace) {
        var query = searchParams.toString();
        var url = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
        if (replace) history.replaceState({}, '', url);
        else if (url !== window.location.pathname + window.location.search + window.location.hash) history.pushState({}, '', url);
      },

      destroy: function() {
        this.generation++;
        if (this.controller) this.controller.abort();
        this.controller = null;
        this.cachedSections = [];
      },

      log: function(...args) { if (this.debug) console.log(...args); }
    });
    return AjaxRenderer;
  })();


  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      // Drawer and full-page forms handle the same cart:build synchronously.
      // Share only that turn's read, never a resolved or cross-mutation cache.
      if (this._mekhannMarkupRead) return this._mekhannMarkupRead;
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var options = { credentials: 'same-origin', method: 'GET', cache: 'no-store' };
      if (controller) options.signal = controller.signal;
      var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.request(url, options);
      var traceStatus = 0;
      // Quantity updates release their pending state after this promise settles.
      // Bound both fetch and body reading, including transports that ignore abort.
      var request = new Promise(function(resolve, reject) {
        var settled = false;
        var timer = window.setTimeout(function() {
          if (settled) return;
          settled = true;
          if (controller) controller.abort();
          if (traceEnd) traceEnd('timeout', traceStatus);
          reject(new Error('Your bag could not be refreshed in time. Please refresh before checking out.'));
        }, 15000);
        Promise.resolve().then(function() { return fetch(url, options); }).then(function(response) {
          traceStatus = response.status;
          if (!response.ok) throw new Error('Your bag could not be refreshed. Please try again.');
          return response.text();
        }).then(function(text) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          if (traceEnd) traceEnd('complete', traceStatus);
          resolve(text);
        }, function(error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          if (traceEnd) traceEnd('error', traceStatus);
          reject(error);
        });
      });
      this._mekhannMarkupRead = request;
      var owner = this;
      Promise.resolve().then(function() {
        if (owner._mekhannMarkupRead === request) owner._mekhannMarkupRead = null;
      });
      return request;
    },
  
    changeItem: function(key, qty) {
  
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
/* Optional local diagnostics. No requests, payloads, tokens or note text.
   Enable explicitly with ?mekhann_cart_trace=1 for a controlled preview run. */
theme.mekhannCartTrace = (function() {
  var enabled = false;
  try { enabled = new URLSearchParams(window.location.search).get('mekhann_cart_trace') === '1'; } catch (ignore) {}
  var entries = [], sequence = 0;
  var clock = window.performance && typeof window.performance.now === 'function' ?
    function() { return window.performance.now(); } : function() { return Date.now(); };
  var origin = enabled ? clock() : 0;
  function publish() {
    try {
      document.documentElement.setAttribute('data-mekhann-cart-trace', JSON.stringify({
        version: 1, clock: window.performance && typeof window.performance.now === 'function' ? 'performance' : 'date', entries: entries
      }));
    } catch (ignore) { /* Diagnostics cannot block the shopping bag. */ }
  }
  function start(stage) {
    if (!enabled) return null;
    var began = clock();
    var entry = {id: ++sequence, stage: stage, startMs: Math.round(began - origin), state: 'pending'};
    entries.push(entry);
    if (entries.length > 64) entries.shift();
    publish();
    return function(outcome, status) {
      if (entry.state !== 'pending') return;
      entry.state = outcome === 'error' || outcome === 'timeout' ? outcome : 'complete';
      entry.durationMs = Math.max(0, Math.round(clock() - began));
      if (Number.isFinite(Number(status)) && Number(status) > 0) entry.status = Number(status);
      publish();
    };
  }
  function mark(stage) { var end = start(stage); if (end) end(); }
  function request(url, options) {
    if (!enabled) return null;
    var path = String(url || '').split('?')[0];
    var kind = /\/cart\/add(?:\.js)?$/.test(path) ? 'add' :
      /\/cart\/change(?:\.js)?$/.test(path) ? 'change' :
      /\/cart\/update(?:\.js)?$/.test(path) ? 'update' :
      /\/cart\.js$/.test(path) ? 'read' : 'html';
    return start('request.' + kind + (options && options.mekhannBundled ? '.section' : ''));
  }
  function images(root) {
    if (!enabled || !root) return;
    // Observe loaded state only. Do not force decode, alter loading priority,
    // wait for below-fold lazy images or hold the transaction open.
    Array.prototype.forEach.call(root.querySelectorAll('.cart__image img'), function(img) {
      if (img.getAttribute('loading') === 'lazy') return;
      var end = start('image.eager.load');
      function finish() {
        img.removeEventListener('load', finish);
        img.removeEventListener('error', finish);
        end(img.naturalWidth > 0 ? 'complete' : 'error');
      }
      if (img.complete) finish();
      else { img.addEventListener('load', finish, {once: true}); img.addEventListener('error', finish, {once: true}); }
    });
  }
  return {enabled: enabled, start: start, mark: mark, request: request, images: images};
})();

/* V2.28.14: response-local Liquid evidence; a tokenless cart projection is
   provisional until the final full Ajax response proves identity. No cache. */
theme.mekhannCartSections = (function() {
  var CONTEXT = 'mekhann-cart-context';
  var RESPONSE = 'mekhann-cart-response';
  var EVIDENCE = '__mekhannSectionEvidence';
  var parsedContexts = typeof WeakMap === 'function' ? new WeakMap() : null;
  var snapshotIdentities = typeof WeakMap === 'function' ? new WeakMap() : null;
  var consumedAdds = typeof WeakSet === 'function' ? new WeakSet() : null;

  function prepare(options, mode) {
    var prepared = Object.assign({}, options || {});
    if (!prepared.body || String(prepared.method || 'GET').toUpperCase() !== 'POST') return prepared;
    var section = mode === 'context' ? CONTEXT : RESPONSE;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var path = theme.routes.cartPage || root + 'cart';
    // Shopify requires a relative URL beginning with '/'. Discard query state.
    if (typeof path !== 'string' || path.charAt(0) !== '/' || path.charAt(1) === '/') path = root + 'cart';
    path = path.split('?')[0].split('#')[0];
    try {
      if (typeof FormData !== 'undefined' && prepared.body instanceof FormData) {
        var fields = new FormData();
        prepared.body.forEach(function(value, key) { fields.append(key, value); });
        fields.set('sections', section);
        fields.set('sections_url', path);
        prepared.body = fields;
      } else {
        var body = typeof prepared.body === 'string' ? JSON.parse(prepared.body) : prepared.body;
        if (!body || typeof body !== 'object' || Array.isArray(body)) return prepared;
        body = Object.assign({}, body, {sections: section, sections_url: path});
        prepared.body = JSON.stringify(body);
      }
      prepared.mekhannBundled = true;
    } catch (ignore) { /* Keep the original mutation when its format is unknown. */ }
    return prepared;
  }

  function sections(data) { return data && (data.sections || data[EVIDENCE]); }
  function markup(data) {
    var evidence = sections(data);
    return evidence && typeof evidence[RESPONSE] === 'string' && evidence[RESPONSE] || null;
  }
  function context(data) {
    var evidence = sections(data);
    if (!evidence) return null;
    var text = typeof evidence[RESPONSE] === 'string' ? evidence[RESPONSE] : evidence[CONTEXT];
    if (typeof text !== 'string' || !text) return null;
    var cached = parsedContexts && parsedContexts.get(evidence);
    if (cached && cached.text === text) return cached.context;
    var result = null;
    var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.start('html.context.parse');
    try {
      var holder = document.createElement('div');
      holder.innerHTML = text;
      var nodes = holder.querySelectorAll('script[data-mekhann-bundled-context]');
      if (nodes.length === 1) {
        var value = JSON.parse(nodes[0].textContent);
        if (value && [3, 4].indexOf(value.version) !== -1 && Array.isArray(value.items) && Array.isArray(value.mappings)) result = value;
      }
    } catch (ignore) {}
    if (parsedContexts) parsedContexts.set(evidence, {text: text, context: result});
    if (traceEnd) traceEnd(result ? 'complete' : 'error');
    return result;
  }
  function allocationsAgree(proof, actual) {
    if (!Array.isArray(proof) || !Array.isArray(actual) || proof.length !== actual.length) return false;
    return proof.every(function(value, index) {
      var allocation = actual[index];
      var application = allocation && allocation.discount_application;
      var type = application && application.type;
      var proofType = value && value.type;
      // V2.34-HAR1: Ajax may supply a type omitted by matching Liquid proof.
      // Absence is compatible; malformed or conflicting explicit types are not.
      if (type !== undefined && type !== null && typeof type !== 'string' ||
          proofType !== undefined && proofType !== null && typeof proofType !== 'string') return false;
      return value && allocation && application && Number(value.amount) === Number(allocation.amount) &&
        typeof application.title === 'string' && value.title === application.title &&
        (type === undefined || type === null || type === '' ||
          proofType === undefined || proofType === null || proofType === '' || type === proofType);
    });
  }
  function agrees(proof, cart) {
    if (!proof || !cart || !Array.isArray(cart.items) || proof.items.length !== cart.items.length ||
        proof.currency !== cart.currency || Number(proof.total_price) !== Number(cart.total_price) ||
        Number(proof.total_discount) !== Number(cart.total_discount)) return false;
    return proof.items.every(function(item) {
      var line = cart.items.find(function(candidate) { return candidate.key === item.key; });
      return line && Number(item.variant_id) === Number(line.variant_id) && Number(item.quantity) === Number(line.quantity) &&
        Number(item.original_line_price) === Number(line.original_line_price) && Number(item.final_line_price) === Number(line.final_line_price) &&
        allocationsAgree(item.allocations, line.line_level_discount_allocations);
    });
  }
  function carry(from, to) {
    var evidence = sections(from);
    if (!evidence || !agrees(context(from), to)) return to;
    // Bare add.js items never represent the full cart. Only matching Liquid
    // evidence travels with a full Ajax cart or the strict projection below.
    try { Object.defineProperty(to, EVIDENCE, {value: evidence, configurable: true}); } catch (ignore) {}
    return to;
  }
  function integer(value, minimum) { return Number.isSafeInteger(value) && value >= minimum; }
  function object(value) { return value && typeof value === 'object' && !Array.isArray(value); }
  function stable(value) {
    if (Array.isArray(value)) return value.map(stable);
    if (!object(value)) return value;
    var sorted = Object.create(null);
    Object.keys(value).sort().forEach(function(key) { sorted[key] = stable(value[key]); });
    return sorted;
  }
  function equal(left, right) { return JSON.stringify(stable(left)) === JSON.stringify(stable(right)); }
  function rawText(value) {
    if (typeof value !== 'string') throw new Error('Unsupported Liquid text');
    // Decode one known layer only; never let literal entity text turn into
    // markup or decode repeatedly. Round-trip rejects a different encoding.
    var decode = {'&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'"};
    var encode = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
    var raw = value.replace(/&(?:amp|lt|gt|quot|#39);/g, function(entity) { return decode[entity]; });
    if (raw.replace(/[&<>"']/g, function(character) { return encode[character]; }) !== value) throw new Error('Unsupported Liquid encoding');
    return raw;
  }
  function rawMap(value) {
    if (!object(value)) throw new Error('Unsupported Liquid map');
    var result = Object.create(null);
    Object.keys(value).forEach(function(key) {
      var decoded = rawText(key);
      if (Object.prototype.hasOwnProperty.call(result, decoded)) throw new Error('Duplicate Liquid key');
      result[decoded] = rawText(value[key]);
    });
    return result;
  }
  function lineIdentity(line) {
    var plan = line.selling_plan_allocation;
    return {key: line.key, variant: Number(line.variant_id || line.id), product: Number(line.product_id), quantity: line.quantity,
      properties: line.properties || {}, parent: line.parent_relationship && line.parent_relationship.parent_key || '',
      plan: Number(plan && (plan.selling_plan && plan.selling_plan.id || plan.selling_plan_id) || 0)};
  }
  function sameLine(proof, actual) {
    return proof && actual && equal(lineIdentity(proof), lineIdentity(actual)) &&
      ['original_price', 'final_price', 'original_line_price', 'final_line_price'].every(function(key) { return proof[key] === actual[key]; }) &&
      ['product_type', 'product_title', 'title', 'variant_title'].every(function(key) { return proof[key] === (actual[key] || ''); }) &&
      allocationsAgree(proof.line_level_discount_allocations.map(function(allocation) {
        return {amount: allocation.amount, title: allocation.discount_application.title, type: allocation.discount_application.type};
      }), actual.line_level_discount_allocations);
  }
  function ownedParentTransition(receipt, before, proof) {
    // Shopify can re-key the qualifying shade and attach a zero allocation
    // when its carrier becomes free. Only this acknowledged carrier receipt
    // may identify that one parent; every unrelated line stays exact.
    if (receipt.length !== 1 || !theme.mekhannCartGroups) return null;
    var child = receipt[0], props = child && child.properties;
    if (!object(props) || props._mekhann_addon_type !== 'shade_carrier' ||
        props._mekhann_carrier_pilot !== 'V2.19.3' || typeof props._mekhann_pilot_token !== 'string' || !props._mekhann_pilot_token ||
        typeof props._mekhann_parent_line_key !== 'string' || !props._mekhann_parent_line_key ||
        typeof props._mekhann_parent_group !== 'string' || !props._mekhann_parent_group ||
        typeof props._mekhann_parent_selection_key !== 'string' || !props._mekhann_parent_selection_key) return null;
    var parents = before.items.filter(function(item) { return item.key === props._mekhann_parent_line_key; });
    if (parents.length !== 1) return null;
    var parent = parents[0], descriptor = JSON.parse(props._mekhann_parent_group);
    var type = String(parent.product_type || '').toLowerCase().replace(/[\s_-]+/g, '');
    if (['lampshade', 'lampshades'].indexOf(type) === -1 || lineIdentity(parent).parent ||
        !parent.properties || typeof parent.properties._mekhann_fitting_group !== 'string' || !parent.properties._mekhann_fitting_group ||
        Number(props._mekhann_parent_variant_id) !== Number(parent.variant_id) ||
        props._mekhann_parent_selection_key !== parent._mekhann_parent_selection_key ||
        !object(descriptor) || !equal(descriptor, theme.mekhannCartGroups.selectionDescriptor(parent)) ||
        before.items.filter(function(item) { return theme.mekhannCartGroups.sameSelection(item, parent); }).length !== 1) return null;
    return {parent: parent, selectionKey: props._mekhann_parent_selection_key,
      allocations: child.line_level_discount_allocations, proof: proof};
  }
  function sameOwnedParent(line, transition) {
    if (!line || !transition || !Array.isArray(transition.allocations) || !transition.allocations.length) return false;
    var parent = transition.parent, previous = lineIdentity(parent), next = lineIdentity(line);
    previous.key = ''; next.key = '';
    if (!equal(previous, next) || parent.original_price !== parent.final_price || parent.original_line_price !== parent.final_line_price ||
        !['original_price', 'final_price', 'original_line_price', 'final_line_price'].every(function(key) { return line[key] === parent[key]; }) ||
        !['product_type', 'product_title', 'title', 'variant_title'].every(function(key) { return line[key] === (parent[key] || ''); })) return false;
    var contextLines = transition.proof.items.filter(function(item) { return item.key === line.key; });
    if (contextLines.length !== 1 || contextLines[0].selection_key !== transition.selectionKey) return false;
    function zeroAllocation(allocation) {
      var application = allocation && allocation.discount_application;
      return allocation && allocation.amount === 0 && object(application) && typeof application.title === 'string' &&
        transition.allocations.some(function(childAllocation) {
          var childApplication = childAllocation && childAllocation.discount_application;
          return childAllocation && integer(childAllocation.amount, 1) && object(childApplication) &&
            application.title === childApplication.title &&
            (!application.type || !childApplication.type || application.type === childApplication.type);
        });
    }
    return Array.isArray(parent.line_level_discount_allocations) && parent.line_level_discount_allocations.every(zeroAllocation) &&
      line.line_level_discount_allocations.length > 0 && line.line_level_discount_allocations.every(zeroAllocation);
  }
  function validateSnapshot(value) {
    var fields = ['version', 'text_encoding', 'currency', 'item_count', 'total_price', 'total_discount',
      'requires_shipping', 'taxes_included', 'note', 'attributes', 'cart_level_discount_applications', 'items'];
    if (!object(value) || value.version !== 1 || value.text_encoding !== 'liquid-html-v1' ||
        Object.keys(value).some(function(key) { return fields.indexOf(key) === -1; }) ||
        typeof value.currency !== 'string' || !/^[A-Z]{3}$/.test(value.currency) ||
        !integer(value.item_count, 0) || !integer(value.total_price, 0) || !integer(value.total_discount, 0) ||
        typeof value.requires_shipping !== 'boolean' || typeof value.taxes_included !== 'boolean' ||
        !Array.isArray(value.items) || !Array.isArray(value.cart_level_discount_applications)) return null;
    var cart = JSON.parse(JSON.stringify(value));
    cart.note = rawText(cart.note); cart.attributes = rawMap(cart.attributes);
    var keys = Object.create(null), quantity = 0;
    var valid = cart.items.every(function(item) {
      if (!object(item) || typeof item.key !== 'string' || !item.key || keys[item.key] ||
          !integer(item.variant_id, 1) || item.id !== item.variant_id || !integer(item.product_id, 1) || !integer(item.quantity, 1) ||
          !['original_price', 'final_price', 'original_line_price', 'final_line_price'].every(function(key) { return integer(item[key], 0); }) ||
          !['product_type', 'product_title', 'title', 'variant_title'].every(function(key) { return typeof item[key] === 'string'; }) ||
          !Array.isArray(item.line_level_discount_allocations)) return false;
      keys[item.key] = true; quantity += item.quantity;
      item.properties = rawMap(item.properties);
      if (item.parent_relationship !== null && (!object(item.parent_relationship) ||
          typeof item.parent_relationship.parent_key !== 'string' || !item.parent_relationship.parent_key)) return false;
      if (item.selling_plan_allocation !== null && (!object(item.selling_plan_allocation) ||
          !object(item.selling_plan_allocation.selling_plan) || !integer(item.selling_plan_allocation.selling_plan.id, 1))) return false;
      return item.line_level_discount_allocations.every(function(allocation) {
        return object(allocation) && integer(allocation.amount, 0) && object(allocation.discount_application) &&
          (allocation.discount_application.type === null || typeof allocation.discount_application.type === 'string') &&
          typeof allocation.discount_application.title === 'string';
      });
    });
    if (!valid || quantity !== cart.item_count || !cart.cart_level_discount_applications.every(function(discount) {
      return object(discount) && typeof discount.title === 'string' && integer(discount.total_allocated_amount, 0);
    })) return null;
    return cart;
  }
  function priorToken(cart) { return snapshotIdentities && snapshotIdentities.get(cart) || ''; }
  function fromAdd(response, before, canUse) {
    // Only acknowledged, new, tagged lines owned by this in-flight operation.
    // Existing-line edits, uncertain writes and old context versions use GETs.
    try {
      if (!snapshotIdentities || !consumedAdds || !object(response) || consumedAdds.has(response) ||
          typeof canUse !== 'function' || !canUse() || !before || !Array.isArray(before.items)) return null;
      consumedAdds.add(response);
      var token = priorToken(before) || before.token;
      var proof = context(response), receipt = response.items;
      if (typeof token !== 'string' || !token || !proof || proof.version !== 4 || !Array.isArray(receipt) || !receipt.length) return null;
      var cart = validateSnapshot(proof.cart_snapshot);
      if (!cart || !agrees(proof, cart) || cart.currency !== before.currency ||
          cart.note !== (before.note || '') || !equal(cart.attributes, before.attributes || {}) ||
          cart.items.length !== before.items.length + receipt.length) return null;
      var allKeys = Object.create(null), matchedKeys = Object.create(null);
      var transition = ownedParentTransition(receipt, before, proof);
      var previousUnchanged = before.items.every(function(item) {
        if (allKeys[item.key]) return false;
        allKeys[item.key] = true;
        var line = cart.items.find(function(candidate) { return candidate.key === item.key; });
        if (!sameLine(line, item)) {
          if (!transition || transition.parent !== item) return false;
          var matches = cart.items.filter(function(candidate) { return sameOwnedParent(candidate, transition); });
          if (matches.length !== 1 || cart.items.filter(function(candidate) { return theme.mekhannCartGroups.sameSelection(candidate, item); }).length !== 1 ||
              before.items.some(function(previous) { return previous !== item && previous.key === matches[0].key; })) return false;
          line = matches[0];
        }
        if (matchedKeys[line.key]) return false;
        matchedKeys[line.key] = true;
        return true;
      });
      if (!previousUnchanged) return null;
      var additionsMatch = receipt.every(function(item) {
        if (!item || typeof item.key !== 'string' || allKeys[item.key] || matchedKeys[item.key]) return false;
        allKeys[item.key] = true;
        var props = item.properties || {};
        var field = props._mekhann_pilot_token ? '_mekhann_pilot_token' : '_mekhann_fitting_group';
        var tag = props[field];
        if (typeof tag !== 'string' || !tag || before.items.some(function(line) { return (line.properties || {})[field] === tag; })) return false;
        if (!sameLine(cart.items.find(function(line) { return line.key === item.key; }), item)) return false;
        matchedKeys[item.key] = true;
        return true;
      });
      if (!additionsMatch || !canUse()) return null;
      snapshotIdentities.set(cart, token);
      return carry(response, cart);
    } catch (ignore) { return null; }
  }
  return {prepare: prepare, context: context, markup: markup, carry: carry, fromAdd: fromAdd, priorToken: priorToken,
    performanceRevision: 'V2.34-HAR1-2026-09-19',
    thumbnailRevision: 'V2.34-THUMB1-2026-09-19',
    behaviourRevision: 'V2.34-QTY1-2026-09-20',
    addPerformanceRevision: 'V2.35-ADD1-2026-09-22',
    cartPresentationRevision: 'V2.35-CART2-2026-09-22'};
})();

  /* MEKHANN_CART_GROUPS_START */
/* V2.22-MULTI-CARRIER-2026-09-07 selection grouping contract. Loaded inside theme.js before CartForm. */
; (function (theme) {
  'use strict';
  var queue = Promise.resolve();
  var pendingCount = 0;
  var uiOperations = [];
  var MAX_CHANGES = 20;

  function properties(value) {
    if (!value || typeof value !== 'object') return [];
    var pairs = Array.isArray(value) ? value : Object.keys(value).map(function (key) {
      return [key, value[key]];
    });
    return pairs.map(function (pair) {
      return [String(pair[0]), pair[1] == null ? '' : String(pair[1])];
    }).sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0; });
  }

  function descriptor(item) {
    item = item || {};
    if (Object.prototype.hasOwnProperty.call(item, 'variantId')) {
      return {
        variantId: Number(item.variantId), properties: properties(item.properties),
        sellingPlanId: Number(item.sellingPlanId || 0), parentKey: String(item.parentKey || ''),
        originalPrice: Number(item.originalPrice), finalPrice: Number(item.finalPrice),
        uniqueKey: String(item.uniqueKey || '')
      };
    }
    var type = String(item.product_type || '').toLowerCase().replace(/[\s_-]+/g, '');
    var props = item.properties || {};
    var relation = item.parent_relationship;
    var parent = relation && (relation.parent_key || relation.parent && relation.parent.key) || '';
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var positiveDiscount = (item.line_level_discount_allocations || []).some(function (allocation) {
      return Number(allocation.amount) > 0;
    });
    var unique = parent || type === 'shadecarrier' || type === 'shadecarriers' ||
      props._mekhann_addon_type === 'shade_carrier' || positiveDiscount ||
      Number(item.original_price) !== Number(item.final_price) ||
      Number(item.original_line_price) !== Number(item.final_line_price);
    return {
      variantId: Number(item.variant_id || item.id), properties: properties(props),
      sellingPlanId: Number(plan && plan.id || 0), parentKey: String(parent),
      originalPrice: Number(item.original_price), finalPrice: Number(item.final_price),
      uniqueKey: unique ? String(item.key || '') : ''
    };
  }

  function selectionDescriptor(item) {
    var identity = descriptor(item);
    identity.originalPrice = 0;
    identity.finalPrice = 0;
    identity.uniqueKey = '';
    return identity;
  }
  function selectionSignature(item) { return JSON.stringify(selectionDescriptor(item)); }
  function sameSelection(a, b) { return selectionSignature(a) === selectionSignature(b); }
  function selectionMembers(cart, item) {
    return cart && Array.isArray(cart.items) ? cart.items.filter(function(candidate) { return sameSelection(candidate, item); }) : [];
  }
  function signature(item) { return JSON.stringify(descriptor(item)); }
  function equivalent(a, b) {
    if (isDisplay(a) && isDisplay(b)) return displaySignature(a) === displaySignature(b);
    if (isDisplay(a) || isDisplay(b)) {
      var display = isDisplay(a) ? a : b, single = isDisplay(a) ? b : a;
      var current = descriptor(single), captured = display.configuration.identity;
      // A reduction can leave one physical row. Retain focus/error ownership
      // only for an explicitly captured member with the same unit economics.
      return !current.uniqueKey && current.originalPrice === captured.originalPrice && current.finalPrice === captured.finalPrice &&
        display.selections.some(function(selection) { return sameSelection(single, selection); });
    }
    return signature(a) === signature(b);
  }
  function members(cart, item) {
    if (isDisplay(item)) return displayMembers(cart, item);
    return cart && Array.isArray(cart.items) ? cart.items.filter(function (candidate) {
      return equivalent(candidate, item);
    }) : [];
  }
  // Display aggregation never changes the persisted selection or the pilot's
  // rollback identity. A command names every physical selection it displayed.
  function isDisplay(value) { return Boolean(value && value.displayVersion === 1 && value.configuration && Array.isArray(value.selections)); }
  function displaySignature(value) { return JSON.stringify(value.configuration); }
  function displayMembers(cart, value) {
    if (!isDisplay(value) || !cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(function(item) { return value.selections.some(function(selection) { return sameSelection(item, selection); }); });
  }
  function displayConfiguration(cart, parent, liquidProof) {
    if (!cart || !parent || !parent.properties || typeof parent.properties._mekhann_fitting_group !== 'string' || !parent.properties._mekhann_fitting_group ||
        parent.parent_relationship || selectionMembers(cart, parent).length !== 1) return null;
    var info = descriptor(parent), props = parent.properties;
    if (info.uniqueKey || !Number.isSafeInteger(parent.quantity) || parent.quantity < 1 ||
        !Number.isSafeInteger(parent.original_price) || parent.original_price !== parent.final_price ||
        parent.original_line_price !== parent.original_price * parent.quantity || parent.final_line_price !== parent.original_line_price) return null;
    var preference = null, saved;
    try {
      saved = JSON.parse(String((cart.attributes || {})._mekhann_carrier_preferences || 'null'));
      if (saved && (saved.version !== 1 || !saved.selections || Array.isArray(saved.selections) || typeof saved.selections !== 'object')) return null;
      preference = saved && saved.selections[selectionSignature(parent)] || null;
    } catch (ignore) { return null; }
    if ((props._mekhann_grouped_parent != null || props._mekhann_grouped_carrier_id != null) &&
        (props._mekhann_grouped_parent !== 'V1' || !Number.isSafeInteger(Number(props._mekhann_grouped_carrier_id)) || Number(props._mekhann_grouped_carrier_id) < 1)) return null;
    var carrierId = props._mekhann_grouped_parent === 'V1' ? Number(props._mekhann_grouped_carrier_id) : 0;
    var mode = carrierId > 0 ? 'follow' : 'off';
    if (preference) {
      if (!preference.parent || !sameSelection(parent, preference.parent) || preference.suspended || ['off', 'follow'].indexOf(preference.mode) < 0) return null;
      mode = preference.mode;
      if (mode === 'follow') carrierId = Number(preference.chosenCarrierVariantId || carrierId);
      else carrierId = 0;
    }
    if (mode === 'follow' && (!Number.isSafeInteger(carrierId) || carrierId < 1)) return null;
    var children = [], bad = false;
    cart.items.forEach(function(child) {
      var cp = child.properties || {}, linked = false;
      if (cp._mekhann_fitting_group === props._mekhann_fitting_group && child !== parent) linked = true;
      if (cp._mekhann_parent_group) {
        try { if (sameSelection(JSON.parse(cp._mekhann_parent_group), parent)) linked = true; } catch (ignore) { if (linked) bad = true; }
      }
      if (!linked) return;
      var allocations = child.line_level_discount_allocations || [], allocation = allocations[0];
      var application = allocation && allocation.discount_application;
      if (cp._mekhann_addon_type !== 'shade_carrier' || cp._mekhann_carrier_pilot !== 'V2.19.3' ||
          Number(cp._mekhann_parent_variant_id) !== info.variantId || !cp._mekhann_pilot_token ||
          child.parent_relationship || !Number.isSafeInteger(child.quantity) || child.quantity < 1 ||
          !Number.isSafeInteger(child.original_line_price) || child.original_line_price <= 0 || child.final_line_price !== 0 ||
          allocations.length !== 1 || !application || allocation.amount !== child.original_line_price ||
          (!liquidProof && application.type !== 'automatic') || (liquidProof && application.type && application.type !== 'automatic')) bad = true;
      children.push(child);
    });
    if (bad || mode === 'off' && children.length || mode === 'follow' &&
        (!children.length || children.some(function(child) { return Number(child.variant_id) !== carrierId; }) || quantity(children) !== parent.quantity)) return null;
    info.properties = info.properties.filter(function(pair) { return ['_mekhann_fitting_group', '_mekhann_grouped_parent', '_mekhann_grouped_carrier_id'].indexOf(pair[0]) < 0; });
    if (typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency)) return null;
    return {currency:cart.currency, identity: info, carrierMode: mode, carrierVariantId: carrierId};
  }
  function displayChildState(cart, parent) {
    return JSON.stringify(cart.items.filter(function(child) {
      var props = child.properties || {};
      if (child === parent || props._mekhann_addon_type !== 'shade_carrier') return false;
      if (props._mekhann_fitting_group === parent.properties._mekhann_fitting_group) return true;
      try { return props._mekhann_parent_group && sameSelection(JSON.parse(props._mekhann_parent_group), parent); } catch (ignore) { return false; }
    }).map(function(child) {
      return {variant:Number(child.variant_id), quantity:child.quantity, properties:properties(child.properties),
        original:child.original_line_price, final:child.final_line_price,
        allocations:(child.line_level_discount_allocations || []).map(function(allocation) {
          return {amount:allocation.amount, title:allocation.discount_application && allocation.discount_application.title || ''};
        })};
    }).sort(function(a,b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }));
  }
  function decodedDisplayCart(proof) {
    if (!proof || proof.version !== 1 || !Array.isArray(proof.items)) return null;
    function raw(value) {
      var map = {'&amp;':'&', '&lt;':'<', '&gt;':'>', '&quot;':'"', '&#39;':"'"};
      return String(value).replace(/&(?:amp|lt|gt|quot|#39);/g, function(entity) { return map[entity]; });
    }
    function map(value) {
      var result = Object.create(null);
      Object.keys(value || {}).forEach(function(key) { result[raw(key)] = raw(value[key]); });
      return result;
    }
    var cart = {currency:proof.currency, attributes: map(proof.attributes), items: []};
    cart.items = proof.items.map(function(item) {
      var line = Object.assign({}, item, {properties: map(item.properties)});
      line.original_price = item.original_line_price / item.quantity;
      line.final_price = item.final_line_price / item.quantity;
      return line;
    });
    return cart;
  }
  function aggregateDisplay(items, proof) {
    // Operate before attaching the new tree: there is still one owned DOM
    // replacement and the full physical cart proof remains byte-for-byte intact.
    var cart = decodedDisplayCart(proof);
    if (!cart || !items) return 0;
    var buckets = Object.create(null), offers = Array.prototype.slice.call(items.querySelectorAll('[data-mekhann-carrier-offer]'));
    Array.prototype.forEach.call(items.querySelectorAll('[data-mekhann-display-eligible="true"]'), function(row) {
      if (row.dataset.mekhannDisplayAggregated) return;
      var parent = cart.items.find(function(item) { return item.key === row.dataset.key; });
      var config = displayConfiguration(cart, parent, true);
      var offer = offers.find(function(node) { return node.dataset.parentLineKey === row.dataset.key; });
      var input = row.querySelector('.js-qty__num'), price = row.querySelector('.cart__price');
      if (!config || !input || !price || row.querySelector('.cart__price--strikethrough, .product__unit-price') ||
          Number(row.dataset.mekhannGroupCount) !== 1 || Number(row.dataset.mekhannGroupQuantity) !== parent.quantity) return;
      // The server's allow-list and full line-discount proof must confirm the
      // exact current carrier. Properties or a zero price alone are not proof.
      if (config.carrierMode === 'follow' && (!offer || offer.dataset.carrierProven !== 'true' ||
          Number(offer.dataset.carrierVariantId) !== config.carrierVariantId || Number(offer.dataset.carrierSelected) !== parent.quantity ||
          !offer.querySelector('[data-mekhann-carrier-summary-quantity]'))) return;
      if (config.carrierMode === 'off' && offer && Number(offer.dataset.carrierSelected) !== 0) return;
      var signature = JSON.stringify(config);
      (buckets[signature] || (buckets[signature] = [])).push({row:row, parent:parent, config:config, offer:offer, input:input, price:price});
    });
    var merged = 0;
    Object.keys(buckets).forEach(function(key) {
      var entries = buckets[key];
      if (entries.length < 2) return;
      var first = entries[0], total = quantity(entries.map(function(entry) { return entry.parent; }));
      var hasMax = entries.every(function(entry) { return entry.input.hasAttribute('max'); });
      if (!hasMax && entries.some(function(entry) { return entry.input.hasAttribute('max'); })) return;
      var maxima = entries.map(function(entry) { return Number(entry.input.getAttribute('max')) + total - entry.parent.quantity; });
      if (hasMax && (maxima.some(function(max) { return !Number.isSafeInteger(max) || max < total; }) || maxima.some(function(max) { return max !== maxima[0]; }))) return;
      var identity = {displayVersion:1, configuration:first.config, selections:entries.map(function(entry) { return selectionDescriptor(entry.parent); }), childStates:entries.map(function(entry) { return displayChildState(cart, entry.parent); }), quantity:total};
      first.row.dataset.mekhannCartGroup = JSON.stringify(identity);
      first.row.dataset.mekhannGroupQuantity = String(total);
      first.row.dataset.mekhannGroupCount = String(entries.length);
      first.row.dataset.mekhannDisplayAggregated = 'true';
      first.input.value = String(total); first.input.setAttribute('value', String(total));
      if (hasMax) first.input.setAttribute('max', String(maxima[0]));
      first.price.innerHTML = theme.Currency.formatMoney(entries.reduce(function(sum, entry) { return sum + entry.parent.final_line_price; }, 0), theme.settings.moneyFormat);
      if (first.offer && first.config.carrierMode === 'follow') {
        var label = first.offer.querySelector('[data-mekhann-carrier-summary-quantity]');
        if (label) label.textContent = '×' + total;
      }
      entries.slice(1).forEach(function(entry) {
        // Remove duplicate product controls, retain each read-only engine host
        // and its live error/status region. No interactive controls are hidden.
        if (entry.offer) {
          var summary = entry.offer.querySelector('[data-mekhann-carrier-summary]');
          if (summary) summary.remove();
          entry.offer.classList.add('mekhann-carrier-inline--status-only');
          if (first.offer) first.offer.insertAdjacentElement('afterend', entry.offer);
        }
        entry.row.remove();
      });
      merged += entries.length - 1;
    });
    return merged;
  }
  function stabilizeDisplay(items, previous) {
    // MC-STABILITY-01: physical Shopify line order is not display-group order.
    // Work only on the detached, verified render. Reuse the existing exact
    // identity contract; this is presentation state, never cart/stock proof.
    function blocks(container) {
      if (!container) return [];
      var children = Array.prototype.slice.call(container.children);
      // A visible native/failed-proof child must retain its server adjacency.
      // Hidden physical children remain intact inside their existing wrapper.
      if (children.some(function(node) { return node.matches('[data-parent-key]'); })) return [];
      return children.filter(function(node) { return node.matches('[data-mekhann-cart-group]'); }).map(function(row) {
        var identity = null, nodes = [row], next = row.nextElementSibling;
        try { identity = JSON.parse(row.dataset.mekhannCartGroup); } catch (ignore) {}
        while (next && next.matches('[data-mekhann-carrier-offer], [data-mekhann-carrier-physical-lines]')) {
          nodes.push(next);
          next = next.nextElementSibling;
        }
        return {row: row, identity: identity, nodes: nodes};
      });
    }
    var before = blocks(previous && (previous.querySelector('.cart__items') || previous));
    var after = blocks(items);
    if (before.length < 2 || after.length < 2) return;
    var matches = after.map(function(block) {
      if (!block.identity) return [];
      return before.reduce(function(indices, old, index) {
        try {
          if (old.identity && equivalent(old.identity, block.identity)) indices.push(index);
        } catch (ignore) {} // Unknown identity keeps server order, never blocks a render.
        return indices;
      }, []);
    });
    var retained = after.filter(function(block, index) {
      var candidates = matches[index];
      if (candidates.length !== 1 || matches.filter(function(other) {
        return other.indexOf(candidates[0]) !== -1;
      }).length !== 1) return false;
      block.priorIndex = candidates[0];
      return true;
    });
    var ordered = retained.slice().sort(function(a, b) { return a.priorIndex - b.priorIndex; });
    if (retained.every(function(block, index) { return block === ordered[index]; })) return;
    // Mark only matched slots. New/ambiguous rows keep their server positions;
    // product controls and their offer/status hosts move as one block.
    var slots = retained.map(function(block) {
      var slot = document.createComment('mekhann-display-slot');
      items.insertBefore(slot, block.row);
      return slot;
    });
    ordered.forEach(function(block, index) {
      block.nodes.forEach(function(node) { items.insertBefore(node, slots[index]); });
    });
    slots.forEach(function(slot) { slot.remove(); });
  }
  function changeDisplayQuantity(identity, target, guard) {
    if (!isDisplay(identity) || !Number.isSafeInteger(target) || target < 0 ||
        !Number.isSafeInteger(identity.quantity) || identity.quantity < 1 || identity.selections.length < 2 || !Array.isArray(identity.childStates) || identity.childStates.length !== identity.selections.length) return Promise.reject(new Error('Please refresh your bag before updating this selection.'));
    return run(async function() {
      if (guard) guard(false);
      var cart = await read();
      var physical = displayMembers(cart, identity);
      var seen = Object.create(null);
      var currentEquivalent = cart.items.filter(function(parent) { var config = displayConfiguration(cart, parent, true); return config && JSON.stringify(config) === displaySignature(identity); });
      if (currentEquivalent.length !== physical.length || physical.length !== identity.selections.length || quantity(physical) !== identity.quantity || physical.some(function(parent) {
        var key = selectionSignature(parent), config = displayConfiguration(cart, parent, true);
        var selectedIndex = identity.selections.findIndex(function(selection) { return sameSelection(parent, selection); });
        // Raw cart.js can omit discount type. Omission is accepted only for
        // the exact physical child proof captured in the verified render; an
        // explicit conflicting type is rejected. The pilot still owns final
        // price/allow-list verification after mutation.
        if (seen[key] || !config || JSON.stringify(config) !== displaySignature(identity) || selectedIndex < 0 ||
            identity.childStates[selectedIndex] !== displayChildState(cart, parent)) return true;
        seen[key] = true; return false;
      })) throw new Error('Your bag has changed. Please check the quantity and try again.');
      var delta = target - identity.quantity;
      if (!delta) return cart;
      // Store absolute per-selection targets. After each write resolve current
      // line keys anew. An uncertain write is never replayed or reassigned.
      var plans = physical.map(function(parent) { return {selection:selectionDescriptor(parent), economics:descriptor(parent), before:parent.quantity, target:parent.quantity}; });
      if (delta > 0) plans[0].target += delta;
      else for (var i = 0; i < plans.length && delta < 0; i += 1) { var amount = Math.min(plans[i].target, -delta); plans[i].target -= amount; delta += amount; }
      for (var index = 0; index < plans.length; index += 1) {
        var plan = plans[index];
        if (plan.target === plan.before) continue;
        if (guard) guard(false);
        var membersNow = selectionMembers(cart, plan.selection);
        if (membersNow.length !== 1 || membersNow[0].quantity !== plan.before) throw new Error('Your bag has changed. Please refresh before continuing.');
        if (guard) guard(true);
        cart = await change(membersNow[0].key, plan.target);
        var matches = selectionMembers(cart, plan.selection);
        if (quantity(matches) !== plan.target || matches.length !== (plan.target ? 1 : 0)) throw new Error('The requested quantity could not be confirmed. Please check your bag.');
        // Every remaining parent must still represent the captured command.
        if (plans.some(function(other, n) {
          var expected = n <= index ? other.target : other.before;
          var rows = selectionMembers(cart, other.selection);
          return quantity(rows) !== expected || rows.length !== (expected ? 1 : 0) || rows.some(function(row) {
            return !equivalent(row, other.economics) || row.original_line_price !== row.original_price * row.quantity || row.final_line_price !== row.original_line_price;
          });
        })) throw new Error('Your bag changed while it was updating. Please check your bag.');
      }
      return cart;
    });
  }

  function quantity(items) {
    return items.reduce(function (sum, item) { return sum + Number(item.quantity); }, 0);
  }
  var activeTask = null;
  function run(task) {
    pendingCount += 1;
    var operation = queue.catch(function () {}).then(function (value) { activeTask = task; return task(value); });
    queue = operation.then(function (value) {
      if (activeTask === task) activeTask = null;
      pendingCount -= 1; return value;
    }, function (error) {
      if (activeTask === task) activeTask = null;
      pendingCount -= 1; throw error;
    });
    // A queue tail must never create an unhandled rejection when an owner catches its operation.
    queue.catch(function () {});
    return queue;
  }
  function request(url, body) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (controller) options.signal = controller.signal;
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
      options = theme.mekhannCartSections.prepare(options);
    }
    var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.request(url, options);
    // A real deadline also covers ignored abort signals and a stalled body read.
    // Timing out a POST does not prove Shopify did not process the mutation.
    return new Promise(function(resolve, reject) {
      var done = false;
      var responseStatus = null;
      function finish(error, cart) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        if (traceEnd) traceEnd(error ? 'error' : 'complete', responseStatus);
        if (error) {
          // A sections-related 400 can follow a committed Shopify mutation.
          if (body && ([400, 404, 422].indexOf(responseStatus) === -1 || options.mekhannBundled && responseStatus === 400)) error.mekhannMutationUnknown = true;
          reject(error);
        } else resolve(cart);
      }
      var timer = setTimeout(function() {
        finish(new Error('We could not confirm the update to your bag. Please refresh your bag before continuing.'));
        if (controller) controller.abort();
      }, 15000);
      Promise.resolve().then(function() { return fetch(url, options); }).then(function(response) {
        responseStatus = response.status;
        return response.json().then(function(cart) {
          if (!response.ok || !cart || !Array.isArray(cart.items)) {
            var error = new Error(cart && (cart.description || cart.message) || 'Your bag could not be updated. Please try again.');
            error.status = response.status;
            throw error;
          }
          return cart;
        });
      }).then(function(cart) { finish(null, cart); }, function(error) { finish(error); });
    });
  }
  function read() {
    return request(theme.routes.cart + (theme.routes.cart.indexOf('?') < 0 ? '?' : '&') + 't=' + Date.now());
  }
  function change(key, count) {
    return request(theme.routes.cartChange + (theme.routes.cartChange.indexOf('?') < 0 ? '?' : '&') + 't=' + Date.now(), { id: key, quantity: count });
  }
  function changeQuantity(identity, target, guard, expectedQuantity) {
    if (isDisplay(identity)) return changeDisplayQuantity(identity, target, guard);
    var expected = descriptor(identity);
    if (!Number.isSafeInteger(target) || target < 0 || !expected.variantId) {
      return Promise.reject(new Error('Please check the quantity in your bag.'));
    }
    return run(function () {
      if (guard) guard(false);
      var attempts = 0;
      var lastCount = null;
      function step(confirmedCart) {
        // Always resolve the next current Shopify key after the previous mutation.
        // change.js already returns the full cart. Reuse only this operation's
        // response and re-run every grouping/progress check before another write.
        return (confirmedCart ? Promise.resolve(confirmedCart) : read()).then(function (cart) {
          if (guard) guard(false);
          var lines = members(cart, expected);
          var current = quantity(lines);
          // An accepted quantity intent may wait for a metadata save. Do not
          // overwrite a quantity changed elsewhere while that intent waited.
          if (!attempts && Number.isSafeInteger(expectedQuantity) && current !== expectedQuantity) {
            throw new Error('Your bag has changed. Please check the quantity and try again.');
          }
          var selectionChanged = !lines.length && selectionMembers(cart, expected).length > 0;
          if (current === target && !selectionChanged) return cart;
          if (selectionChanged || !lines.length || attempts >= MAX_CHANGES || lastCount === current) {
            var error = new Error('Your bag has changed. Please check the quantity and try again.');
            error.cart = cart;
            throw error;
          }
          // Preserve the zero-allocation qualifying line when decreasing where possible.
          var line = lines.slice().sort(function (a, b) {
            return (a.line_level_discount_allocations || []).length - (b.line_level_discount_allocations || []).length;
          })[0];
          var delta = target - current;
          var next = delta > 0 ? Number(line.quantity) + delta : Math.max(0, Number(line.quantity) + delta);
          attempts += 1;
          lastCount = current;
          if (guard) guard(true);
          return change(line.key, next).then(function (updated) {
            // A deliberately ungrouped discounted/native row is one real line.
            // Shopify may change its key/pricing; never repeat against a guessed replacement.
            if (expected.uniqueKey) return updated;
            return step(updated);
          });
        });
      }
      return step();
    });
  }

  function hold() {
    var release;
    var operation = new Promise(function(resolve) { release = resolve; });
    uiOperations.push(operation);
    return function() {
      uiOperations = uiOperations.filter(function(pending) { return pending !== operation; });
      release();
    };
  }
  theme.mekhannCartGroups = {
    descriptor: descriptor, signature: signature, equivalent: equivalent, members: members,
    aggregateDisplay: aggregateDisplay, stabilizeDisplay: stabilizeDisplay, displayConfiguration: displayConfiguration, displayChildState: displayChildState, isDisplay: isDisplay,
    selectionDescriptor: selectionDescriptor, selectionSignature: selectionSignature,
    sameSelection: sameSelection, selectionMembers: selectionMembers,
    changeQuantity: changeQuantity, read: read, run: run, hold: hold,
    pending: function () { return pendingCount > 0 || uiOperations.length > 0; },
    onlyPendingTaskIs: function (task) { return typeof task === 'function' && activeTask === task && pendingCount === 1 && uiOperations.length === 0; },
    whenIdle: function () { return Promise.all([queue.catch(function () {})].concat(uiOperations)); }
  };
})(theme);

  /* MEKHANN_CART_GROUPS_END */

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var instances = [];
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
  
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };

    function visibleProductRows(products) {
      return Array.prototype.filter.call(products.querySelectorAll('[data-mekhann-cart-group]'), function(row) {
        // Hidden physical carrier rows are proof, not keyboard destinations.
        return !row.closest('[hidden]');
      });
    }
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      if (form.__mekhannCartForm && !form.__mekhannCartForm.destroyed) return form.__mekhannCartForm;
      instances.slice().forEach(function(instance) { if (!instance.form.isConnected) instance.destroy(); });
      form.__mekhannCartForm = this;
      instances.push(this);
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
  
      this.cartItemsUpdated = false;
      this.quantityFeedbackSession = 0;
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        var displayProof = this.products && this.products.querySelector('[data-mekhann-initial-display-proof]');
        if (displayProof) {
          try { theme.mekhannCartGroups.aggregateDisplay(this.products, JSON.parse(displayProof.textContent)); } catch (ignore) {}
          displayProof.remove();
        }
        this.initQtySelectors();
        this.initSummaryLayout();

        this.quantityListener = this.quantityChanged.bind(this);
        document.addEventListener('cart:quantity' + this.namespace, this.quantityListener);
        this.removeListener = function(event) {
          var control = event.target.closest('[data-mekhann-group-remove]');
          if (!control || !this.form.contains(control)) return;
          event.preventDefault();
          var row = control.closest('[data-mekhann-cart-group]');
          if (row) this.quantityChanged({ detail: [row.dataset.key, 0, row.querySelector('.js-qty__wrapper') || row], removeControl: control });
        }.bind(this);
        this.form.addEventListener('click', this.removeListener);

        this.submitListener = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.submitListener);
  
        if (this.noteInput && !this.noteInput.closest('[data-mekhann-cart-extras]')) {
          this.noteListener = function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          };
          this.noteInput.addEventListener('change', this.noteListener);
        }
  
        // Dev-friendly way to build the cart
        this.buildListener = function(event) {
          if (this.destroyed || !this.form.isConnected) return;
          var operation = this.buildCart({ renderToken: event.detail && event.detail.renderToken, markup: event.detail && event.detail.markup });
          // V2.26.1: mutation owners wait for every mounted cart surface.
          if (event.detail && Array.isArray(event.detail.renderPromises)) {
            event.detail.renderPromises.push(operation);
          }
        }.bind(this);
        document.addEventListener('cart:build', this.buildListener);
      },

      destroy: function() {
        if (this.destroyed) return;
        this.destroyed = true;
        if (this.summaryLayoutDispose) this.summaryLayoutDispose();
        this.supersedeBuild();
        document.removeEventListener('cart:quantity' + this.namespace, this.quantityListener);
        document.removeEventListener('cart:build', this.buildListener);
        this.form.removeEventListener('click', this.removeListener);
        this.form.removeEventListener('submit', this.submitListener);
        if (this.noteInput && this.noteListener) this.noteInput.removeEventListener('change', this.noteListener);
        this.clearQuantityLimitFeedback();
        if (this.form.__mekhannCartForm === this) delete this.form.__mekhannCartForm;
        instances = instances.filter(function(instance) { return instance !== this; }.bind(this));
      },
  
      initSummaryLayout: function() {
        if (this.location !== 'page') return;
        var summary = this.form.querySelector('.mekhann-cart-page__summary');
        if (!summary || !window.ResizeObserver) return;
        var owner = this;
        var form = this.form;
        var header = document.getElementById('SiteHeader');
        var wrapper = document.getElementById('HeaderWrapper');
        var frame = null;
        var disposed = false;
        var disposers = [];
        var subtotalHome = form.querySelector('[data-mekhann-page-subtotal-home]');
        var checkoutHome = form.querySelector('[data-mekhann-page-checkout-home]');
        var action = form.querySelector('[data-mekhann-page-checkout-action]');
        var dock = form.querySelector('[data-mekhann-page-checkout-dock]');
        var subtotalSlot = dock && dock.querySelector('[data-mekhann-page-subtotal-slot]');
        var checkoutSlot = dock && dock.querySelector('[data-mekhann-page-checkout-slot]');
        var subtotal = this.subtotal && this.subtotal.closest('.cart__item-sub');
        var checkout = this.submitBtn;
        var active = false;
        var blockedSignature = null;
        var homeStyles = null;
        var supportsDock = subtotalHome && checkoutHome && action && dock && subtotalSlot && checkoutSlot &&
          subtotal && checkout && subtotalHome.contains(subtotal) && checkoutHome.contains(action) && action.contains(checkout) &&
          checkout.form === form && dock.closest('form') === form &&
          window.getComputedStyle(form).getPropertyValue('--mekhann-page-dock-supported').trim() === '1';

        function listen(target, name, listener, options) {
          target.addEventListener(name, listener, options);
          disposers.push(function() { target.removeEventListener(name, listener, options); });
        }
        function setDock(next) {
          if (!supportsDock || active === next) return;
          var focused = document.activeElement;
          var movingFocus = focused && (action.contains(focused) || subtotal.contains(focused));
          active = next;
          if (next) {
            homeStyles = [subtotalHome, checkoutHome].map(function(home) {
              var prior = { node: home, height: home.style.height, boxSizing: home.style.boxSizing };
              home.style.height = home.getBoundingClientRect().height + 'px';
              home.style.boxSizing = 'border-box';
              return prior;
            });
            subtotalSlot.appendChild(subtotal);
            // The action wrapper carries the one native button and any recovery
            // control inserted beside it by the existing cart owner.
            checkoutSlot.appendChild(action);
            dock.hidden = false;
            form.setAttribute('data-mekhann-page-dock-active', '');
          } else {
            form.removeAttribute('data-mekhann-page-dock-active');
            subtotalHome.appendChild(subtotal);
            checkoutHome.appendChild(action);
            dock.hidden = true;
            homeStyles.forEach(function(prior) {
              prior.node.style.height = prior.height;
              prior.node.style.boxSizing = prior.boxSizing;
            });
            homeStyles = null;
            form.style.removeProperty('--mekhann-page-dock-height');
            if (document.documentElement.__mekhannPageDockOwner === owner) {
              document.documentElement.style.removeProperty('--mekhann-page-dock-clearance');
              delete document.documentElement.__mekhannPageDockOwner;
            }
          }
          if (movingFocus && document.activeElement !== focused && focused.isConnected) focused.focus({ preventScroll: true });
        }
        function layoutSignature(viewportHeight) {
          var totalBox = subtotalHome.getBoundingClientRect();
          var actionBox = checkoutHome.getBoundingClientRect();
          return [window.innerWidth, window.innerHeight, viewportHeight, totalBox.width, totalBox.height,
            actionBox.width, actionBox.height, subtotal.textContent, checkout.textContent].join('|');
        }
        var update = function() {
          frame = null;
          if (disposed || this.destroyed || !form.isConnected) { setDock(false); return; }
          var top = 24;
          if (header && header.dataset.sticky === 'true' && theme.config && theme.config.stickyHeader) {
            top += header.offsetHeight;
            if (wrapper) top += Math.max(0, parseFloat(window.getComputedStyle(wrapper).top) || 0);
          }
          if (supportsDock) {
            var viewport = window.visualViewport;
            var viewportHeight = viewport ? viewport.height : window.innerHeight;
            var viewportBottom = (viewport ? viewport.offsetTop : 0) + viewportHeight;
            var focused = document.activeElement;
            var editing = focused && focused.matches && focused.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]):not([type="button"]), [contenteditable]:not([contenteditable="false"])');
            var termsAttention = this.termsCheckbox && !this.termsCheckbox.checked && focused === this.termsCheckbox;
            var overlay = document.documentElement.classList.contains('js-drawer-open') ||
              document.documentElement.classList.contains('modal-open') ||
              Boolean(document.querySelector('.drawer--is-open, .modal--is-active, .pswp--open, dialog[open]'));
            var sourceBox = checkoutHome.getBoundingClientRect();
            var eligible = window.innerWidth <= 999 && window.innerHeight > 600 && viewportHeight > 600 &&
              (!viewport || viewport.height >= window.innerHeight - 100 && Math.abs((viewport.scale || 1) - 1) < 0.01) &&
              !editing && !termsAttention && !overlay && !form.hidden && form.getClientRects().length > 0 &&
              !form.closest('[hidden], [inert]') && !form.querySelector('[data-mekhann-native-recovery]') &&
              sourceBox.height > 0 && sourceBox.bottom > viewportBottom - 8;
            if (!eligible) setDock(false);
            else if (active || layoutSignature(viewportHeight) !== blockedSignature) {
              setDock(true);
              var dockHeight = dock.getBoundingClientRect().height;
              var overflowing = [dock, subtotalSlot, action].some(function(node) {
                return node.clientWidth > 0 && node.scrollWidth > node.clientWidth + 1;
              });
              if (!dockHeight || dockHeight > viewportHeight * 0.25 || overflowing) {
                setDock(false);
                // A hidden dock's ResizeObserver callback must not repeatedly
                // retry the same oversized layout and move the page each frame.
                blockedSignature = layoutSignature(viewportHeight);
              } else {
                blockedSignature = null;
                var heightValue = Math.ceil(dockHeight) + 'px';
                if (form.style.getPropertyValue('--mekhann-page-dock-height') !== heightValue) form.style.setProperty('--mekhann-page-dock-height', heightValue);
                document.documentElement.__mekhannPageDockOwner = owner;
                if (document.documentElement.style.getPropertyValue('--mekhann-page-dock-clearance') !== heightValue) document.documentElement.style.setProperty('--mekhann-page-dock-clearance', heightValue);
              }
            }
          }
          var height = summary.getBoundingClientRect().height;
          var fits = window.innerWidth >= 1000 && !form.hidden && height > 0 && height <= window.innerHeight - top - 24;
          summary.style.setProperty('--mekhann-summary-top', top + 'px');
          if (summary.hasAttribute('data-mekhann-summary-sticky') !== fits) summary.toggleAttribute('data-mekhann-summary-sticky', fits);
        }.bind(this);
        var schedule = function() { if (!disposed && frame === null) frame = window.requestAnimationFrame(update); };
        var observer = new window.ResizeObserver(schedule);
        observer.observe(summary);
        if (this.products) observer.observe(this.products.closest('.mekhann-cart-page__products') || this.products);
        if (header) observer.observe(header);
        if (wrapper) observer.observe(wrapper);
        if (supportsDock) {
          observer.observe(dock);
          observer.observe(action);
          listen(window, 'scroll', schedule, { passive: true });
          listen(document, 'focusin', schedule);
          listen(document, 'focusout', schedule);
          listen(document, 'click', schedule, { passive: true });
          listen(document, 'close', schedule, true);
          ['cart:rendered', 'drawerOpen', 'drawerClose.CartDrawer', 'drawerClose.FilterDrawer', 'modalOpen', 'modalClose'].forEach(function(name) { listen(document, name, schedule); });
          listen(form, 'change', schedule);
          listen(form, 'click', function(event) {
            if (!active || !checkout.contains(event.target) || !owner.termsCheckbox || owner.termsCheckbox.checked) return;
            setDock(false);
            owner.termsCheckbox.focus();
          });
          if (window.visualViewport) {
            listen(window.visualViewport, 'resize', schedule);
            listen(window.visualViewport, 'scroll', schedule, { passive: true });
          }
        }
        listen(window, 'resize', schedule);
        this.summaryLayoutDispose = function() {
          if (disposed) return;
          disposed = true;
          observer.disconnect();
          disposers.forEach(function(dispose) { dispose(); });
          if (frame !== null) window.cancelAnimationFrame(frame);
          frame = null;
          setDock(false);
          summary.removeAttribute('data-mekhann-summary-sticky');
        };
        schedule();
      },

      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        if (this.destroyed || !this.form.isConnected) return;
        if (theme.mekhannCartGroups.pending() || this.form.getAttribute('aria-busy') === 'true' || this.form.hasAttribute('data-mekhann-cart-unverified')) {
          evt.preventDefault();
          if (this.form.hasAttribute('data-mekhann-cart-unverified')) this.showCartError('Please refresh your bag before checking out.');
          if (this.submitBtn) this.submitBtn.classList.remove(classes.btnLoading);
          return false;
        }
        if (this.submitBtn) this.submitBtn.classList.add(classes.btnLoading);
  
        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.
  
          Error is handled in the quantityChanged method
  
          For Expanse/Fetch quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.
  
          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch when using quick add
        */
  
        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }
  
        if (this.termsCheckbox) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(text) {
        var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.start('html.products.parse');
        const html = document.createElement('div');
        html.innerHTML = text;
        if (traceEnd) traceEnd();
        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts')
        }
      },
  
      supersedeBuild: function() {
        // A mutation owns the next confirmed render. An older read must not
        // replace its DOM or surface a stale transport error while it runs.
        // Replace the promise as well as the generation: the stale callback
        // returns cartBuildOperation, so retaining itself would create a cycle.
        this.cartBuildGeneration = (this.cartBuildGeneration || 0) + 1;
        this.cartBuildOperation = Promise.resolve(false);
      },

      buildCart: function(options) {
        options = options || {};
        if (this.destroyed || !this.form.isConnected) return Promise.resolve(false);
        var generation = (this.cartBuildGeneration || 0) + 1;
        this.cartBuildGeneration = generation;
        var supplied = options.markup;
        var engine = window.MekhannCarrierPilotV2193;
        var accepted = false;
        var acceptedMarkup = null;
        if (typeof supplied === 'string' && supplied && options.renderToken && engine && typeof engine.canCommitRender === 'function') {
          // Validate before touching the DOM. A missing/null/stale Shopify section
          // takes the existing GET path; no mutation is ever retried here.
          try {
            var parsed = this._parseProductHTML(supplied);
            var proof = parsed.items && parsed.items.querySelector('[data-mekhann-render-cart-proof]');
            accepted = Boolean(proof && engine.canCommitRender(options.renderToken, JSON.parse(proof.textContent)));
            if (accepted) acceptedMarkup = parsed;
          } catch (ignore) {}
        }
        if (!accepted && theme.mekhannCartTrace) theme.mekhannCartTrace.mark(supplied ? 'html.fallback.rejected' : 'html.fallback.missing');
        var operation = (accepted ? Promise.resolve(supplied) : theme.cart.getCartProductMarkup()).then(function(text) {
          if (this.destroyed || !this.form.isConnected) return false;
          if (generation !== this.cartBuildGeneration) return this.cartBuildOperation;
          if (typeof text !== 'string' || !text) throw new Error('Your bag could not be refreshed. Please try again.');
          // Keep parsed nodes inside this build only. cartMarkup still checks
          // the current proof after this asynchronous boundary before commit.
          this.cartMarkup(text, options, acceptedMarkup);
          // A rendered listener can synchronously request another generation.
          if (generation !== this.cartBuildGeneration) return this.cartBuildOperation;
          var refreshError = this.cartRefreshError;
          if (refreshError) {
            if (refreshError.ownsVerificationLock && !this.cartError) {
              this.form.removeAttribute('data-mekhann-cart-unverified');
            }
            // MC_NATIVE_STATUS_OWNER_01_2026_10_17: the recovery link is part
            // of the presentation, not its identity. Clear only this failed
            // build's exact notice; a later quantity/error owner must survive.
            var presentation = refreshError.presentation;
            if (presentation && this.form.contains(presentation.node) &&
                presentation.node.mekhannCartErrorPresentation === presentation) {
              presentation.node.textContent = '';
              presentation.node.classList.add('hide');
              delete presentation.node.mekhannCartErrorPresentation;
            }
            this.cartRefreshError = null;
          }
          return true;
        }.bind(this)).catch(function(error) {
          // An older read can fail after a newer build has already succeeded.
          // Only the current generation owns this form's error/checkout state.
          if (this.destroyed || !this.form.isConnected) return false;
          if (generation !== this.cartBuildGeneration) return this.cartBuildOperation;
          var message = error && error.message || 'Your bag could not be refreshed. Please try again.';
          this.cartRefreshError = {
            message: message,
            ownsVerificationLock: Boolean(this.cartRefreshError && this.cartRefreshError.ownsVerificationLock) || !this.form.hasAttribute('data-mekhann-cart-unverified')
          };
          this.form.setAttribute('data-mekhann-cart-unverified', 'true');
          this.cartRefreshError.presentation = this.showCartError(message);
          return false;
        }.bind(this));
        this.cartBuildOperation = operation;
        return operation;
      },
  
      cartMarkup: function(text, options, parsedMarkup) {
        options = options || {};
        var previousFocus = document.activeElement;
        var focusedRow = previousFocus && this.products.contains(previousFocus) && previousFocus.closest('[data-mekhann-cart-group]');
        var focusedIdentity = null;
        var focusedIndex = -1;
        var focusControl = null;
        if (focusedRow) {
          try { focusedIdentity = JSON.parse(focusedRow.dataset.mekhannCartGroup); } catch (ignore) {}
          focusedIndex = visibleProductRows(this.products).indexOf(focusedRow);
          ['.js-qty__adjust--plus', '.js-qty__adjust--minus', '.js-qty__num', '[data-mekhann-group-remove]', 'a[href]'].some(function(selector) {
            if (!previousFocus.matches(selector)) return false;
            focusControl = selector;
            return true;
          });
        }
        var markup = parsedMarkup || this._parseProductHTML(text);
        var items = markup.items;
        if (!items) throw new Error('Your bag could not be refreshed. Please try again.');
        var proofNode = items.querySelector('[data-mekhann-render-cart-proof]');
        var renderedCart = null;
        if (proofNode) {
          try { renderedCart = JSON.parse(proofNode.textContent); } catch (ignore) {}
          proofNode.remove();
        }
        var carrierEngine = window.MekhannCarrierPilotV2193;
        if (options.renderToken && (!carrierEngine || typeof carrierEngine.canCommitRender !== 'function' ||
            !carrierEngine.canCommitRender(options.renderToken, renderedCart))) {
          throw new Error('Your bag changed while it was updating. Please refresh your bag before continuing.');
        }
        theme.mekhannCartGroups.aggregateDisplay(items, renderedCart);
        theme.mekhannCartGroups.stabilizeDisplay(items, this.products);
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        // Keep the full page's last-item removal as complete as a fresh /cart load.
        var pageEmpty = this.location === 'page' && this.wrapper.querySelector('[data-mekhann-page-empty]');
        if (pageEmpty) {
          pageEmpty.hidden = count > 0;
          this.form.hidden = count === 0;
        }
  
        this.updateCount(count);
  
        // One replacement, without a transient empty tree resetting a scroller.
        // Preserve both desktop and short-screen/editing drawer scroll owners.
        var scrollState = ['.drawer__scrollable', '.drawer__inner'].map(function(selector) {
          var node = this.products.closest(selector);
          return node && {node: node, top: node.scrollTop};
        }.bind(this)).filter(Boolean);
        this.products.replaceChildren(items);
        if (theme.mekhannCartTrace) {
          theme.mekhannCartTrace.mark('html.products.appended');
          theme.mekhannCartTrace.images(this.products);
        }
  
        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        // Use the same returned cart state as its amount and items. Do not
        // leave the previous shipping/tax message after an AJAX change.
        var cartFooter = this.form.querySelector('[data-mekhann-cart-footer]');
        if (cartFooter) {
          var shippingState = items.dataset.cartRequiresShipping === 'true' ? 'shipping' : 'no-shipping';
          var taxState = items.dataset.cartTaxesIncluded === 'true' ? 'included' : 'excluded';
          var footerCopy = cartFooter.getAttribute('data-copy-' + shippingState + '-' + taxState);
          if (footerCopy) cartFooter.textContent = footerCopy;
        }
  
        this.reInit();
        scrollState.forEach(function(state) { state.node.scrollTop = state.top; });

        if (focusControl && !document.contains(previousFocus)) {
          var rows = visibleProductRows(this.products);
          var replacementRow = focusedIdentity && rows.find(function(row) {
            try { return theme.mekhannCartGroups.equivalent(JSON.parse(row.dataset.mekhannCartGroup), focusedIdentity); } catch (ignore) { return false; }
          });
          replacementRow = replacementRow || rows[Math.min(focusedIndex, rows.length - 1)];
          var replacementFocus = replacementRow && replacementRow.querySelector(focusControl);
          if (!replacementFocus || replacementFocus.disabled) replacementFocus = replacementRow && (replacementRow.querySelector('.js-qty__num') || replacementRow.querySelector('[data-mekhann-group-remove], a[href]'));
          if (!replacementFocus) replacementFocus = pageEmpty && pageEmpty.querySelector('a[href], button') || this.wrapper.querySelector('.js-drawer-close');
          if (replacementFocus) replacementFocus.focus({ preventScroll: true });
        }

        if (this.cartError) this.showCartError(this.cartError.message, this.cartError.group);
        document.dispatchEvent(new CustomEvent('cart:rendered', { detail: {
          form: this.form, products: this.products, renderToken: options.renderToken || null, renderedCart: renderedCart
        } }));

        // Cart refreshes do not need to rescan animations or reinitialise
        // payment integrations elsewhere on the page.
        if (window.AOS && this.products.querySelector('[data-aos]')) { window.AOS.refreshHard(); }
  
        if (window.Shopify && window.Shopify.StorefrontExpressButtons &&
            this.products.querySelector('[data-shopify="dynamic-checkout-cart"], shopify-accelerated-checkout-cart')) {
          window.Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        if (markup) this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        // Rendering or opening a bag never announces stock. Only the originating
        // Plus operation may announce a freshly verified maximum below.
        this.clearQuantityLimitFeedback();
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var input = el.querySelector('.js-qty__num');
          var label = el.querySelector('label');
          if (input) {
            input.id = 'cart_updates_' + this.location + '_' + input.dataset.id;
            if (label) label.setAttribute('for', input.id);
          }
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      clearQuantityLimitFeedback: function() {
        this.form.querySelectorAll('.cart__quantity-limit').forEach(function(notice) {
          if (notice.mekhannLimitTimer) window.clearTimeout(notice.mekhannLimitTimer);
          if (notice.mekhannLimitAnnounceTimer) window.clearTimeout(notice.mekhannLimitAnnounceTimer);
          notice.mekhannLimitTimer = null;
          notice.mekhannLimitAnnounceTimer = null;
          notice.hidden = true;
          notice.textContent = '';
        });
      },

      showConfirmedQuantityLimit: function(identity, qty, intent, cart, isCurrent) {
        if (!intent || intent.consumed) return;
        intent.consumed = true;
        var self = this;
        var groups = theme.mekhannCartGroups;
        function current() {
          return !self.destroyed && self.form.isConnected && self.form.__mekhannCartForm === self &&
            self.quantityFeedbackSession === intent.session &&
            (self.wrapper.id !== 'CartDrawer' || self.wrapper.classList.contains('drawer--is-open') && self.wrapper.getAttribute('aria-hidden') !== 'true') &&
            !self.form.hasAttribute('data-mekhann-cart-unverified') && (!isCurrent || isCurrent());
        }
        if (!current() || qty <= intent.previousQuantity ||
            groups.members(cart, identity).reduce(function(sum, item) { return sum + Number(item.quantity); }, 0) !== qty) return;
        var rows = Array.prototype.filter.call(this.form.querySelectorAll('[data-mekhann-cart-group]'), function(row) {
          try { return groups.equivalent(JSON.parse(row.dataset.mekhannCartGroup), identity); } catch (ignore) { return false; }
        });
        if (rows.length !== 1) return;
        var wrapper = rows[0].querySelector('.js-qty__wrapper');
        var selector = wrapper && wrapper.__mekhannQtySelector;
        if (!selector || Number(rows[0].dataset.mekhannGroupQuantity) !== qty || selector._getQty() !== qty ||
            selector.maxValue === null || !Number.isFinite(selector.maxValue) || qty < selector.maxValue) return;
        selector.showQuantityLimitFeedback(current);
      },
  
      showCartError: function(message, group) {
        var errorContainer = null;
        if (group) {
          this.form.querySelectorAll('[data-mekhann-cart-group]').forEach(function(row) {
            try {
              if (theme.mekhannCartGroups.equivalent(JSON.parse(row.dataset.mekhannCartGroup), group)) {
                errorContainer = row.querySelector('[data-cart-item-error]');
              }
            } catch (ignore) {}
          });
        }
        if (!errorContainer) {
          errorContainer = this.form.querySelector('[data-mekhann-cart-error]');
          if (!errorContainer) {
            errorContainer = document.createElement('div');
            errorContainer.setAttribute('data-mekhann-cart-error', '');
            errorContainer.setAttribute('role', 'status');
            errorContainer.setAttribute('aria-live', 'polite');
            errorContainer.className = 'cart__quantity-error';
            this.products.insertAdjacentElement('afterend', errorContainer);
          }
        }
        errorContainer.textContent = message;
        var refresh = document.createElement('a');
        refresh.href = this.form.getAttribute('action') || (theme.routes && theme.routes.cart) || '/cart';
        refresh.className = 'mekhann-cart-recovery';
        refresh.setAttribute('data-mekhann-view-bag', '');
        refresh.textContent = 'Refresh shopping bag';
        errorContainer.appendChild(refresh);
        errorContainer.classList.remove('hide');
        var presentation = { node: errorContainer };
        errorContainer.mekhannCartErrorPresentation = presentation;
        return presentation;
      },

      changeQuantityOwned: function(identity, qty, el, resetInput, carrier, queuedRemoveControl, quantityIntent, queuedQuantity) {
        var self = this;
        var groups = theme.mekhannCartGroups;
        var token = null, releasePending = null, latestCart = null, failure = null, confirmed = false, plusMutation = null, minusCart = null;
        var quantityRow = el && el.closest('[data-mekhann-cart-group]');
        var displayedQuantity = quantityRow ? Number(quantityRow.dataset.mekhannGroupQuantity) : NaN;
        var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.start(qty === 0 ? 'remove.total' : 'quantity.total');
        var traceQueue = theme.mekhannCartTrace && theme.mekhannCartTrace.start('quantity.queue');
        var queuedRemoveStarted = false;
        var queuedAction = Boolean(queuedRemoveControl || queuedQuantity);
        var queuedControl = queuedRemoveControl || queuedQuantity && el;
        var queuedRow = queuedQuantity && el && el.closest('[data-mekhann-cart-group]');
        function ownsForm() { return !queuedAction || !self.destroyed && self.form.__mekhannCartForm === self; }
        this.cartItemsUpdated = true;
        if (el) el.classList.add('is-loading');
        var removeLabel = queuedRemoveControl && queuedRemoveControl.textContent;
        if (queuedRemoveControl) {
          queuedRemoveControl.textContent = 'Removing…';
          queuedRemoveControl.setAttribute('aria-busy', 'true');
          queuedRemoveControl.setAttribute('aria-disabled', 'true');
        }
        // Reserve the actual save promise in the click's call stack. A save
        // completing before the next microtask must not lose accepted intent.
        var queuedBegin = queuedAction ? carrier.beginOwnedMutation({
          afterExtras: true,
          action: queuedQuantity ? 'quantity' : 'remove',
          isCurrent: function(writeStarted) {
            return !self.destroyed && self.form.isConnected && self.form.__mekhannCartForm === self &&
              (writeStarted || queuedControl && queuedControl.isConnected && self.form.contains(queuedControl) &&
                (!queuedQuantity || queuedRow && Number(queuedRow.dataset.mekhannGroupQuantity) === queuedQuantity.previousQuantity));
          }
        }) : null;
        var operation = Promise.resolve().then(async function() {
          // Begin before taking the form/group lock: the engine must be able to
          // finish any older request before this transaction owns the queue.
          token = await (queuedBegin || carrier.beginOwnedMutation());
          if (traceQueue) traceQueue();
          queuedRemoveStarted = queuedAction;
          var guard = queuedAction ? function(beforeWrite) { carrier.assertQueuedRemove(token, beforeWrite); } : null;
          if (guard) guard(false);
          releasePending = groups.hold();
          self.form.setAttribute('aria-busy', 'true');
          try {
            if (quantityIntent && qty === quantityIntent.previousQuantity + 1 && typeof carrier.tryPlusOwnedSelection === 'function') {
              plusMutation = await carrier.tryPlusOwnedSelection(token, identity, qty, guard, quantityIntent.previousQuantity);
            }
            if (qty > 0 && qty === displayedQuantity - 1 && typeof carrier.tryMinusOwnedSelection === 'function') {
              minusCart = await carrier.tryMinusOwnedSelection(token, identity, qty, guard, displayedQuantity);
            }
            latestCart = minusCart || (plusMutation ? plusMutation.cart : qty === 0 && typeof carrier.removeOwnedSelection === 'function' ?
              await carrier.removeOwnedSelection(token, identity, guard, displayedQuantity) :
              await groups.changeQuantity(identity, qty, guard, displayedQuantity));
            if (guard) guard(false);
          }
          catch (error) {
            if (error && error.mekhannRemoveCancelled) throw error;
            failure = error;
            self.cartError = {group: identity, message: error && error.message || 'Your bag could not be updated. Please try again.'};
          }
          // The engine now owns the lock while it follows/trims linked carrier
          // quantities and renders. No parent-only HTML is published first.
          if (guard) guard(false);
          self.form.removeAttribute('aria-busy');
          releasePending(); releasePending = null;
          var result;
          if (failure || !latestCart) result = await carrier.abortOwnedMutation(token, {uncertain: Boolean(failure && failure.mekhannMutationUnknown), parentRecovery: false});
          else result = await carrier.settleOwnedMutation(token, {cart: latestCart, fitting: plusMutation && plusMutation.fitting});
          token = null;
          latestCart = result && result.cart;
          if (!result || !carrier.isRenderReceiptCurrent(result.renderReceipt)) {
            throw new Error('Your bag changed while it was updating. Please refresh your bag before continuing.');
          }
          confirmed = true;
          if (!failure && theme.mekhannCartDrawer && typeof theme.mekhannCartDrawer.retireCompletedAddFeedback === 'function') {
            theme.mekhannCartDrawer.retireCompletedAddFeedback(latestCart, result.renderReceipt);
          }
          instances.filter(function(instance) { return instance.form.isConnected; }).forEach(function(instance) {
            instance.form.removeAttribute('data-mekhann-cart-unverified');
          });
          var plusWarning = result.warning || plusMutation && plusMutation.warning;
          if (plusWarning) self.showCartError(plusWarning);
          var feedbackIdentity = identity;
          if (plusMutation && plusMutation.fitting) {
            // The successful new physical pair joins the existing visible row.
            // Use that full current identity for maximum feedback, retaining
            // the original identity for cancelled/failed command ownership.
            Array.prototype.some.call(self.form.querySelectorAll('[data-mekhann-cart-group]'), function(row) {
              try {
                var candidate = JSON.parse(row.dataset.mekhannCartGroup);
                if (!groups.equivalent(candidate, identity) || Number(row.dataset.mekhannGroupQuantity) !== qty) return false;
                feedbackIdentity = candidate; return true;
              } catch (ignore) { return false; }
            });
          }
          if (!failure && !plusWarning) self.showConfirmedQuantityLimit(feedbackIdentity, qty, quantityIntent, latestCart, function() {
            return carrier.isRenderReceiptCurrent(result.renderReceipt);
          });
        }).catch(async function(error) {
          if (queuedAction && token) {
            // A transport rejection after teardown must not start ordinary
            // recovery (which may write). Preserve any unknown-POST evidence.
            try { carrier.assertQueuedRemove(token, false); }
            catch (cancelled) {
              if (error && error.mekhannMutationUnknown || failure && failure.mekhannMutationUnknown) cancelled.mekhannMutationUnknown = true;
              error = cancelled;
            }
          }
          failure = failure || error;
          if (releasePending) { if (ownsForm()) self.form.removeAttribute('aria-busy'); releasePending(); releasePending = null; }
          // Only never-acquired or explicitly cancelled intents take this path.
          // token is also null after a real completed mutation: receipt failure
          // there must retain the ordinary unverified-cart handling below.
          if (queuedAction && (!queuedRemoveStarted || error && error.mekhannRemoveCancelled && carrier.cancelQueuedRemove(token, Boolean(failure && failure.mekhannMutationUnknown)))) {
            token = null;
            if (!error || !error.mekhannNavigation) {
              self.cartError = {group: identity, message: failure && failure.message || (queuedQuantity ? 'The quantity could not be updated. Please try again.' : 'The item could not be removed. Please try again.')};
              if (!self.destroyed && self.form.isConnected) self.showCartError(self.cartError.message, identity);
            }
            return;
          }
          if (token) {
            try {
              var recovered = await carrier.abortOwnedMutation(token, {uncertain: Boolean(failure && failure.mekhannMutationUnknown), parentRecovery: false});
              latestCart = recovered && recovered.cart;
              confirmed = Boolean(recovered && carrier.isRenderReceiptCurrent(recovered.renderReceipt));
            } catch (recoveryError) { latestCart = null; }
            token = null;
          }
          self.cartError = {group: identity, message: failure && failure.message || 'Your bag could not be updated. Please try again.'};
          if (!confirmed) self.form.setAttribute('data-mekhann-cart-unverified', 'true');
          self.showCartError(self.cartError.message, identity);
        }).finally(function() {
          if (releasePending) releasePending();
          if (el && ownsForm()) el.classList.remove('is-loading');
          if (queuedRemoveControl && ownsForm()) {
            queuedRemoveControl.textContent = removeLabel;
            queuedRemoveControl.removeAttribute('aria-busy');
            queuedRemoveControl.removeAttribute('aria-disabled');
          }
          if (ownsForm()) self.form.removeAttribute('aria-busy');
          self.cartItemsUpdated = false;
          if (self.submitBtn && ownsForm()) self.submitBtn.classList.remove(classes.btnLoading);
          // Restore the original input only if it survived (e.g. request failed).
          if (ownsForm()) resetInput();
          if (traceQueue) traceQueue(failure ? 'error' : 'complete');
          if (traceEnd) traceEnd(confirmed && !failure ? 'complete' : 'error');
        });
        this.quantityOperation = operation;
        return operation;
      },

      quantityChanged: function(evt) {
        if (this.destroyed || !this.form.isConnected || !evt || !Array.isArray(evt.detail)) return;
        var key = evt.detail[0];
        var qty = Number(evt.detail[1]);
        var el = evt.detail[2];
        var row = el && el.closest('[data-mekhann-cart-group]');
        var groups = theme.mekhannCartGroups;
        if (!key || !Number.isSafeInteger(qty) || qty < 0 || !row || !this.form.contains(row)) return;
        var input = row.querySelector('.js-qty__num');
        function resetInput() {
          if (!input) return;
          input.value = row.dataset.mekhannGroupQuantity;
          if (el && el.__mekhannQtySelector) el.__mekhannQtySelector.updateButtonState(Number(input.value));
        }
        var carrier = window.MekhannCarrierPilotV2193;
        var queueRemove = Boolean(evt.removeControl && qty === 0 && carrier && typeof carrier.canQueueRemoveAfterExtras === 'function' && carrier.canQueueRemoveAfterExtras());
        var queueQuantity = Boolean(!evt.removeControl && qty !== Number(row.dataset.mekhannGroupQuantity) && carrier &&
          typeof carrier.canQueueQuantityAfterExtras === 'function' && carrier.canQueueQuantityAfterExtras());
        var queueAfterExtras = queueRemove || queueQuantity;
        if (this.cartItemsUpdated || groups.pending() && !queueAfterExtras || this.form.getAttribute('aria-busy') === 'true' || carrier && typeof carrier.isBusy === 'function' && carrier.isBusy() && !queueAfterExtras) {
          resetInput();
          return;
        }
        var identity;
        try { identity = JSON.parse(row.dataset.mekhannCartGroup); }
        catch (error) { resetInput(); this.showCartError('Your bag could not be updated. Please refresh and try again.'); return; }

        var origin = evt.detail[3];
        var previousQuantity = Number(row.dataset.mekhannGroupQuantity);
        var quantityIntent = origin && origin.source === 'plus' && origin.previousQuantity === previousQuantity && qty > previousQuantity
          ? { previousQuantity: previousQuantity, session: this.quantityFeedbackSession, consumed: false } : null;
        this.clearQuantityLimitFeedback();
        this.cartError = null;
        this.form.querySelectorAll('[data-cart-item-error], [data-mekhann-cart-error]').forEach(function(node) {
          node.textContent = ''; node.classList.add('hide');
        });
        if (carrier && typeof carrier.beginOwnedMutation === 'function' && typeof carrier.settleOwnedMutation === 'function' &&
            typeof carrier.abortOwnedMutation === 'function' && typeof carrier.isRenderReceiptCurrent === 'function') {
          return this.changeQuantityOwned(identity, qty, el, resetInput, carrier, queueRemove ? evt.removeControl : null, quantityIntent,
            queueQuantity ? {previousQuantity: previousQuantity} : null);
        }
        if (el) el.classList.add('is-loading');
        this.form.setAttribute('aria-busy', 'true');
        this.cartItemsUpdated = true;
        var releasePending = groups.hold();
        var operation = groups.changeQuantity(identity, qty, null, previousQuantity);
        document.dispatchEvent(new CustomEvent('cart:mutation:start', { detail: { source: 'mekhann-cart-groups', group: identity } }));
        var latestCart = null;
        var failure = null;
        operation.then(function(cart) {
          latestCart = cart;
        }).catch(function(error) {
          failure = error;
          this.cartError = { group: identity, message: error && error.message || 'Your bag could not be updated. Please try again.' };
          return groups.read().then(function(cart) { latestCart = cart; }).catch(function() {
            this.cartError.message = 'We could not confirm your bag. Please refresh before checking out.';
          }.bind(this));
        }.bind(this)).then(function() {
          resetInput();
          return Promise.all(instances.filter(function(instance) { return instance.form.isConnected; }).map(function(instance) {
            var renderOperation = instance.buildCart();
            var renderGeneration = instance.cartBuildGeneration;
            return renderOperation.then(function(rendered) {
              // A later external rebuild owns the visible form and its guard.
              // Do not let this older quantity callback undo that newer state.
              if (renderGeneration !== instance.cartBuildGeneration) return;
              if (latestCart && rendered) instance.form.removeAttribute('data-mekhann-cart-unverified');
              else instance.form.setAttribute('data-mekhann-cart-unverified', 'true');
              if (instance === this && !failure && rendered) instance.showConfirmedQuantityLimit(identity, qty, quantityIntent, latestCart, function() {
                return renderGeneration === instance.cartBuildGeneration;
              });
            }.bind(this));
          }.bind(this)));
        }.bind(this)).catch(function(error) {
          failure = error;
          this.form.setAttribute('data-mekhann-cart-unverified', 'true');
          this.showCartError('We could not confirm your bag. Please refresh before checking out.');
        }.bind(this)).finally(function() {
          if (el) el.classList.remove('is-loading');
          this.form.removeAttribute('aria-busy');
          this.cartItemsUpdated = false;
          if (this.submitBtn) this.submitBtn.classList.remove(classes.btnLoading);
          releasePending();
          if (latestCart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: latestCart, source: 'mekhann-cart-groups' } }));
          document.dispatchEvent(new CustomEvent('cart:mutation:complete', {
            detail: { source: 'mekhann-cart-groups', cart: latestCart, error: failure, unknown: !latestCart }
          }));
        }.bind(this));
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    // Per-panel state: rapid clicks reverse their own transition without
    // blocking a different accordion.
    var transitions = new WeakMap();
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        return;
      }
  
      var inner = container.querySelector(selectors.moduleInner);
      if (!inner) { return; }
      var height = inner.offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if (isOpen) {
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          el.setAttribute('aria-expanded', false);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          if (newModule) { setTransitionHeight(newModule, 0, true); }
        });
      }
  
      if (isOpen) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl && parentCollapsibleEl.style.height !== 'auto') {
        // Use the parent's target while it is animating, not an intermediate
        // rendered height; rapid sibling toggles must not shrink the menu.
        var parentHeight = parseFloat(parentCollapsibleEl.style.height);
        if (!Number.isFinite(parentHeight)) { parentHeight = parentCollapsibleEl.offsetHeight; }
        var totalHeight = isOpen ? parentHeight - childHeight : parentHeight + height;
        setTransitionHeight(parentCollapsibleEl, Math.max(0, totalHeight), false,
          parentCollapsibleEl.classList.contains(classes.autoHeight));
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, false, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      var previous = transitions.get(container);
      if (previous) { previous.cancel(); }

      var timer;
      var observer;
      var state = {
        cancel: function() {
          window.clearTimeout(timer);
          container.removeEventListener('transitionend', onEnd);
          if (observer) { observer.disconnect(); }
        }
      };
      transitions.set(container, state);

      function finish() {
        if (transitions.get(container) !== state) { return; }
        state.cancel();
        transitions.delete(container);
        if (!isOpen && isAutoHeight && container.classList.contains(classes.open)) {
          // Native DOM property: loaded pickup content, variant changes and
          // responsive text can all grow naturally once the panel is open.
          container.style.height = 'auto';
        }
        container.classList.remove('is-transitioning');
      }

      function onEnd(evt) {
        if (evt.target === container && evt.propertyName === 'height') { finish(); }
      }

      // Freeze the current rendered height, including a partial animation,
      // before reversing it. An old timer must never reopen a closed panel.
      var currentHeight = container.getBoundingClientRect().height;
      container.classList.remove(classes.hide);
      container.style.height = currentHeight + 'px';
      container.classList.add('is-transitioning');
      container.offsetHeight;
      container.addEventListener('transitionend', onEnd);
      container.style.height = height + 'px';
      if (isOpen) {
        container.classList.remove(classes.open);
      } else {
        container.classList.add(classes.open);
      }

      // Loading text can be replaced during the opening transition itself.
      // After settling, height:auto needs no ongoing observer/layout work.
      var inner = container.querySelector(selectors.moduleInner);
      if (!isOpen && isAutoHeight && inner && window.ResizeObserver) {
        observer = new window.ResizeObserver(function() {
          if (transitions.get(container) === state) {
            container.style.height = inner.offsetHeight + 'px';
          }
        });
        observer.observe(inner);
      }
      // Also settle for reduced motion, unchanged height or detached content.
      timer = window.setTimeout(finish, 500);
    }

    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {
    // V2.23-INLINE-CART-2026-09-07: cart focus stays owned by the drawer,
    // including its close button. Other Impulse modal/drawer helpers are unchanged.
    function cartFocusAvailable(element) {
      if (!element || !document.contains(element) || element.disabled || element.matches(':disabled') || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      if (!element.getClientRects().length || window.getComputedStyle(element).visibility === 'hidden') return false;
      var ancestor = element.parentElement;
      while (ancestor) {
        if (ancestor.tagName === 'DETAILS' && !ancestor.open) {
          var summary = ancestor.querySelector('summary');
          if (!summary || !summary.contains(element)) return false;
        }
        ancestor = ancestor.parentElement;
      }
      return true;
    }

    function cartDialogAbove(drawer) {
      return Array.prototype.some.call(document.querySelectorAll('dialog[open]'), function(dialog) {
        return !drawer.contains(dialog);
      });
    }

    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
      this.isCartDrawer = id === 'CartDrawer';
      this.isPLPFilterDrawer = id === 'FilterDrawer' && this.drawer && this.drawer.hasAttribute('data-plp-filter-drawer');
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        this.openListener = this.open.bind(this);
        this.closeListener = this.close.bind(this);
        this.openButtons = Array.prototype.slice.call(document.querySelectorAll(this.config.open));
        this.closeButtons = Array.prototype.slice.call(this.drawer.querySelectorAll(this.config.close));
        // Setup open button(s)
        this.openButtons.forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          if (this.isCartDrawer || this.isPLPFilterDrawer) {
            openBtn.setAttribute('aria-controls', this.config.id);
            openBtn.setAttribute('aria-haspopup', 'dialog');
          }
          openBtn.addEventListener('click', this.openListener);
        });
  
        this.closeButtons.forEach(closeBtn => {
          closeBtn.addEventListener('click', this.closeListener);
        });
  
        // Close modal if a drawer is opened
        this.modalListener = function() {
          this.close(null, this.isCartDrawer);
        }.bind(this);
        document.addEventListener('modalOpen', this.modalListener);
      },

      destroy: function() {
        if (this.destroyed) return;
        this.destroyed = true;
        if (this.isOpen) {
          this.isOpen = false;
          this.drawer.classList.remove(this.config.activeDrawer);
          document.documentElement.classList.remove(this.config.openClass, this.config.closingClass);
          this.unbindEvents();
          if (!this.isCartDrawer) theme.a11y.removeTrapFocus({container: this.drawer, namespace: 'drawer_focus'});
        }
        if (this.closeTimer) {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = null;
          document.documentElement.classList.remove(this.config.closingClass);
        }
        this.unbindCartFocus();
        this.unbindPLPFilterFocus();
        (this.openButtons || []).forEach(function(button) {
          button.removeEventListener('click', this.openListener);
          if (this.isCartDrawer || this.isPLPFilterDrawer) button.setAttribute('aria-expanded', 'false');
        }.bind(this));
        (this.closeButtons || []).forEach(function(button) { button.removeEventListener('click', this.closeListener); }.bind(this));
        document.removeEventListener('modalOpen', this.modalListener);
        if ((this.isCartDrawer || this.isPLPFilterDrawer) && this.drawer) {
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.setAttribute('inert', '');
        }
      },
  
      open: function(evt, returnFocusEl) {
        if (this.destroyed || !this.drawer || !this.drawer.isConnected) return;
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
        if (this.closeTimer) { window.clearTimeout(this.closeTimer); this.closeTimer = null; }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (this.isCartDrawer || this.isPLPFilterDrawer) {
          if (evt && evt.stopPropagation) evt.stopPropagation();
          var source = evt && evt.currentTarget || returnFocusEl || document.activeElement;
          this.activeSource = source && source !== document.body && source !== document.documentElement && !this.drawer.contains(source) ? source : null;
          if (this.activeSource && this.activeSource.matches(this.config.open)) this.activeSource.setAttribute('aria-expanded', 'true');
          this.drawer.removeAttribute('inert');
          this.drawer.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.remove(this.config.closingClass);
        } else if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        if (!this.isCartDrawer && !this.isPLPFilterDrawer) {
          theme.a11y.trapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
          });
        }
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
        if (this.isCartDrawer) this.bindCartFocus();
        if (this.isPLPFilterDrawer) this.bindPLPFilterFocus();
      },
  
      close: function(evt, preventFocusReturn) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        this.closeTimer = window.setTimeout(function() {
          this.closeTimer = null;
          if (this.destroyed) return;
          document.documentElement.classList.remove(this.config.closingClass);
          if (!this.isCartDrawer && !this.isPLPFilterDrawer && this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        if (this.isCartDrawer || this.isPLPFilterDrawer) {
          this.unbindCartFocus();
          this.unbindPLPFilterFocus();
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.setAttribute('inert', '');
          if (this.activeSource && this.activeSource.matches(this.config.open)) this.activeSource.setAttribute('aria-expanded', 'false');
        } else {
          theme.a11y.removeTrapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
          });
        }
  
        this.unbindEvents();
        if (this.isCartDrawer) document.dispatchEvent(new CustomEvent('drawerClose.CartDrawer'));
        if (this.isPLPFilterDrawer) {
          document.dispatchEvent(new CustomEvent('drawerClose.FilterDrawer'));
          if (!preventFocusReturn) {
            var filterSource = cartFocusAvailable(this.activeSource) ? this.activeSource : Array.prototype.find.call(document.querySelectorAll(this.config.open), cartFocusAvailable);
            if (filterSource) filterSource.focus({ preventScroll: true });
          }
        }
        if (this.isCartDrawer && !preventFocusReturn && !cartDialogAbove(this.drawer)) {
          var target = cartFocusAvailable(this.activeSource) ? this.activeSource : Array.prototype.find.call(document.querySelectorAll(this.config.open), cartFocusAvailable);
          if (target) target.focus({ preventScroll: true });
        }
      },

      // PLP19-R1: dynamic focus targets survive filter HTML replacement.
      bindPLPFilterFocus: function() {
        this.unbindPLPFilterFocus();
        var self = this;
        var focusable = function() {
          return Array.prototype.filter.call(self.drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'), cartFocusAvailable);
        };
        this.drawer.setAttribute('tabindex', '-1');
        this.plpKeydown = function(evt) {
          if (!self.isOpen) return;
          if (evt.key === 'Escape' || evt.keyCode === 27) {
            evt.preventDefault();
            // PLP19-R7: this modal owns Escape. A closed PredictiveSearch
            // listener must not blur the Filter trigger restored by close().
            evt.stopPropagation();
            self.close();
            return;
          }
          if (evt.key !== 'Tab' && evt.keyCode !== 9) return;
          var targets = focusable();
          var first = targets[0], last = targets[targets.length - 1];
          var active = document.activeElement;
          if (!first) { evt.preventDefault(); self.drawer.focus({ preventScroll: true }); return; }
          if (evt.shiftKey && (active === first || active === self.drawer || !self.drawer.contains(active))) {
            evt.preventDefault(); last.focus({ preventScroll: true });
          } else if (!evt.shiftKey && (active === last || !self.drawer.contains(active))) {
            evt.preventDefault(); first.focus({ preventScroll: true });
          }
        };
        this.plpFocusin = function(evt) {
          if (self.isOpen && !self.drawer.contains(evt.target)) {
            (focusable()[0] || self.drawer).focus({ preventScroll: true });
          }
        };
        document.addEventListener('keydown', this.plpKeydown, true);
        document.addEventListener('focusin', this.plpFocusin, true);
        (focusable()[0] || this.drawer).focus({ preventScroll: true });
      },

      unbindPLPFilterFocus: function() {
        if (this.plpKeydown) document.removeEventListener('keydown', this.plpKeydown, true);
        if (this.plpFocusin) document.removeEventListener('focusin', this.plpFocusin, true);
        this.plpKeydown = null;
        this.plpFocusin = null;
      },

      bindCartFocus: function() {
        this.unbindCartFocus();
        var self = this;
        function focusable() {
          return Array.prototype.filter.call(self.drawer.querySelectorAll('button, a[href], input:not([type="hidden"]), select, textarea, summary, [tabindex]'), function(element) {
            return Number(element.getAttribute('tabindex') || 0) >= 0 && cartFocusAvailable(element);
          });
        }
        this.cartKeydown = function(evt) {
          if (!self.isOpen) return;
          if (cartDialogAbove(self.drawer)) {
            if (evt.key === 'Escape' || evt.keyCode === 27) self.cartAdvisorEscape = true;
            return;
          }
          if (evt.key !== 'Tab' && evt.keyCode !== 9) return;
          var elements = focusable();
          var first = elements[0] || self.drawer;
          var last = elements[elements.length - 1] || self.drawer;
          var active = document.activeElement;
          if (!elements.length || !self.drawer.contains(active) || active === self.drawer || (evt.shiftKey && active === first) || (!evt.shiftKey && active === last)) {
            evt.preventDefault();
            (evt.shiftKey ? last : first).focus({ preventScroll: true });
          }
        };
        this.cartFocusin = function(evt) {
          if (!self.isOpen || cartDialogAbove(self.drawer) || self.drawer.contains(evt.target)) return;
          (focusable()[0] || self.drawer).focus({ preventScroll: true });
        };
        document.addEventListener('keydown', this.cartKeydown, true);
        document.addEventListener('focusin', this.cartFocusin, true);
        (focusable()[0] || this.drawer).focus({ preventScroll: true });
      },

      unbindCartFocus: function() {
        if (this.cartKeydown) document.removeEventListener('keydown', this.cartKeydown, true);
        if (this.cartFocusin) document.removeEventListener('focusin', this.cartFocusin, true);
        this.cartKeydown = null;
        this.cartFocusin = null;
        this.cartAdvisorEscape = false;
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          if (this.isCartDrawer && (cartDialogAbove(this.drawer) || evt.target.closest('dialog'))) return;
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (this.isCartDrawer && (cartDialogAbove(this.drawer) || this.cartAdvisorEscape)) {
            if (evt.key === 'Escape' || evt.keyCode === 27) this.cartAdvisorEscape = false;
            return;
          }
          if (evt.keyCode === 27 || this.isCartDrawer && evt.key === 'Escape') {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);
  
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  /*============================================================================
    ParallaxImage
  ==============================================================================*/
  
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [  1,  0 ],
        90: [  0, -1 ],
        180: [ -1,  0 ],
        270: [  0,  1 ]
      }
  
      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }
  
    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;
  
      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));
  
      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);
  
      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px
  
      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360
  
      const toLeft = angle > 90 && angle < 270;
      const toTop  = angle < 180;
  
      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop  ? 'top' : 'bottom'] = 0;
  
      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }
  
      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;
  
      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }
  
    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;
  
      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;
  
      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }
  
      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }
  
    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }
  
      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }
  
  customElements.define('parallax-image', ParallaxImage);
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );
  
          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  theme.AjaxProduct = (function() {
    // V2.26: native click, keyboard submission and viewer use this single owner.
    var STORAGE_KEY = 'mekhann:add-to-bag:unresolved:v226';
    var TIMEOUT = 15000;
    var status = {loading: false, uncertain: []};
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (Array.isArray(saved)) status.uncertain = saved.filter(function(attempt) { return attempt && Array.isArray(attempt.choices) && Array.isArray(attempt.before); });
    } catch (ignore) {}

    function persistUncertain(strict) {
      try {
        if (status.uncertain.length) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(status.uncertain.map(function(attempt) {
          return {choices: attempt.choices, before: attempt.before, token: attempt.token || null, fittingIntent: attempt.fittingIntent || null};
        })));
        else window.sessionStorage.removeItem(STORAGE_KEY);
        if (strict) {
          var readback = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '[]');
          var expected = status.uncertain.map(function(attempt) {
            return {choices: attempt.choices, before: attempt.before, token: attempt.token || null, fittingIntent: attempt.fittingIntent || null};
          });
          if (JSON.stringify(readback) !== JSON.stringify(expected)) throw new Error('Addition recovery record was not saved.');
        }
      } catch (error) {
        if (strict) throw message('Your bag request could not be saved safely. Nothing new has been sent; please refresh before trying again.');
      }
    }

    function remember(attempt, strict) {
      status.uncertain.push(attempt);
      try { persistUncertain(strict); }
      catch (error) {
        status.uncertain = status.uncertain.filter(function(pending) { return pending !== attempt; });
        persistUncertain();
        throw error;
      }
    }

    function forget(attempt, strict) {
      var previous = status.uncertain;
      status.uncertain = status.uncertain.filter(function(pending) { return pending !== attempt; });
      try { persistUncertain(strict); }
      catch (error) { status.uncertain = previous; throw error; }
    }

    function overlaps(left, right) {
      return left.some(function(a) { return right.some(function(b) {
        return a.id === b.id && a.plan === b.plan && propertySignature(a.properties) === propertySignature(b.properties);
      }); });
    }

    function request(url, body, sectionMode) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer;
      var options = {
        method: body == null ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: body == null ? undefined : JSON.stringify(body), signal: controller ? controller.signal : undefined
      };
      if (body != null) options = theme.mekhannCartSections.prepare(options, sectionMode);
      var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.request(url, options);
      var traceStatus = 0;
      var operation = fetch(url, options).then(function(response) {
        traceStatus = response.status;
        return response.json().catch(function() {
          var error = message('We could not confirm the response from your bag.');
          error.httpStatus = Number(response.status);
          if (options.mekhannBundled && response.status === 400) error.mekhannMutationUnknown = true;
          throw error;
        }).then(function(data) {
          if (!response.ok || data && Number(data.status) >= 400) {
            var error = message(data && data.description || 'We could not add this item. Please try again.');
            error.httpStatus = Number(response.status);
            if (options.mekhannBundled && response.status === 400) error.mekhannMutationUnknown = true;
            throw error;
          }
          return data;
        });
      });
      var result = Promise.race([operation, new Promise(function(resolve, reject) {
        timer = setTimeout(function() {
          if (controller) controller.abort();
          reject(message('The request took too long.'));
        }, TIMEOUT);
      })]).finally(function() { clearTimeout(timer); });
      if (!traceEnd) return result;
      return result.then(function(data) { traceEnd('complete', traceStatus); return data; }, function(error) {
        traceEnd('error', traceStatus); throw error;
      });
    }

    function readCart() {
      var route = theme.routes.cart || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js';
      return request(route + (route.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now()).then(function(cart) {
        if (!cart || !Array.isArray(cart.items)) throw message('We could not check your shopping bag.');
        return cart;
      });
    }

    function selections(form) {
      var fields = new URLSearchParams(theme.utils.serialize(form)), props = {};
      fields.forEach(function(value, key) {
        var match = /^properties\[(.*)\]$/.exec(key);
        if (match && value !== '') props[match[1]] = value;
      });
      var external = form.closest('[data-product-blocks]');
      var quantity = form.querySelector('[name="quantity"]') || external && external.querySelector('[name="quantity"]');
      var variant = form.querySelector('[data-product-select]');
      var choices = [{id: Number(variant && variant.value || fields.get('id')), quantity: Number(quantity && quantity.value || fields.get('quantity') || 1),
        plan: Number(fields.get('selling_plan') || 0), properties: props}];
      // Preserve the existing cushion-pad contract: one mapped pad per addition.
      // The legacy native additional-item fields are not sent a second time.
      var pad = form.querySelector('.metaprod');
      if (pad && pad.value) choices.push({id: Number(pad.value), quantity: 1, plan: 0, properties: {}});
      return choices;
    }

    // Optional drawer image preparation. The inert metadata comes from the
    // same Liquid image_url/image_tag contract as the final cart thumbnail.
    // Capture by the submitted variant before an async cart read can outlive
    // another visible selection; do not borrow the PDP gallery's currentSrc.
    function captureCartThumbnail(form, variantId) {
      try {
        if (theme.settings.cartType !== 'drawer' || document.body.classList.contains('template-cart')) return '';
        var select = form.querySelector('[data-product-select]');
        var option = select && Array.prototype.find.call(select.querySelectorAll('option'), function(candidate) {
          return Number(candidate.value) === Number(variantId);
        });
        return option && option.getAttribute('data-mekhann-cart-thumbnail') || '';
      } catch (ignore) { return ''; }
    }

    function warmCartThumbnail(markup) {
      try {
        if (!markup || typeof window.Image !== 'function') return null;
        var template = document.createElement('template');
        template.innerHTML = markup;
        var source = template.content && template.content.firstElementChild;
        if (!source || source.tagName !== 'IMG' || source.nextElementSibling) return null;
        var src = source.getAttribute('src');
        var srcset = source.getAttribute('srcset');
        var sizes = source.getAttribute('sizes');
        if (!src || !srcset || !sizes) return null;
        var image = new window.Image();
        // Set responsive selection before src. A disconnected Image fetches
        // the chosen candidate without adding a speculative visible bag row.
        image.sizes = sizes;
        image.srcset = srcset;
        image.src = src;
        return image;
      } catch (ignore) { return null; }
    }

    function propertySignature(props) {
      return JSON.stringify(Object.keys(props || {}).filter(function(key) {
        return props[key] != null && String(props[key]) !== '';
      }).sort().map(function(key) { return [key, String(props[key])]; }));
    }

    function matches(item, choice) {
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      return Number(item.variant_id || item.id) === choice.id && Number(plan && plan.id || 0) === choice.plan &&
        !item.parent_relationship && propertySignature(item.properties) === propertySignature(choice.properties);
    }

    function count(cart, choice) {
      return cart.items.reduce(function(total, item) { return total + (matches(item, choice) ? Number(item.quantity) : 0); }, 0);
    }

    // A stock rejection may be brief only when the complete Ajax cart remains
    // unchanged through final verification. Ignore only the engine's derived
    // mapping annotations; retain properties, money, metadata and discounts.
    function rejectedCartFingerprint(cart) {
      if (!cart || typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items)) return '';
      try {
        var copy = JSON.parse(JSON.stringify(cart));
        delete copy._mekhann_carrier_mappings;
        delete copy._mekhann_carrier_options;
        copy.items.forEach(function(item) {
          delete item._mekhann_parent_selection_key;
          (item.line_level_discount_allocations || []).forEach(function(allocation) {
            if (allocation.discount_application) delete allocation.discount_application._mekhann_type_source;
          });
        });
        function ordered(value) {
          if (Array.isArray(value)) return value.map(ordered);
          if (!value || typeof value !== 'object') return value;
          var sorted = Object.create(null);
          Object.keys(value).sort().forEach(function(key) { sorted[key] = ordered(value[key]); });
          return sorted;
        }
        return JSON.stringify(ordered(copy));
      } catch (ignore) { return ''; }
    }

    function payload(choices) {
      return {items: choices.map(function(choice) {
        var item = {id: choice.id, quantity: choice.quantity};
        if (choice.plan) item.selling_plan = choice.plan;
        if (Object.keys(choice.properties).length) item.properties = choice.properties;
        return item;
      })};
    }

    function validResponse(response, choices) {
      var items = response && (Array.isArray(response.items) ? response.items : [response]);
      return items && choices.every(function(choice) {
        return items.some(function(item) { return matches(item, choice) && Number(item.quantity) >= choice.quantity; });
      });
    }

    function message(text) { var error = new Error(text); error.description = text; return error; }

    function ProductForm(form, submit, args) {
      if (form && form.__mekhannAjaxProduct) return form.__mekhannAjaxProduct;
      this.form = form; this.args = args;
      if (form) {
        this.addToCart = form.querySelector(submit || '.add-to-cart');
        form.__mekhannAjaxProduct = this;
        form.setAttribute('data-mekhann-add-build', 'V2.35-CART2-2026-09-22');
        form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, verificationOnly) {
        evt.preventDefault();
        if (status.loading || !this.addToCart || !verificationOnly && (this.addToCart.disabled || this.addToCart.getAttribute('aria-disabled') === 'true')) return Promise.resolve();
        var self = this, groups = theme.mekhannCartGroups, choices = selections(this.form);
        var purchaseClock = window.performance && typeof window.performance.now === 'function' ? function() { return window.performance.now(); } : function() { return Date.now(); };
        var purchaseStartedAt = purchaseClock();
        this.form.removeAttribute('data-mekhann-last-purchase');
        var cart = null, started = false, accepted = null, warning = '', failure = null, successOwner = this, attempt = null;
        var fitting = window.MekhannPdpCarrier && window.MekhannPdpCarrier.forForm(this.form);
        var fittingIntent = null, parentLifecycleComplete = false;
        var transactionEngine = window.MekhannCarrierPilotV2193;
        var useOwnedTransaction = Boolean(transactionEngine && typeof transactionEngine.beginOwnedMutation === 'function' &&
          typeof transactionEngine.settleOwnedMutation === 'function' && typeof transactionEngine.abortOwnedMutation === 'function' &&
          typeof transactionEngine.isRenderReceiptCurrent === 'function');
        var ownedToken = null, renderReceipt = null, addPresentation = null, unchangedMaximumCart = '', newAddRequested = false;
        // The native journal can survive a reload before the form ledger is
        // written. Recover its original intent, never manufacture a new Add.
        if (transactionEngine && typeof transactionEngine.recoverNativeAttempt === 'function') {
          try {
            var abandonedNative = typeof transactionEngine.nativeBatchAbandonedTokens === 'function' ? transactionEngine.nativeBatchAbandonedTokens() : [];
            if (typeof transactionEngine.nativeBatchResolvedTokens === 'function') {
              abandonedNative = abandonedNative.concat(transactionEngine.nativeBatchResolvedTokens());
            }
            status.uncertain = status.uncertain.filter(function(prior) {
              return !(prior.fittingIntent && prior.fittingIntent.nativeBatch &&
                abandonedNative.indexOf(prior.fittingIntent.nativeBatch.token) !== -1);
            });
            var restoredNative = transactionEngine.recoverNativeAttempt();
            if (restoredNative && !status.uncertain.some(function(prior) {
              return prior.fittingIntent && prior.fittingIntent.nativeBatch &&
                prior.fittingIntent.nativeBatch.token === restoredNative.fittingIntent.nativeBatch.token;
            })) status.uncertain.push(restoredNative);
            // An explicit check refers to the recorded purchase, even if the
            // customer has since selected another colour or size on this PDP.
            // Verification never prepares or posts the currently visible choice.
            if (verificationOnly && restoredNative) {
              choices = restoredNative.choices;
              fittingIntent = restoredNative.fittingIntent;
            }
          } catch (recoveryError) { this.error(recoveryError); return Promise.resolve(); }
        }
        // V2.28.4: the primary submit always purchases a new product. Applying
        // a carrier to an existing bag line has its own explicit controller action.
        var carrierApi = window.MekhannPdpCarrier;
        if (carrierApi && carrierApi.isApplying && carrierApi.isApplying()) return Promise.resolve();
        var carrierRoot = Array.prototype.some.call(document.querySelectorAll('[data-mekhann-pdp-carrier]'), function(root) {
          return root.dataset.carrierFormId === self.form.id;
        });
        if (carrierRoot && (!carrierApi || carrierApi.version !== 'V2.28.5' || !fitting)) {
          this.error(message('Carrier options are still loading. Please refresh this page before adding to your bag.'));
          return Promise.resolve();
        }
        if (fitting) {
          // A regenerated group identifier must never evade a previous uncertain
          // shade addition. Resolve that request before accepting another fitting.
          if (!fittingIntent && status.uncertain.some(function(prior) {
            return prior.choices.some(function(previous) {
              return previous.properties && previous.properties._mekhann_fitting_group &&
                choices.some(function(choice) { return choice.id === previous.id && choice.plan === previous.plan; });
            });
          })) verificationOnly = true;
          if (!fittingIntent && !verificationOnly) {
            try { fittingIntent = fitting.prepare(choices); choices = fittingIntent.choices || choices; }
            catch (error) { this.error(error); return Promise.resolve(); }
          }
        }
        if (fittingIntent && fittingIntent.edit) {
          this.error(message('Please refresh this page before adding to your bag.'));
          return Promise.resolve();
        }
        var cartThumbnail = !verificationOnly && choices[0] ? captureCartThumbnail(this.form, choices[0].id) : '';
        var cartThumbnailImage = null;
        var priorBusy = this.addToCart.getAttribute('aria-busy');
        status.loading = true;
        if (carrierApi && carrierApi.setPurchaseBusy) carrierApi.setPurchaseBusy(true);
        this.addToCart.classList.add('btn--loading');
        this.addToCart.setAttribute('aria-busy', 'true');
        var traceEnd = theme.mekhannCartTrace && theme.mekhannCartTrace.start('add.total');
        var traceQueue = theme.mekhannCartTrace && theme.mekhannCartTrace.start('add.queue');
        var task = async function() {
          if (traceQueue) traceQueue();
          if (!verificationOnly && !choices.every(function(choice) { return Number.isInteger(choice.id) && choice.id > 0 && Number.isInteger(choice.quantity) && choice.quantity > 0 && Number.isInteger(choice.plan) && choice.plan >= 0; })) {
            throw message('Please choose an available option before adding it to your bag.');
          }
          // Grouped Add presentation: this owner already gates cart mutations. Open a truthful
          // loading shell before its first read; no item or amount is invented.
          var drawer = theme.mekhannCartDrawer;
          if (ownedToken && !verificationOnly && fittingIntent && !fittingIntent.edit &&
              theme.settings.cartType === 'drawer' &&
              !document.body.classList.contains('template-cart') && drawer && typeof drawer.beginPendingAdd === 'function') {
            addPresentation = drawer.beginPendingAdd(self.addToCart, fittingIntent.parentGroupId);
          }
          // ADD1: a new fitting group identifies this purchase independently of
          // pre-existing cart contents. Its durable v2 journal owns both the
          // request and recovery. Legacy/uncertain flows retain a fresh preflight.
          var nativeBatch = ownedToken && !verificationOnly && !status.uncertain.length &&
            fittingIntent && !fittingIntent.edit &&
            typeof transactionEngine.prepareScopedNativeBatch === 'function' ?
              transactionEngine.prepareScopedNativeBatch(ownedToken, fittingIntent, choices) : null;
          if (!nativeBatch) cart = await readCart();
          var blocked = false;
          status.uncertain.slice().forEach(function(prior) {
            if (prior.token && cart.token && prior.token !== cart.token &&
                !(prior.fittingIntent && prior.fittingIntent.nativeBatch)) {
              forget(prior);
              return;
            }
            var previousDelta = prior.choices.map(function(choice, index) { return count(cart, choice) - prior.before[index]; });
            var relates = overlaps(choices, prior.choices) || Boolean(fitting && verificationOnly &&
              choices.some(function(choice) {
                return prior.choices.some(function(previous) {
                  return choice.id === previous.id && choice.plan === previous.plan &&
                    previous.properties && previous.properties._mekhann_fitting_group;
                });
              }));
            // A fitting recovery belongs to this PDP's parent only. Leave other
            // unresolved additions in the ledger for their own explicit check.
            if (fitting && verificationOnly && (!relates || blocked)) return;
            if (previousDelta.some(function(delta) { return delta > 0; })) {
              // A combined purchase remains in the ledger until both lines,
              // the real cart identity and the final rendered bag are verified.
              if (!(prior.fittingIntent && prior.fittingIntent.nativeBatch)) forget(prior);
              warning = 'Your previous request changed your bag. Please check the items and quantities before adding more.';
              if (relates || verificationOnly) {
                accepted = previousDelta[0] > 0 ? cart.items.find(function(item) { return matches(item, prior.choices[0]); }) : null;
                successOwner = prior.owner || self;
                fittingIntent = prior.fittingIntent || null;
                attempt = prior;
                if (!started) {
                  started = true;
                  if (!ownedToken) document.dispatchEvent(new CustomEvent('cart:mutation:start', {detail: {source: 'add-to-bag', recovery: true}}));
                }
                blocked = true;
              }
            } else if (relates || verificationOnly) {
              blocked = true;
            }
          });
          if (blocked) {
            if (accepted) return;
            if (warning) throw message(warning);
            // An unchanged GET cannot prove a timed-out POST cannot finish later.
            // Other unrelated selections remain available; this request is not replayed.
            throw message('We could not confirm your previous addition. Check its status or view your shopping bag before adding this item again.');
          }
          if (verificationOnly) return;
          var before = choices.map(function(choice) { return nativeBatch ? 0 : count(cart, choice); });
          var newCarrierPurchase = Boolean(ownedToken && !verificationOnly && fittingIntent &&
            !fittingIntent.edit && Number(fittingIntent.carrierVariantId) > 0 && choices.length === 1);
          if (!nativeBatch && newCarrierPurchase && typeof transactionEngine.prepareNativeBatch === 'function') {
            nativeBatch = transactionEngine.prepareNativeBatch(ownedToken, fittingIntent, choices, cart);
          }
          if (nativeBatch) {
            fittingIntent.nativeBatch = nativeBatch;
            // The ledger and response matcher must use the exact posted props.
            if (nativeBatch.choices) choices = fittingIntent.choices = nativeBatch.choices;
            before = choices.map(function(choice) { return nativeBatch.version === 2 ? 0 : count(cart, choice); });
          }
          attempt = {choices: choices, before: before, token: cart && cart.token || null, owner: self, fittingIntent: fittingIntent};
          try {
            remember(attempt, Boolean(nativeBatch));
            if (nativeBatch) transactionEngine.markNativeBatchSent(ownedToken, nativeBatch);
          }
          catch (storageError) {
            if (nativeBatch) {
              transactionEngine.abandonUnsentNativeBatch(ownedToken, nativeBatch);
              forget(attempt);
            }
            throw storageError;
          }
          started = true;
          if (!ownedToken) document.dispatchEvent(new CustomEvent('cart:mutation:start', {detail: {source: 'add-to-bag'}}));
          var response = null, addError = null, beforeCart = cart;
          try {
            // Only a genuine new Add reaches here: validation, previous-request
            // checks and durable journal setup have succeeded. Never await an
            // image or let a failed image alter the purchase request.
            cartThumbnailImage = warmCartThumbnail(cartThumbnail);
            self.pendingCartThumbnail = cartThumbnailImage;
            // A grouped Add returns the final drawer HTML and economic proof.
            // Legacy serial/native paths still obtain HTML from their final Follow.
            newAddRequested = true;
            response = await request(theme.routes.cartAdd, nativeBatch ? {items: nativeBatch.items} : payload(choices),
              newCarrierPurchase && !(nativeBatch && nativeBatch.kind === 'grouped') ? 'context' : 'response');
            if (!validResponse(response, choices)) {
              var receiptError = message('We could not confirm the response from your bag.');
              receiptError.httpStatus = 200;
              receiptError.mekhannTransportConfirmed = true;
              throw receiptError;
            }
          } catch (error) { addError = error; }
          if (nativeBatch && typeof transactionEngine.acknowledgeNativeBatch === 'function') {
            transactionEngine.acknowledgeNativeBatch(ownedToken, nativeBatch, !addError || Boolean(addError.mekhannTransportConfirmed), {
              httpStatus: addError ? Number(addError.httpStatus) || 0 : 200,
              unknown: Boolean(addError && (addError.mekhannMutationUnknown || !addError.httpStatus))
            });
          }
          // Keep one canonical product layout. A successful Add response is
          // still verified below before rows, totals or checkout are released.
          cart = null;
          try {
            var exactNewReceipt = response && Array.isArray(response.items) && response.items.length === (nativeBatch ? nativeBatch.items.length : choices.length) &&
              choices.every(function(choice) { return response.items.some(function(item) {
                return matches(item, choice) && item.quantity === choice.quantity;
              }); });
            if (nativeBatch && Number(fittingIntent.carrierVariantId) > 0 && exactNewReceipt) exactNewReceipt = response.items.some(function(item) {
              return Number(item.variant_id || item.id) === Number(fittingIntent.carrierVariantId) &&
                Number(item.quantity) === choices[0].quantity && item.properties &&
                item.properties._mekhann_pilot_token === nativeBatch.token &&
                (nativeBatch.kind === 'grouped' ? item.properties._mekhann_grouped_batch === 'V1' && !item.parent_relationship : item.parent_relationship);
            });
            // An empty preflight cannot prove that the first Add retains its
            // cart token. Bind that parent result to a real Ajax cart before
            // carrying identity into the carrier step.
            if (!addError && newCarrierPurchase && !(nativeBatch && nativeBatch.kind === 'grouped') && exactNewReceipt && beforeCart.items.length > 0 && typeof transactionEngine.isOwnedMutationCurrent === 'function') {
              cart = theme.mekhannCartSections.fromAdd(response, beforeCart, function() {
                return status.loading && transactionEngine.isOwnedMutationCurrent(ownedToken);
              });
            }
            if (!cart) cart = await readCart();
            theme.mekhannCartSections.carry(response, cart);
          }
          catch (readError) {
            if (!addError && response) {
              accepted = (response.items || [response]).find(function(item) { return matches(item, choices[0]); });
              if (!nativeBatch) forget(attempt);
              warning = 'Item added. Your bag is taking a moment to refresh.';
              return;
            }
            throw message('We could not confirm whether this item was added. Please check your bag before trying again.');
          }
          var deltas = choices.map(function(choice, index) { return count(cart, choice) - before[index]; });
          if (deltas.some(function(delta) { return delta > 0; })) {
            if (!nativeBatch) forget(attempt);
            accepted = deltas[0] > 0 ? cart.items.find(function(item) { return matches(item, choices[0]); }) : null;
            if (!deltas.every(function(delta, index) { return delta === choices[index].quantity; })) {
              warning = 'Your bag was updated, but the items or quantities differ from your request. Please check your bag before continuing.';
            }
            if (!accepted) throw message(warning);
            return;
          }
          if (nativeBatch && addError && typeof transactionEngine.rejectNativeBatch === 'function' &&
              transactionEngine.rejectNativeBatch(ownedToken, nativeBatch, cart, addError.httpStatus, Boolean(addError.mekhannMutationUnknown))) {
            forget(attempt, true);
          }
          if (!nativeBatch && addError && !addError.mekhannMutationUnknown && [400, 404, 422].indexOf(addError.httpStatus) !== -1 && deltas.every(function(delta) { return delta === 0; })) forget(attempt);
          if (addError && addError.httpStatus === 422 && !addError.mekhannMutationUnknown &&
              /maximum quantity|already in your cart/i.test(addError.description || addError.message || '')) {
            var beforeRejectionFingerprint = rejectedCartFingerprint(beforeCart);
            if (beforeRejectionFingerprint && beforeRejectionFingerprint === rejectedCartFingerprint(cart)) unchangedMaximumCart = beforeRejectionFingerprint;
          }
          throw addError && addError.description ? addError : message('We could not confirm this item was added. Please check your bag, then try again.');
        };
        // One owner spans parent mutation, fitting reconciliation and final HTML.
        // Acquire it before the group queue to avoid waiting on our own operation.
        var operation = Promise.resolve().then(async function() {
          if (useOwnedTransaction) ownedToken = await transactionEngine.beginOwnedMutation({parentRecovery: Boolean(verificationOnly)});
          return groups && groups.run ? groups.run(task) : task();
        });
        var completion = operation.catch(function(error) { failure = error; }).then(async function() {
          if (ownedToken) {
            var result = null;
            var recoveredParentRead = false;
            try {
              // A verified add response can outlive a failed follow-up GET.
              // Recover by reading only, then settle the original fitting intent.
              // Never turn this known parent success into a second add request.
              if (accepted && !cart && !failure && (!status.uncertain.length || fittingIntent && fittingIntent.nativeBatch)) {
                cart = await readCart();
                recoveredParentRead = true;
              }
              if (!cart || failure) result = await transactionEngine.abortOwnedMutation(ownedToken, {uncertain: status.uncertain.length > 0});
              else result = await transactionEngine.settleOwnedMutation(ownedToken, {
                cart: cart, fitting: accepted && fitting && fittingIntent && !fittingIntent.edit ? fittingIntent : null
              });
            } catch (error) {
              if (accepted) warning = 'Your item has been added. ' + (fittingIntent && !fittingIntent.edit && Number(fittingIntent.carrierVariantId) > 0 ? 'We could not confirm the selected shade carrier. Please check your shopping bag.' : (error.description || error.message || 'Please refresh your bag before continuing.'));
              else failure = failure || error;
              try { result = await transactionEngine.abortOwnedMutation(ownedToken, {uncertain: status.uncertain.length > 0}); }
              catch (recoveryError) {
                cart = null;
                if (accepted) warning = fittingIntent && !fittingIntent.edit && Number(fittingIntent.carrierVariantId) > 0 ? 'Your item has been added. We could not confirm the selected shade carrier. Please refresh your shopping bag before continuing.' : 'Your item has been added. Please refresh your shopping bag before continuing.';
              }
            }
            if (result && result.cart) cart = result.cart;
            if (result && result.renderReceipt && transactionEngine.isRenderReceiptCurrent(result.renderReceipt)) {
              renderReceipt = result.renderReceipt;
              if (attempt && fittingIntent && fittingIntent.nativeBatch && result.nativeBatchResolved === fittingIntent.nativeBatch.token) {
                try { forget(attempt, true); }
                catch (storageError) { warning = 'Your items are in your bag, but this browser could not save the confirmation. Check the previous addition before adding more.'; }
              }
              if (recoveredParentRead && warning === 'Item added. Your bag is taking a moment to refresh.') warning = null;
            }
            if (result && result.warning) warning = result.warning;
            if (accepted && !renderReceipt && !warning) warning = 'Your item has been added. Please refresh your shopping bag before continuing.';
            ownedToken = null;
            parentLifecycleComplete = true;
            if (accepted && fitting && fittingIntent) fitting.settled(true, fittingIntent);
            return;
          }
          if (!accepted || !fitting || !fittingIntent || fittingIntent.edit) return;
          if (started) {
            if (cart) document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart, source: 'add-to-bag'}}));
            document.dispatchEvent(new CustomEvent('cart:mutation:complete', {detail: {cart: cart, source: 'add-to-bag', error: failure, unknown: !cart || status.uncertain.length > 0}}));
            parentLifecycleComplete = true;
          }
          try {
            var result = await fitting.afterAdded({product: accepted, cart: cart, intent: fittingIntent});
            if (result && result.cart) cart = result.cart;
            if (result && result.warning) warning = result.warning;
          } catch (error) {
            // The verified parent stays added. A carrier failure must never
            // encourage a second product addition or publish an obsolete cart.
            cart = error.cart || null;
            warning = 'Your lampshade has been added. ' + (error.description || error.message || 'We could not confirm the shade carrier. Please check your shopping bag.');
          }
          fitting.settled(true, fittingIntent);
        }).finally(function() {
          if (self.pendingCartThumbnail === cartThumbnailImage) self.pendingCartThumbnail = null;
          status.loading = false;
          if (carrierApi && carrierApi.setPurchaseBusy) carrierApi.setPurchaseBusy(false);
          self.addToCart.classList.remove('btn--loading');
          if (priorBusy == null) self.addToCart.removeAttribute('aria-busy');
          else self.addToCart.setAttribute('aria-busy', priorBusy);
          if (started && !parentLifecycleComplete) {
            if (cart) document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart, source: 'add-to-bag'}}));
            document.dispatchEvent(new CustomEvent('cart:mutation:complete', {detail: {cart: cart, source: 'add-to-bag', error: failure, unknown: !cart || status.uncertain.length > 0}}));
          }
          // Explicit read-only recovery may complete an earlier unverified
          // presentation. Match its original form and group; never release a
          // different purchase's loading state or reopen a closed drawer.
          var recoveryDrawer = theme.mekhannCartDrawer;
          var recoveryPresentation = recoveryDrawer && recoveryDrawer.pendingAddPresentation;
          if (!addPresentation && verificationOnly && fittingIntent && recoveryPresentation &&
              recoveryPresentation.phase === 'unverified' && recoveryPresentation.button === self.addToCart &&
              recoveryPresentation.parentGroupId === fittingIntent.parentGroupId && fittingIntent.parentGroupId &&
              recoveryPresentation.root.isConnected &&
              recoveryPresentation.root.getAttribute('data-mekhann-add-owner') === recoveryPresentation.id) {
            addPresentation = recoveryPresentation;
          }
          var addFeedbackHandled = Boolean(addPresentation && addPresentation.owner.finishPendingAdd(addPresentation, {
            renderReceipt: renderReceipt, cart: cart, accepted: Boolean(accepted), warning: warning, error: failure,
            unchangedMaximum: Boolean(unchangedMaximumCart && !status.uncertain.length &&
              unchangedMaximumCart === rejectedCartFingerprint(cart))
          }));
          if (accepted) {
            successOwner.success(accepted, cart, renderReceipt, useOwnedTransaction, addPresentation,
              Boolean(newAddRequested && !verificationOnly && !warning && !failure));
            // Browser-clock evidence for the owned submit-to-confirmed-drawer
            // path. Read-only DOM diagnostics avoid remote-click timing noise;
            // this is not a paint, input-latency or network-waterfall measure.
            if (renderReceipt && !warning && !failure && !verificationOnly &&
                transactionEngine && transactionEngine.isRenderReceiptCurrent(renderReceipt)) {
              self.form.setAttribute('data-mekhann-last-purchase', JSON.stringify({
                outcome: 'confirmed', elapsedMs: Math.round(purchaseClock() - purchaseStartedAt),
                presentation: 'verified-cart-only', build: 'V2.35-CART2-2026-09-22',
                clock: window.performance && typeof window.performance.now === 'function' ? 'performance' : 'date',
                carrierSelected: Boolean(fittingIntent && Number(fittingIntent.carrierVariantId) > 0),
                path: fittingIntent && fittingIntent.nativeBatch ? (fittingIntent.nativeBatch.version === 2 ? 'scoped-add' : fittingIntent.nativeBatch.kind === 'grouped' ? 'grouped-batch' : 'native-batch') : 'serial'
              }));
            }
            if (warning) self.error(message(warning));
            if (document.body.classList.contains('template-cart') || theme.settings.cartType !== 'drawer') {
              window.location.assign(theme.routes.cartPage || '/cart');
            }
          } else if (failure) self.error(failure, addFeedbackHandled);
        });
        if (traceEnd) completion = completion.finally(function() {
          if (traceQueue) traceQueue(failure ? 'error' : 'complete');
          traceEnd(renderReceipt && !warning && !failure ? 'complete' : 'error');
        });
        this.pendingAddition = completion;
        return completion;
      },

      success: function(product, cart, renderReceipt, ownedCart, addPresentation, revealAddedItem) {
        var errors = this.form.querySelector('.errors');
        if (errors) errors.remove();
        var detail = {product: product, cart: cart, addToCartBtn: this.addToCart,
          renderReceipt: renderReceipt || null, ownedCart: Boolean(ownedCart), addPresentation: addPresentation || null,
          revealAddedItem: Boolean(revealAddedItem)};
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: detail}));
        if (this.args && this.args.scopedEventId) document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {detail: detail}));
      },

      error: function(error, feedbackHandled) {
        var errors = this.form.querySelector('.errors');
        if (errors) errors.remove();
        var text = error.description || error.message || 'We could not check your bag. Please try again.';
        var maximum = error.httpStatus === 422 && /maximum quantity|already in your cart/i.test(text);
        if (maximum) text = 'This item is already at its available quantity in your shopping bag.';
        var notice = document.querySelector('[data-mekhann-site-notice][data-mekhann-v218-bound="true"]');
        if (feedbackHandled) {
          // The verified drawer owns this brief stock notice. Keep the public
          // error event below, without a second site notice or inline alert.
        } else if (maximum && notice) {
          document.dispatchEvent(new CustomEvent('mekhann:notice', {detail: {message: text, showCartLink: true}}));
        } else {
          var errorDiv = document.createElement('div');
          errorDiv.classList.add('errors', 'text-center');
          errorDiv.setAttribute('role', 'alert');
          if (error.mekhannCarrierValidation === 'choice') {
            errorDiv.setAttribute('data-mekhann-carrier-validation', 'choice');
          }
          if (error.mekhannNativeBatchToken && status.uncertain.filter(function(prior) {
            return prior.fittingIntent && prior.fittingIntent.nativeBatch &&
              prior.fittingIntent.nativeBatch.token === error.mekhannNativeBatchToken;
          }).length === 1) {
            errorDiv.setAttribute('data-mekhann-native-error-token', error.mekhannNativeBatchToken);
          }
          errorDiv.textContent = text;
          if (status.uncertain.length) {
            var self = this;
            var actions = document.createElement('div');
            var check = document.createElement('button');
            check.type = 'button';
            check.className = 'btn btn--tertiary btn--small';
            check.textContent = 'Check previous addition';
            check.addEventListener('click', function() {
              self.addItemFromForm({preventDefault: function() {}}, true);
            });
            var cartLink = document.createElement('a');
            cartLink.href = theme.routes.cartPage || '/cart';
            cartLink.textContent = 'View shopping bag';
            actions.append(check, document.createTextNode(' '), cartLink);
            errorDiv.append(actions);
          }
          this.form.append(errorDiv);
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {detail: {errorMessage: text}}));
        if (this.args && this.args.scopedEventId) document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {detail: {errorMessage: text}}));
      }
    });

    // Covers dynamically inserted native forms before Product.init has run.
    // Already-bound forms preventDefault themselves, so the same submit cannot run twice.
    document.addEventListener('submit', function(evt) {
      var form = evt.target;
      if (evt.defaultPrevented || !form || !form.matches('.product-single__form') || !form.querySelector('.add-to-cart')) return;
      new ProductForm(form).addItemFromForm(evt);
    });
    return ProductForm;
  })();

  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
      var maxValue = this.input.getAttribute('max');
      this.maxValue = maxValue !== null ? parseInt(maxValue) : null;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);

      // A stock flag belongs to this selector; an inherited disable does not.
      this.plusIndependentDisabled = this.plus.disabled && !this.plus.hasAttribute('data-mekhann-stock-limited') && !this.plus.hasAttribute('data-mekhann-carrier-busy-lock');
      this.plusIndependentAria = this.plus.getAttribute('aria-disabled') === 'true' && !this.plus.hasAttribute('data-mekhann-stock-limited') && !this.plus.hasAttribute('data-mekhann-carrier-busy-lock');
      this.wrapper.__mekhannQtySelector = this;
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.updateButtonState(this._getQty());

        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1, true);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty, attemptedIncrease) {
        if (this.options.isCart) {
          if (attemptedIncrease && this.plus.disabled) return;
          var groups = theme.mekhannCartGroups;
          var carrier = window.MekhannCarrierPilotV2193;
          var queueAfterExtras = carrier && typeof carrier.canQueueQuantityAfterExtras === 'function' && carrier.canQueueQuantityAfterExtras();
          if (!queueAfterExtras && (groups && groups.pending() || carrier && typeof carrier.isBusy === 'function' && carrier.isBusy())) return;
        }
        var currentQty = this._getQty();

        // A lower stock limit may arrive after the buyer added these units.
        // Activating Plus must never clamp an existing quantity down or remove
        // the row. Only the buyer's decrease/remove action may reduce it.
        if (this.options.isCart && attemptedIncrease && this.maxValue !== null && currentQty >= this.maxValue) {
          this.updateButtonState(currentQty);
          return;
        }

        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        // Keep a cart Minus as one explicit step even when stock has fallen
        // below the existing bag. Shopify still decides whether to accept it.
        if (this.maxValue !== null && qty > this.maxValue &&
            !(this.options.isCart && qty < currentQty)) {
          qty = this.maxValue;
        }

        this.input.value = qty;
        this.updateButtonState(qty);

        if (qty === currentQty) {
          return;
        }

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper, attemptedIncrease ? {source: 'plus', previousQuantity: currentQty} : null]
          }));
        } else if (Number(qty) !== currentQty) {
          // Native +/- does not emit input/change when it writes .value.
          // Notify presentation consumers without re-entering mutation logic.
          this.input.dispatchEvent(new CustomEvent('mekhann:product-quantity', {
            bubbles: true, detail: { quantity: Number(qty) }
          }));
        }
      },

      showQuantityLimitFeedback: function(isCurrent) {
        var row = this.wrapper.closest('.cart__item');
        var notice = row && row.querySelector('[data-mekhann-quantity-notice]');
        if (!notice) return;
        if (notice.mekhannLimitTimer) window.clearTimeout(notice.mekhannLimitTimer);
        if (notice.mekhannLimitAnnounceTimer) window.clearTimeout(notice.mekhannLimitAnnounceTimer);
        notice.textContent = '';
        notice.hidden = false;
        // This is called only after the originating operation's current proof.
        // Recheck before the polite announcement; a close/new operation cancels it.
        notice.mekhannLimitAnnounceTimer = window.setTimeout(function() {
          notice.mekhannLimitAnnounceTimer = null;
          if (!notice.isConnected || isCurrent && !isCurrent()) { notice.hidden = true; return; }
          notice.textContent = 'Maximum quantity reached.';
          notice.mekhannLimitTimer = window.setTimeout(function() {
            notice.mekhannLimitTimer = null;
            notice.hidden = true;
            notice.textContent = '';
          }, 2500);
        }, 30);
      },

      updateButtonState: function(qty) {
        if (this.maxValue === null) {
          return;
        }

        var atMaximum = qty >= this.maxValue;
        if (this.options.isCart) {
          var ownedStock = this.plus.hasAttribute('data-mekhann-stock-limited');
          if (atMaximum) {
            this.plus.setAttribute('data-mekhann-stock-limited', 'true');
            this.plus.disabled = true;
          } else {
            this.plus.removeAttribute('data-mekhann-stock-limited');
            if (ownedStock && !this.plusIndependentDisabled && !this.plus.hasAttribute('data-mekhann-carrier-busy-lock')) this.plus.disabled = false;
          }
          this.plus.setAttribute('aria-disabled', atMaximum || this.plusIndependentAria ? 'true' : 'false');
        } else {
          this.plus.disabled = atMaximum;
          this.plus.setAttribute('aria-disabled', atMaximum ? 'true' : 'false');
        }
      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');
  
    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      // Lampshades use the card carousel as their PLP preview. Their modal
      // duplicated variant/media state and could not represent an inferred
      // support image safely, so Quick Preview is intentionally disabled.
      if (product.classList.contains('grid-product--lampshades')) {
        return;
      }

      product.addEventListener('mouseover', productMouseover);
      product.addEventListener('focusin', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var productModalUrl = el.dataset.productModalUrl;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn, productModalUrl);
      }
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn, productModalUrl) {
    if (btn && btn.mekhannPreloadPromise) {
      return btn.mekhannPreloadPromise;
    }

    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = productModalUrl || theme.routes.home + '/products/' + handle;
    url += url.indexOf('?') === -1 ? '?view=modal' : '&view=modal';
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    var preloadPromise = fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const div = html.querySelector('.product-section[data-product-handle="'+handle+'"]');
  
      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // A Lampshades card swatch can be selected while Quick Preview is
      // preloading. Re-apply that card state after the modal markup is ready.
      var gridItem = btn ? btn.closest('.grid-product') : null;
      if (!gridItem) {
        gridItem = document.querySelector('.grid-product[data-product-id="' + productId + '"]');
      }
      theme.syncGridQuickShopVariant(gridItem, holder);

      if (holder.dataset.mekhannVariantSyncBound !== 'true') {
        holder.dataset.mekhannVariantSyncBound = 'true';
        document.addEventListener('quickview:loaded', function(evt) {
          if (String(evt.detail.productId) !== String(productId)) {
            return;
          }

          theme.syncGridQuickShopVariant(gridItem, holder);
          if (holder.dataset.mekhannPreparingOpen !== 'true') {
            theme.beginQuickShopPreparation(gridItem, holder, productId);
          }
        });
      }
  
      // Register collapsible elements
      theme.collapsibles.init();
  
      // Register potential video modal links (when video has sound)
      theme.videoModal();
  
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    }).catch(function(error) {
      if (btn) {
        btn.mekhannPreloadPromise = null;
      }
      console.warn('Unable to preload Quick Preview', error);
      throw error;
    });

    if (btn) {
      btn.mekhannPreloadPromise = preloadPromise;
    }

    return preloadPromise;
  }

  theme.prepareQuickShopOpen = function(gridItem, btn) {
    if (!gridItem || !btn) {
      return Promise.resolve(false);
    }

    if (btn.mekhannPrepareOpenPromise) {
      return btn.mekhannPrepareOpenPromise;
    }

    var handle = gridItem.dataset.productHandle;
    var productId = gridItem.dataset.productId;
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var modal = document.getElementById('QuickShopModal-' + productId);

    function resetPreparationSurface() {
      if (holder) {
        holder.dataset.mekhannPreparingOpen = 'false';
      }

      if (modal) {
        modal.classList.remove('modal--is-active');
        modal.style.removeProperty('visibility');
        modal.style.removeProperty('pointer-events');
      }
    }

    btn.mekhannPrepareOpenPromise = theme.preloadProductModal(
      handle,
      productId,
      btn,
      gridItem.dataset.productModalUrl
    ).then(function() {
      holder = document.getElementById('QuickShopHolder-' + handle);
      modal = document.getElementById('QuickShopModal-' + productId);

      if (!holder || !modal) {
        throw new Error('Quick Preview holder or modal is missing');
      }

      // Give the hidden modal a real layout box so Flickity can initialise and
      // the selected image can load without exposing an unfinished modal.
      holder.dataset.mekhannPreparingOpen = 'true';
      modal.style.visibility = 'hidden';
      modal.style.pointerEvents = 'none';
      modal.classList.add('modal--is-active');

      theme.syncGridQuickShopVariant(gridItem, holder);

      var productSection = holder.querySelector('.product-section');
      var productInstance = productSection && productSection.mekhannProductInstance;
      if (!productInstance) {
        throw new Error('Quick Preview product controller is missing');
      }

      productInstance.openModalProduct();
      return theme.beginQuickShopPreparation(gridItem, holder, productId);
    }).then(function(success) {
      resetPreparationSurface();
      btn.mekhannPrepareOpenPromise = null;
      return success;
    }).catch(function(error) {
      resetPreparationSurface();
      btn.mekhannPrepareOpenPromise = null;
      console.warn('Unable to prepare Quick Preview', error);
      throw error;
    });

    return btn.mekhannPrepareOpenPromise;
  };

  theme.syncGridQuickShopVariant = function(gridItem, holder) {
    if (!gridItem || !holder || !gridItem.dataset.selectedVariantId) {
      return;
    }

    var variantJson = holder.querySelector('[data-variant-json]');
    if (!variantJson) {
      return;
    }

    var variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (error) {
      console.warn('Unable to read Quick Preview variant data', error);
      return;
    }

    var selectedVariantId = parseInt(gridItem.dataset.selectedVariantId, 10);
    var selectedVariant = variants.find(function(variant) {
      return variant.id === selectedVariantId;
    });

    if (!selectedVariant) {
      return;
    }

    if (gridItem.dataset.selectedMediaId) {
      holder.dataset.mekhannSelectedMediaId = gridItem.dataset.selectedMediaId;
    } else if (selectedVariant.featured_media) {
      holder.dataset.mekhannSelectedMediaId = selectedVariant.featured_media.id;
    }

    // Quick Preview loads its product form only after the modal opens. Keep
    // that deferred request aligned with a swatch chosen on the PLP so the
    // first modal open does not fall back to the variant used at preload time.
    var blocksHolder = holder.querySelector('[data-blocks-holder]');
    if (blocksHolder && gridItem.dataset.selectedVariantUrl) {
      blocksHolder.dataset.url = gridItem.dataset.selectedVariantUrl;
    }

    var triggerInput = null;

    selectedVariant.options.forEach(function(value, index) {
      var optionIndex = 'option' + (index + 1);
      var optionInputs = holder.querySelectorAll('[data-variant-input][data-index="' + optionIndex + '"]');

      optionInputs.forEach(function(input) {
        if (input.tagName === 'SELECT') {
          input.value = value;
          triggerInput = input;
        } else if (input.value === value) {
          input.checked = true;
          triggerInput = input;
        }
      });
    });

    if (triggerInput) {
      triggerInput.dispatchEvent(new Event('change', {bubbles: true}));
      return;
    }

    var masterSelect = holder.querySelector('[data-product-select]');
    if (masterSelect) {
      masterSelect.value = selectedVariant.id;
      masterSelect.dispatchEvent(new Event('change', {bubbles: true}));
    }
  };

  theme.beginQuickShopPreparation = function(gridItem, holder, productId) {
    if (!gridItem || !holder || !gridItem.dataset.selectedVariantId) {
      return Promise.resolve(false);
    }

    var modal = document.getElementById('QuickShopModal-' + productId);
    if (!modal) {
      return Promise.resolve(false);
    }

    var token = String((parseInt(modal.dataset.mekhannPrepareToken || '0', 10) || 0) + 1);
    modal.dataset.mekhannPrepareToken = token;
    modal.classList.remove('mekhann-quick-preview--failed');
    modal.classList.add('mekhann-quick-preview--preparing');
    modal.setAttribute('aria-busy', 'true');

    theme.syncGridQuickShopVariant(gridItem, holder);
    return theme.alignQuickShopVariant(gridItem, holder, modal, token);
  };

  theme.alignQuickShopVariant = function(gridItem, holder, modal, token) {
    var attempts = 0;
    var maxAttempts = 100;

    if (modal.mekhannQuickPrepareTimer) {
      window.clearTimeout(modal.mekhannQuickPrepareTimer);
    }

    return new Promise(function(resolve) {
      var finished = false;

      function finish(success) {
        if (finished) {
          return;
        }

        finished = true;
        var tokenIsCurrent = String(modal.dataset.mekhannPrepareToken) === String(token);

        if (tokenIsCurrent) {
          modal.classList.toggle('mekhann-quick-preview--failed', !success);
          modal.classList.remove('mekhann-quick-preview--preparing');
          modal.setAttribute('aria-busy', 'false');
          modal.mekhannQuickPrepareTimer = null;
        }

        resolve(success && tokenIsCurrent);
      }

      function attemptAlignment() {
        if (String(modal.dataset.mekhannPrepareToken) !== String(token)) {
          finish(false);
          return;
        }

        attempts += 1;

        // Read the latest card state on every attempt so a swatch change made
        // during preparation cannot open a stale variant.
        var expectedVariantId = String(gridItem.dataset.selectedVariantId || '');
        var expectedMediaId = String(holder.dataset.mekhannSelectedMediaId || '');

        var productSection = holder.querySelector('.product-section');
        var productInstance = productSection && productSection.mekhannProductInstance;
        var blocksHolder = holder.querySelector('[data-blocks-holder]');
        var blocksReady = !!blocksHolder && blocksHolder.classList.contains('product-form-holder--loaded');
        var mainSlider = holder.querySelector('[data-product-photos]');
        var currentVariantId = productInstance && productInstance.variants && productInstance.variants.currentVariant ?
          String(productInstance.variants.currentVariant.id) : '';
        var masterSelect = holder.querySelector('[data-product-select]');
        var variantReady = currentVariantId === expectedVariantId ||
          (masterSelect && String(masterSelect.value) === expectedVariantId);

        if ((!blocksReady || !variantReady) && (attempts === 1 || attempts % 8 === 0)) {
          theme.syncGridQuickShopVariant(gridItem, holder);
        }

        var selectedMediaReady = expectedMediaId === '';
        var selectedImageReady = expectedMediaId === '';

        if (mainSlider && expectedMediaId !== '') {
          var expectedSlide = mainSlider.querySelector('.product-main-slide[data-media-id="' + expectedMediaId + '"]');
          var visibleSlides = Array.from(mainSlider.querySelectorAll('.flickity-slider .product-main-slide'));

          if (!visibleSlides.length) {
            visibleSlides = Array.from(mainSlider.querySelectorAll(':scope > .product-main-slide'));
          }

          var expectedIndex = visibleSlides.indexOf(expectedSlide);
          var selectedSlide = mainSlider.querySelector('.product-main-slide.is-selected');

          if (productInstance && productInstance.flickity && expectedIndex >= 0 &&
              (!selectedSlide || String(selectedSlide.dataset.mediaId) !== expectedMediaId)) {
            productInstance.flickity.goToSlide(expectedIndex);
            selectedSlide = mainSlider.querySelector('.product-main-slide.is-selected');
          }

          selectedMediaReady = !!selectedSlide && String(selectedSlide.dataset.mediaId) === expectedMediaId;

          var expectedImage = expectedSlide && expectedSlide.querySelector('img');
          if (expectedImage) {
            expectedImage.loading = 'eager';
            selectedImageReady = expectedImage.complete && expectedImage.naturalWidth > 0;
          }
        }

        if (blocksReady && variantReady && selectedMediaReady && selectedImageReady) {
          window.requestAnimationFrame(function() {
            finish(true);
          });
          return;
        }

        if (attempts >= maxAttempts) {
          finish(false);
          return;
        }

        modal.mekhannQuickPrepareTimer = window.setTimeout(attemptAlignment, 80);
      }

      attemptAlignment();
    });
  };
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
      this.listeners = [];
      this.destroyed = false;
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';
  
          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.listen(this.pauseBtn, 'click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      this.listen(window, 'resize', theme.utils.debounce(300, function() {
        if (!this.destroyed) this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      // A filtered gallery is recreated on colour/size boundaries. Every
      // wrapper-owned listener must leave with that instance.
      listen: function(target, event, handler) {
        target.addEventListener(event, handler);
        this.listeners.push({ target: target, event: event, handler: handler });
      },
      unlisten: function(target, event, handler) {
        target.removeEventListener(event, handler);
        this.listeners = this.listeners.filter(function(listener) {
          return listener.target !== target || listener.event !== event || listener.handler !== handler;
        });
      },
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          var outgoingSlide = this.currentSlide;
          var clearOutgoing = function() {
            outgoingSlide.classList.remove(classes.animateOut);
            this.unlisten(outgoingSlide, 'transitionend', clearOutgoing);
          }.bind(this);
          this.listen(outgoingSlide, 'transitionend', clearOutgoing);
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.listeners.forEach(function(listener) {
          listener.target.removeEventListener(listener.event, listener.handler);
        });
        this.listeners = [];
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
  
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        var initialLink = this.childNavLinks[this.args.initialIndex] || this.childNavLinks[0];
        if (initialLink) initialLink.classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          this.listen(link, 'click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          this.listen(link, 'focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          this.listen(link, 'keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            this.listen(arrow, 'click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        if (!el) return;
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
  
        // Set default state based on current selected variant
        this.setInitialAvailability();
      },
  
      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {
  
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }
  
            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
  
            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })
  
          return options;
        }, { option1: [], option2: [], option3: []})
      },
  
      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);
  
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },
  
      setAvailability: function(evt) {
  
        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;
  
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },
  
      manageOptionState: function(option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },
  
      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="'+ value +'"]').disabled = true;
          } else {
            group.querySelector('option[value="'+ value +'"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');
  
          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);
  
          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
    var vimeoPlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  
  /*============================================================================
    ToolTip
  ==============================================================================*/
  
  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');
  
      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
  
      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }
  
    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;
  
      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }
  
      this._lockScrolling();
  
      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }
  
      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });
  
      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }
  
    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';
  
      this._unlockScrolling();
  
      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }
  
    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }
  
    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }
  
  customElements.define('tool-tip', ToolTip);
  
  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/
  
  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }
  
    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });
  
      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }
  
  customElements.define('tool-tip-trigger', ToolTipTrigger);
  
  /*============================================================================
    NewsletterReminder
  ==============================================================================*/
  
  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');
  
      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
  
      this.init();
    }
  
    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });
  
      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });
  
      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));
  
      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });
  
      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);
  
        this.hide();
      });
    }
  
    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }
  
    hide() {
      this.dataset.enabled = 'false';
    }
  }
  
  customElements.define('newsletter-reminder', NewsletterReminder);
  
  /*============================================================================
    ImageElement
  ==============================================================================*/
  
  class ImageElement extends HTMLElement {
    constructor() {
      super();
  
      this.init();
    }

    connectedCallback() {
      // A retired PLP node may be reconnected by the section lifecycle. Normal
      // Flickity moves keep their existing observer; completed images stay done.
      this.init();
    }

    mekhannDisposeObserver() {
      if (!this.mekhannImageObserver) return;
      this.mekhannImageObserver.disconnect();
      this.mekhannImageObserver = null;
    }
  
    init() {
      if (this.mekhannImageObserver || this.mekhannImageObserved) return;
  
      const handleIntersection = (entries, observer) => {
        if (this.mekhannImageObserver !== observer) return;
        if (!this.isConnected) { this.mekhannDisposeObserver(); return; }
        if (!entries[0].isIntersecting) return;
  
        this.removeAnimations();
  
        observer.unobserve(this);
        this.mekhannImageObserver = null;
        this.mekhannImageObserved = true;
      }
  
      // Set an IntersectionObserver to check if the image is nearly in the viewport
      this.mekhannImageObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'});
      this.mekhannImageObserver.observe(this);
    }
  
    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');
  
      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }
  
      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }
  
  customElements.define('image-element', ImageElement);
  
  /*============================================================================
    PredictiveSearch
  ==============================================================================*/
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;
  
      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');
  
        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
  
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 3,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };
  
      const params = this.paramUrl(searchObj);
  
      fetch(`/search/suggest?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
  
          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
      document.body.classList.add('predictive-overflow-hidden');
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
  
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.CartDrawer = (function() {
    var pendingAddSequence = 0;
    var presentedAdds = new WeakSet();
    function cartContentsFingerprint(cart) {
      if (!cart || !Array.isArray(cart.items) || typeof cart.currency !== 'string') return '';
      return JSON.stringify({ currency: cart.currency, total: cart.total_price,
        items: cart.items.map(function(item) {
          return [item.key, Number(item.variant_id || item.id), Number(item.quantity), item.final_line_price];
        }).sort(function(a, b) { return String(a[0]).localeCompare(String(b[0])); }) });
    }
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      if (!this.form) return;
      var previous = theme.mekhannCartDrawer;
      if (previous && !previous.destroyed && previous.form === this.form) return previous;
      if (previous && typeof previous.destroy === 'function') previous.destroy();
      theme.mekhannCartDrawer = this;
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.revealedAddEvents = new WeakSet();
        this.cartForm.buildCart();
  
        this.addedListener = function(evt) {
          if (this.destroyed || !this.form.isConnected) return;
          var detail = evt.detail || {};
          var carrier = window.MekhannCarrierPilotV2193;
          if (detail.ownedCart) {
            // The transaction already rendered every mounted cart surface.
            // Do not show an unconfirmed cart or issue a second HTML request.
            if (carrier && typeof carrier.isRenderReceiptCurrent === 'function' && carrier.isRenderReceiptCurrent(detail.renderReceipt)) {
              // Completion never reopens a drawer the customer has closed.
              if (!presentedAdds.has(detail.addPresentation)) this.open(evt);
              this.revealConfirmedAddition(detail);
            } else {
              var form = detail.addToCartBtn && detail.addToCartBtn.closest('form');
              if (form && form.__mekhannAjaxProduct) form.__mekhannAjaxProduct.error({
                description: 'Your item has been added. Please refresh your shopping bag before continuing.'
              });
            }
            return;
          }
          // Non-carrier/legacy product integrations still wait for actual HTML;
          // opening first would briefly display an empty or previous bag.
          this.cartForm.buildCart().then(function(rendered) {
            if (rendered) this.open(evt);
            else {
              var form = detail.addToCartBtn && detail.addToCartBtn.closest('form');
              if (form && form.__mekhannAjaxProduct) form.__mekhannAjaxProduct.error({
                description: 'Your item has been added. Please refresh your shopping bag before continuing.'
              });
            }
          }.bind(this));
        }.bind(this);
        document.addEventListener('ajaxProduct:added', this.addedListener);
  
        // Dev-friendly way to open cart
        this.openListener = this.open.bind(this);
        this.closeListener = this.close.bind(this);
        this.limitFeedbackListener = function() {
          this.cartForm.quantityFeedbackSession += 1;
          this.cartForm.clearQuantityLimitFeedback();
          this.clearTransientAddFeedback();
        }.bind(this);
        this.addFeedbackCloseListener = this.clearTransientAddFeedback.bind(this);
        document.addEventListener('cart:open', this.openListener);
        document.addEventListener('cart:close', this.closeListener);
        document.addEventListener('drawerOpen.CartDrawer', this.limitFeedbackListener);
        document.addEventListener('drawerClose.CartDrawer', this.addFeedbackCloseListener);
        document.dispatchEvent(new CustomEvent('mekhann:cart:mounted', {detail: {form: this.form, drawer: this.drawer.drawer}}));
      },

      // MC-ADD-VISIBILITY-01: only a fresh, confirmed Add may reveal its row.
      // Quantity/Remove renders retain their existing scroll/focus contract.
      revealConfirmedAddition: function(detail) {
        var root = this.drawer && this.drawer.drawer;
        var engine = window.MekhannCarrierPilotV2193;
        var groups = theme.mekhannCartGroups;
        if (!detail || !detail.revealAddedItem || !detail.ownedCart || !detail.product ||
            this.destroyed || !this.form.isConnected || !root || !root.isConnected ||
            !engine || !engine.isRenderReceiptCurrent(detail.renderReceipt) || !groups ||
            this.revealedAddEvents.has(detail)) return;
        this.revealedAddEvents.add(detail);
        // A completion must not reopen a panel the buyer closed, or interrupt
        // a note the buyer deliberately started while the request settled.
        var active = document.activeElement;
        if (!this.drawer.isOpen || root.getAttribute('aria-hidden') === 'true' ||
            root.classList.contains('mekhann-cart-editing') || active && root.contains(active) &&
            active.matches('textarea, input:not([readonly]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"])')) return;
        var rows = Array.prototype.filter.call(this.form.querySelectorAll('[data-mekhann-cart-group]'), function(row) {
          if (row.closest('[hidden], [inert]')) return false;
          try { return groups.equivalent(JSON.parse(row.dataset.mekhannCartGroup), detail.product); }
          catch (ignore) { return false; }
        });
        if (rows.length !== 1) return;
        var narrow = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 999px)').matches : window.innerWidth <= 999;
        var shortScreen = typeof window.matchMedia === 'function' ? window.matchMedia('(max-height: 600px)').matches : window.innerHeight <= 600;
        var scroller = root.querySelector(narrow || shortScreen ? '.drawer__inner' : '.drawer__scrollable');
        if (!scroller || !scroller.contains(rows[0])) return;
        var viewport = window.visualViewport;
        var viewportTop = viewport ? viewport.offsetTop : 0;
        var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
        var bounds = scroller.getBoundingClientRect(), target = rows[0].getBoundingClientRect();
        var top = Math.max(bounds.top, viewportTop) + 12;
        var bottom = Math.min(bounds.bottom, viewportBottom) - 12;
        if (bottom <= top || !target.height) return;
        var delta = target.height > bottom - top || target.top < top ? target.top - top :
          target.bottom > bottom ? target.bottom - bottom : 0;
        // Never scrollIntoView: that could also move the page behind the drawer.
        if (Math.abs(delta) > 1) scroller.scrollTop = Math.max(0, scroller.scrollTop + delta);
      },

      beginPendingAdd: function(button, parentGroupId) {
        var root = this.drawer && this.drawer.drawer;
        var feedback = root && root.querySelector('[data-mekhann-add-feedback]');
        var message = feedback && feedback.querySelector('[data-mekhann-add-message]');
        var checkout = this.form && this.form.querySelector('[name="checkout"]');
        if (this.destroyed || !this.form || !this.form.isConnected || !root || !feedback || !message || !checkout) return null;
        if (this.pendingAddPresentation && this.pendingAddPresentation.phase === 'pending') return null;
        if (this.pendingAddPresentation) this.releasePendingAdd(this.pendingAddPresentation);
        this.clearTransientAddFeedback();
        this.completedAddFeedback = null;
        var presentation = {
          id: 'add-' + (++pendingAddSequence), owner: this, root: root, feedback: feedback,
          button: button, parentGroupId: parentGroupId || '',
          message: message, refresh: feedback.querySelector('[data-mekhann-add-refresh]'), checkout: checkout,
          phase: 'pending', independentDisabled: checkout.disabled && !checkout.hasAttribute('data-mekhann-carrier-server-lock') &&
            !checkout.hasAttribute('data-mekhann-checkout-pending-lock') && !checkout.hasAttribute('data-mekhann-checkout-verification-lock'),
          serverLockAtStart: checkout.hasAttribute('data-mekhann-carrier-server-lock'),
          priorAriaDisabled: checkout.hasAttribute('data-mekhann-checkout-pending-lock') ? null : checkout.getAttribute('aria-disabled'),
          panels: Array.prototype.map.call(root.querySelectorAll('.drawer__inner, .drawer__cart-empty'), function(panel) {
            return {node: panel, inert: panel.hasAttribute('inert')};
          })
        };
        this.pendingAddPresentation = presentation;
        presentedAdds.add(presentation);
        root.setAttribute('data-mekhann-add-owner', presentation.id);
        root.setAttribute('data-mekhann-add-state', 'pending');
        feedback.hidden = false;
        this.presentAddStatus(presentation, 'Adding to your shopping bag…', 'pending');
        if (presentation.refresh) presentation.refresh.hidden = true;
        presentation.panels.forEach(function(panel) { panel.node.setAttribute('inert', ''); });
        // Never set aria-busy on the form: the cart engine treats it as a
        // competing mutation lock. This separate marker owns presentation only.
        checkout.setAttribute('data-mekhann-add-checkout-lock', presentation.id);
        checkout.disabled = true;
        checkout.setAttribute('aria-disabled', 'true');
        this.drawer.open(null, button);
        return presentation;
      },

      releasePendingAdd: function(presentation) {
        if (!presentation || this.pendingAddPresentation !== presentation) return;
        var root = presentation.root, checkout = presentation.checkout;
        if (root.getAttribute('data-mekhann-add-owner') === presentation.id) {
          root.removeAttribute('data-mekhann-add-owner');
          root.removeAttribute('data-mekhann-add-state');
          presentation.feedback.hidden = true;
          this.presentAddStatus(presentation, '', 'success');
          presentation.panels.forEach(function(panel) { if (!panel.inert) panel.node.removeAttribute('inert'); });
        }
        if (checkout.getAttribute('data-mekhann-add-checkout-lock') === presentation.id) {
          checkout.removeAttribute('data-mekhann-add-checkout-lock');
          if (!presentation.independentDisabled && !checkout.hasAttribute('data-mekhann-carrier-server-lock') &&
              !checkout.hasAttribute('data-mekhann-checkout-pending-lock') && !checkout.hasAttribute('data-mekhann-checkout-verification-lock')) {
            checkout.disabled = false;
            if (!presentation.serverLockAtStart && presentation.priorAriaDisabled !== null) checkout.setAttribute('aria-disabled', presentation.priorAriaDisabled);
            else checkout.removeAttribute('aria-disabled');
          } else if (presentation.priorAriaDisabled !== null) {
            checkout.setAttribute('aria-disabled', presentation.priorAriaDisabled);
          }
        }
        this.pendingAddPresentation = null;
      },

      presentAddStatus: function(presentation, message, kind) {
        var engine = window.MekhannCarrierPilotV2193;
        if (engine && typeof engine.presentStatus === 'function') {
          engine.presentStatus(presentation.message, message, kind, 'Your addition is taking longer to confirm.');
        } else {
          presentation.message.textContent = message || '';
          presentation.message.hidden = !message;
          presentation.message.setAttribute('data-mekhann-status-kind', kind);
        }
      },

      retireCompletedAddFeedback: function(cart, receipt) {
        var previous = this.completedAddFeedback;
        var engine = window.MekhannCarrierPilotV2193;
        var fingerprint = cartContentsFingerprint(cart);
        if (!previous || this.pendingAddPresentation || this.destroyed || !this.form.isConnected ||
            !engine || !engine.isRenderReceiptCurrent(receipt) || !fingerprint || fingerprint === previous.fingerprint ||
            previous.message.textContent !== previous.text || previous.message.getAttribute('data-mekhann-status-kind') !== 'error') return;
        if (previous.transient) { this.clearTransientAddFeedback(); return; }
        this.presentAddStatus(previous, '', 'success');
        previous.feedback.hidden = true;
        this.completedAddFeedback = null;
      },

      clearTransientAddFeedback: function() {
        var previous = this.completedAddFeedback;
        if (!previous || !previous.transient) return;
        if (previous.timer) window.clearTimeout(previous.timer);
        previous.timer = null;
        // A stale timer must not erase a new pending or unresolved message.
        if (!this.pendingAddPresentation && previous.message.isConnected &&
            previous.message.textContent === previous.text && previous.message.getAttribute('data-mekhann-status-kind') === 'error') {
          this.presentAddStatus(previous, '', 'success');
          previous.feedback.hidden = true;
        }
        this.completedAddFeedback = null;
      },

      finishPendingAdd: function(presentation, result) {
        if (this.destroyed || !this.form.isConnected || this.pendingAddPresentation !== presentation ||
            presentation.root.getAttribute('data-mekhann-add-owner') !== presentation.id) return;
        result = result || {};
        var engine = window.MekhannCarrierPilotV2193;
        var verified = Boolean(engine && engine.isRenderReceiptCurrent(result.renderReceipt));
        var message = result.warning || result.error && (result.error.description || result.error.message) || '';
        if (!verified) {
          presentation.phase = 'unverified';
          presentation.root.setAttribute('data-mekhann-add-state', 'unverified');
          this.presentAddStatus(presentation, message || 'Your bag could not be confirmed. Refresh your shopping bag before trying again.', 'error');
          if (presentation.refresh) presentation.refresh.hidden = false;
          // Keep this presentation lock, and all existing engine uncertainty.
          // The refresh link reads the bag; it never replays the Add request.
          return;
        }
        presentation.phase = 'complete';
        this.releasePendingAdd(presentation);
        var transientMaximum = Boolean(result.unchangedMaximum && result.error && result.error.httpStatus === 422 &&
          !result.error.mekhannMutationUnknown && !result.accepted && !result.warning &&
          /maximum quantity|already in your cart/i.test(message));
        if (transientMaximum) message = 'Available quantity is already in your bag.';
        this.presentAddStatus(presentation, message, 'error');
        presentation.feedback.hidden = !message;
        var fingerprint = cartContentsFingerprint(result.cart);
        // Only a completed rejected Add can become obsolete after a later
        // successful cart-content change. Uncertain writes and accepted-Add
        // warnings retain their own recovery/message lifecycle.
        if (message && result.error && !result.accepted && !result.warning && fingerprint) {
          this.completedAddFeedback = { message: presentation.message, feedback: presentation.feedback, text: message, fingerprint: fingerprint };
          if (transientMaximum) {
            var owner = this, completed = this.completedAddFeedback;
            completed.transient = true;
            completed.timer = window.setTimeout(function() {
              if (owner.completedAddFeedback === completed && !owner.destroyed && owner.form.isConnected) owner.clearTransientAddFeedback();
            }, 2500);
            if (!this.drawer.isOpen) this.clearTransientAddFeedback();
          }
        }
        if (presentation.refresh) presentation.refresh.hidden = true;
        // Deliberately no open(): the buyer may have closed this drawer.
        return transientMaximum;
      },

      destroy: function() {
        if (this.destroyed) return;
        this.clearTransientAddFeedback();
        // Teardown removes only the presentation's own lock. The transaction
        // engine continues to own its ledger, checkout gate and render proof.
        if (this.pendingAddPresentation) this.releasePendingAdd(this.pendingAddPresentation);
        this.destroyed = true;
        document.removeEventListener('ajaxProduct:added', this.addedListener);
        document.removeEventListener('cart:open', this.openListener);
        document.removeEventListener('cart:close', this.closeListener);
        document.removeEventListener('drawerOpen.CartDrawer', this.limitFeedbackListener);
        document.removeEventListener('drawerClose.CartDrawer', this.addFeedbackCloseListener);
        if (this.cartForm && typeof this.cartForm.destroy === 'function') this.cartForm.destroy();
        if (this.drawer && typeof this.drawer.destroy === 'function') this.drawer.destroy();
        if (theme.mekhannCartDrawer === this) theme.mekhannCartDrawer = null;
      },
  
      open: function(evt) {
        if (this.destroyed || !this.form.isConnected) return;
        var detail = evt && evt.detail;
        var source = detail && (detail.addToCartBtn || detail.returnFocusEl);
        this.drawer.open(null, source);
      },
  
      close: function() {
        if (this.destroyed) return;
        this.drawer.close();
      }
    });
  
    return CartDrawer;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
  
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }
  
      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      menuDetailsHandler();
      searchDrawer();
    }
  
    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);
  
      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');
  
        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();
  
      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;
  
      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
  
      var h = siteHeader.offsetHeight;
  
      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }
  
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }
  
      requestAnimationFrame(scrollHandler);
  
      config.lastScroll = window.scrollY;
    }
  
    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));
  
          // add is-active class to .site-header__search-container
          document.querySelector(selectors.searchContainer).classList.add('is-active');
        });
      });
  
      document.addEventListener('predictive-search:close-all', function() {
        closeSearchDrawer();
      });
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSizes) {
    var output = '';
  
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSizes);
  
      let priceMarkup = '';
      let vendorMarkup = '';
  
      if (theme.settings.predictiveSearchPrice) {
  const formatGridPrice = price => {
    const formattedPrice = theme.Currency.formatMoney(price, theme.moneyFormat);

    return Number(price) % 100 === 0
      ? formattedPrice.replace(/([.,])00(?=\D*$)/, '')
      : formattedPrice;
  };

  const minimumPrice = formatGridPrice(product.price_min);
  const hasPriceRange =
    Number(product.price_min) !== Number(product.price_max);

  const displayPrice = hasPriceRange
    ? `${minimumPrice}&nbsp;to&nbsp;${formatGridPrice(product.price_max)}`
    : minimumPrice;

  priceMarkup = `<div class="grid-product__price">${displayPrice}</div>`;
}
      if (theme.settings.predictiveSearchVendor) vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;
  
      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
              </div>
            </a>
          </div>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  // Templates contain inert placeholders. Build the real image with the data
  // for this item before inserting it, rather than cloning empty dimensions.
  theme.createImageFromTemplate = function(markup, imageData) {
    const placeholder = markup.querySelector('[data-image-placeholder]');
    const imageEl = placeholder ? document.createElement('img') : markup.querySelector('img');
    if (placeholder) {
      imageEl.className = placeholder.className;
      placeholder.replaceWith(imageEl);
    }
    imageEl.setAttribute('loading', 'lazy');
    imageEl.setAttribute('alt', '');

    const width = Number(imageData && imageData.width);
    const height = Number(imageData && imageData.height);
    if (Number.isInteger(width) && width > 0 && Number.isInteger(height) && height > 0) {
      imageEl.setAttribute('width', String(width));
      imageEl.setAttribute('height', String(height));
    } else {
      // URL-only article data is already inside a CSS ratio box. Do not
      // invent intrinsic dimensions when the source does not provide them.
      imageEl.removeAttribute('width');
      imageEl.removeAttribute('height');
    }
    return imageEl;
  };

  theme.buildProductImage = function(product, imageSizes) {
    var size = theme.settings.productImageSize;
    var output = '';
    const featuredImage = product.featured_image;
    const normaliseImageUrl = url => String(url || '').replace(/^https?:/, '').split('?')[0];
    const featuredUrl = normaliseImageUrl(typeof featuredImage === 'object' && featuredImage
      ? featuredImage.src || featuredImage.url : featuredImage);
    let imageData = typeof featuredImage === 'object' ? featuredImage : null;
    if (!imageData && featuredUrl && Array.isArray(product.media)) {
      const media = product.media.find(item => item &&
        (normaliseImageUrl(item.src) === featuredUrl ||
          normaliseImageUrl(item.preview_image && item.preview_image.src) === featuredUrl));
      imageData = media && (media.preview_image || media);
    }
  
    if (size === 'natural') {
      const template = document.getElementById("naturalImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = theme.createImageFromTemplate(clonedMarkup, imageData);
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');

      const imageWidth = Number(imageEl.getAttribute('width'));
      const imageHeight = Number(imageEl.getAttribute('height'));
      const ratio = imageWidth > 0 && imageHeight > 0
        ? imageHeight / imageWidth * 100 : Number(product.image_aspect_ratio);
      if (Number.isFinite(ratio) && ratio > 0) {
        imageWrapperEl.style.paddingBottom = `${ratio}%`;
      } else {
        // Let the image use its own natural size if older stored data has no
        // ratio, instead of leaving it collapsed inside a zero-height box.
        imageWrapperEl.style.height = 'auto';
        imageEl.style.position = 'relative';
        imageEl.style.height = 'auto';
      }
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    } else {
      const template = document.getElementById("fixedRatioImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = theme.createImageFromTemplate(clonedMarkup, imageData);
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');
  
      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);
  
      if (!theme.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    }
  
    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }
  
    return output;
  }
  
  theme.buildCollectionItem = function(items) {
    var output = '';
  
    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPageItem = function(items) {
    var output = '';
  
    items.forEach(page => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildArticleItem = function(items, imageSize) {
    var output = '';
  
    items.forEach(article => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPredictiveImage = function(obj) {
    var imageMarkup = '';
    if (obj.image) {
      const template = document.getElementById("articleImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageData = typeof obj.image === 'object' ? obj.image : {src: obj.image};
      const imageEl = theme.createImageFromTemplate(clonedMarkup, imageData);

      imageEl.src = imageData.src || imageData.url;
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      imageMarkup = imageDiv.innerHTML;
    }
    return imageMarkup;
  }
  

  /*============================================================================
    Age Verification Popup
  ==============================================================================*/
  
  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();
  
      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);
  
      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }
  
      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })
  
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
  
            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }
  
            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);
  
            if (!secondViewVisited) return;
  
            this.showDeclineContent();
          }
        })
  
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }
  
      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;
  
      this.init();
    }
  
    init() {
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });
  
      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }
  
      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }
  
      this.modal.open();
  
      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
  
      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();
  
          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            sessionStorage.setItem(this.id, 'second-view');
          }
        });
      }
  
      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();
  
          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);
  
          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }
  
      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();
  
          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }
  
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }
  
          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }
  
          this.modal.close();
  
          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }
  
    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);
  
      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }
  
    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);
  
      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }
  
  customElements.define('age-verification-popup', AgeVerificationPopup);
  
  
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        evt.preventDefault();
        if (this.galleryOpen) return;
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }
  
        this.items = this.getImageData();
  
        if (!this.items.length) return;
        this.mekhannViewerTrigger = evt.currentTarget;
        var slide = evt.currentTarget.closest('.product-main-slide') || this.container.querySelector(selectors.activeImage);
        var index = this.items.findIndex(function(item) {
          return item.el.closest('.product-main-slide') === slide;
        });
        this.initGallery(this.items, Math.max(0, index) + 1);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },

      getMekhannPdpSection: function() {
        if (!this.container || !this.container.closest) return null;
        return this.container.closest('.product-section[data-mekhann-pdp-system="modular-v1"]');
      },

      getMekhannViewerSettings: function() {
        var section = this.getMekhannPdpSection();
        if (!section) {
          var legacySection = this.container && this.container.closest &&
            this.container.closest('.product-section[data-product-template="lampshade"]');
          if (!legacySection) return null;
          return {
            section: legacySection,
            legacy: true,
            enhanced: true,
            showAtb: true,
            fit: 'contain',
            arrows: 'soft'
          };
        }
        var controlsValue = String(section.dataset.mekhannViewerControls || '').toLowerCase();
        var atbValue = String(section.dataset.mekhannViewerAtb || '').toLowerCase();
        var fitValue = String(section.dataset.mekhannViewerFit || 'contain').toLowerCase();
        var arrowsValue = String(section.dataset.mekhannMobileArrows || 'soft').toLowerCase();
        return {
          section: section,
          legacy: false,
          enhanced: /^(true|1|enhanced|enabled|on)$/.test(controlsValue),
          showAtb: /^(true|1|show|enabled|on)$/.test(atbValue),
          fit: fitValue === 'natural' ? 'natural' : 'contain',
          arrows: /^(minimal|hidden)$/.test(arrowsValue) ? arrowsValue : 'soft'
        };
      },

      resetMekhannViewer: function(pswpElement) {
        if (!pswpElement) return;
        pswpElement.classList.remove(
          'pswp--mekhann-pdp',
          'pswp--mekhann-controls-enhanced',
          'pswp--mekhann-fit-contain',
          'pswp--mekhann-fit-natural',
          'pswp--mekhann-arrows-soft',
          'pswp--mekhann-arrows-minimal',
          'pswp--mekhann-arrows-hidden',
          'pswp--mekhann-single',
          'pswp--mekhann-no-atb',
          'pswp--mekhann-lampshade'
        );
        var controls = pswpElement.querySelector('[data-mekhann-pswp-controls]');
        var thumbsRail = pswpElement.querySelector('[data-mekhann-pswp-thumbs]');
        var overlayAdd = pswpElement.querySelector('[data-mekhann-pswp-add]');
        if (controls) controls.hidden = true;
        if (thumbsRail) thumbsRail.innerHTML = '';
        if (overlayAdd) {
          overlayAdd.hidden = true;
          overlayAdd.disabled = false;
          overlayAdd.onclick = null;
        }
        this.mekhannPswpThumbs = [];
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
        var viewerSettings = this.getMekhannViewerSettings();
        var items = [];
  
        this.images.forEach(el => {
          var slide = el.closest('.product-main-slide');
          // Videos and models keep their native players. Their poster image
          // must not shift the selected index of this image-only viewer.
          if (slide && slide.dataset.mediaType && slide.dataset.mediaType !== 'image') return;
          var width = Number(el.getAttribute('data-photoswipe-width')) || el.naturalWidth;
          var height = Number(el.getAttribute('data-photoswipe-height')) || el.naturalHeight;
          var source = el.getAttribute('data-photoswipe-src');
          if (!source || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return;
          var item = {
            msrc: el.currentSrc || el.src,
            src: source,
            w: width,
            h: height,
            el: el
          }
          if (!viewerSettings) item.initialZoomLevel = 0.5;
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        if (!pswpElement || !items.length || this.galleryOpen) return;
        var viewerSettings = this.getMekhannViewerSettings();
        var returnFocus = this.mekhannViewerTrigger || document.activeElement;
        this.resetMekhannViewer(pswpElement);
  
        var options = {
          allowPanToNext: viewerSettings ? true : false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: Math.max(0, Math.min(items.length - 1, Number(index) - 1 || 0)),
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: viewerSettings ? 'fit' : 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }

        if (viewerSettings && !viewerSettings.legacy) {
          // Start at the final fitted position. An image animation based on a
          // scrolled thumbnail must not present an off-screen first frame.
          options.showAnimationDuration = 0;
          options.hideAnimationDuration = 0;
          options.errorMsg = '<div class="pswp__error-msg"><p>This image could not be loaded.</p><button type="button" class="text-link" data-mekhann-viewer-retry>Try again</button></div>';
        }
  
        this.galleryOpen = true;
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.setupMekhannControls(pswpElement, items, viewerSettings);
        this.setupMekhannFit(pswpElement, viewerSettings);
        this.setupMekhannViewerLifecycle(pswpElement, items, returnFocus);
        this.gallery.listen('destroy', function() {
          this.galleryOpen = false;
          this.resetMekhannViewer(pswpElement);
        }.bind(this));
        this.gallery.init();
  
        this.preventiOS15Scrolling();
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        if (this.mekhannPswpThumbs) {
          this.mekhannPswpThumbs.forEach(function(thumb, thumbIndex) {
            var isActive = thumbIndex === index;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }
        var currentItem = this.gallery.items[index];
        var slide = currentItem && currentItem.el && currentItem.el.closest('.product-main-slide');
        var slides = this.container.querySelectorAll('.flickity-slider .product-main-slide');
        var slideIndex = slide ? Array.prototype.indexOf.call(slides, slide) : index;
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: slideIndex >= 0 ? slideIndex : index,
            mediaId: slide && slide.dataset.mediaId || ''
          }
        }));
      },

      // V2.24: let the native fit and pan bounds use the real visible controls.
      setupMekhannFit: function(pswpElement, viewerSettings) {
        if (!viewerSettings || viewerSettings.legacy) return;
        var gallery = this.gallery;
        var controls = pswpElement.querySelector('[data-mekhann-pswp-controls]');
        var close = pswpElement.querySelector('.pswp__button--close');
        var frame = 0;
        var destroyed = false;
        var measure = function() {
          var wrap = pswpElement.querySelector('.pswp__scroll-wrap');
          if (!wrap) return { top: 0, bottom: 0 };
          var bounds = wrap.getBoundingClientRect();
          var style = window.getComputedStyle(pswpElement);
          var edge = parseFloat(style.getPropertyValue('--mekhann-pswp-fit-edge')) || 12;
          var safeBottom = parseFloat(style.getPropertyValue('--mekhann-pswp-safe-bottom')) || 0;
          // Native .pswp__ui--hidden translates the UI by 150%. Measuring its
          // transformed close button made the first top margin exceed the
          // viewport and produced a negative fit ratio. Use layout offsets.
          var closeBounds = close && close.getBoundingClientRect();
          var closeTop = close && Number.isFinite(close.offsetTop) ? close.offsetTop :
            closeBounds ? Math.max(0, closeBounds.top - bounds.top) : 0;
          var closeHeight = close && close.offsetHeight || closeBounds && closeBounds.height || 0;
          var dockHeight = controls && !controls.hidden ? controls.offsetHeight || controls.getBoundingClientRect().height : 0;
          var availableHeight = Math.max(1, wrap.clientHeight || bounds.height || window.innerHeight);
          // A very short window still receives a positive image area. The
          // full controls remain scrollable independently through their CSS.
          var maximumInset = Math.max(0, Math.floor((availableHeight - 1) / 2));
          return {
            top: Math.min(maximumInset, Math.ceil(Math.max(edge, closeTop + closeHeight + edge))),
            bottom: Math.min(maximumInset, Math.ceil(Math.max(dockHeight, safeBottom) + edge))
          };
        };
        var sync = function() {
          var bars = measure();
          var previous = gallery.options.barsSize;
          var changed = !previous || bars.top !== previous.top || bars.bottom !== previous.bottom;
          gallery.options.barsSize = bars;
          return changed;
        };
        // Default UI registers its margin parser during init. Updating barsSize
        // here lets that later parser consume our values without overwriting them.
        gallery.options.fitControlsWidth = 0;
        gallery.options.barsSize = { top: 0, bottom: 0 };
        gallery.listen('parseVerticalMargin', sync);
        gallery.listen('beforeResize', sync);
        var schedule = function() {
          if (destroyed || frame) return;
          frame = window.requestAnimationFrame(function() {
            frame = 0;
            if (destroyed) return;
            if (sync()) {
              gallery.invalidateCurrItems();
              gallery.updateSize(true);
            }
          });
        };
        gallery.listen('afterInit', schedule);
        window.addEventListener('resize', schedule);
        window.addEventListener('orientationchange', schedule);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
        var observer = window.ResizeObserver ? new window.ResizeObserver(schedule) : null;
        if (observer) {
          if (controls) observer.observe(controls);
          if (close) observer.observe(close);
        }
        gallery.listen('destroy', function() {
          destroyed = true;
          if (frame) window.cancelAnimationFrame(frame);
          window.removeEventListener('resize', schedule);
          window.removeEventListener('orientationchange', schedule);
          if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
          if (observer) observer.disconnect();
        });
      },

      setupMekhannViewerLifecycle: function(pswpElement, items, returnFocus) {
        var gallery = this.gallery;
        var sourceSizes = items.map(function(item) { return { width: item.w, height: item.h }; });
        var keydown = function(evt) {
          if (evt.key !== 'Tab') return;
          var focusable = Array.prototype.slice.call(pswpElement.querySelectorAll('button, a[href], [tabindex="0"]')).filter(function(el) {
            return !el.disabled && !el.closest('[hidden]') && el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
          });
          if (!focusable.length) { evt.preventDefault(); pswpElement.focus(); return; }
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (evt.shiftKey && (document.activeElement === first || document.activeElement === pswpElement)) {
            evt.preventDefault(); last.focus();
          } else if (!evt.shiftKey && (document.activeElement === last || !pswpElement.contains(document.activeElement))) {
            evt.preventDefault(); first.focus();
          }
        };
        var retry = function(evt) {
          var button = evt.target.closest('[data-mekhann-viewer-retry]');
          if (!button || !pswpElement.contains(button)) return;
          evt.preventDefault();
          var item = gallery.currItem;
          var dimensions = sourceSizes[gallery.getCurrentIndex()];
          if (!item || !dimensions || item.loading) return;
          button.disabled = true;
          item.w = dimensions.width;
          item.h = dimensions.height;
          item.loadError = false;
          item.loaded = false;
          gallery.invalidateCurrItems();
          gallery.updateSize(true);
          pswpElement.focus({ preventScroll: true });
        };
        pswpElement.addEventListener('keydown', keydown);
        pswpElement.addEventListener('click', retry);
        gallery.listen('destroy', function() {
          pswpElement.removeEventListener('keydown', keydown);
          pswpElement.removeEventListener('click', retry);
          var focused = document.activeElement;
          if (returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function' &&
              (!focused || focused === document.body || pswpElement.contains(focused))) {
            returnFocus.focus({ preventScroll: true });
          }
        });
      },

      setupMekhannControls: function(pswpElement, items, viewerSettings) {
        var controls = pswpElement.querySelector('[data-mekhann-pswp-controls]');
        var thumbsRail = pswpElement.querySelector('[data-mekhann-pswp-thumbs]');
        var overlayAdd = pswpElement.querySelector('[data-mekhann-pswp-add]');
        this.mekhannPswpThumbs = [];

        if (!viewerSettings) return;
        if (viewerSettings.legacy) {
          pswpElement.classList.add('pswp--mekhann-lampshade');
        } else {
          pswpElement.classList.add(
            'pswp--mekhann-pdp',
            'pswp--mekhann-fit-' + viewerSettings.fit,
            'pswp--mekhann-arrows-' + viewerSettings.arrows
          );
          pswpElement.classList.toggle('pswp--mekhann-single', items.length <= 1);
        }

        if (!controls || !thumbsRail || !overlayAdd) return;
        thumbsRail.innerHTML = '';
        overlayAdd.onclick = null;
        overlayAdd.hidden = true;
        if (!viewerSettings.enhanced) return;

        if (!viewerSettings.legacy) pswpElement.classList.add('pswp--mekhann-controls-enhanced');
        controls.hidden = false;
        thumbsRail.setAttribute('role', 'group');
  
        var self = this;
        items.forEach(function(item, itemIndex) {
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'pswp__mekhann-thumb';
          thumb.setAttribute('aria-label', 'View product image ' + (itemIndex + 1));
          var image = document.createElement('img');
          image.src = item.msrc || item.src;
          image.alt = '';
          thumb.appendChild(image);
          thumb.addEventListener('click', function() {
            if (self.gallery) self.gallery.goTo(itemIndex);
          });
          thumbsRail.appendChild(thumb);
          self.mekhannPswpThumbs.push(thumb);
        });

        var productSection = viewerSettings.section;
        var sourceAdd = productSection.querySelector('[data-add-to-cart]');
        var sourceAddText = sourceAdd && sourceAdd.querySelector('[data-add-to-cart-text]');
        var hasOverlayAdd = viewerSettings.legacy ? true : viewerSettings.showAtb && Boolean(sourceAdd);
        if (!viewerSettings.legacy) pswpElement.classList.toggle('pswp--mekhann-no-atb', !hasOverlayAdd);
        overlayAdd.hidden = !hasOverlayAdd;
        if (!hasOverlayAdd) return;

        overlayAdd.disabled = !sourceAdd || sourceAdd.disabled || sourceAdd.getAttribute('aria-disabled') === 'true';
        var overlayAddLabel = sourceAddText ? sourceAddText.textContent.trim() : '';
        overlayAdd.textContent = overlayAddLabel || 'Add to Shopping Bag';
        var overlayAddPending = false;
        overlayAdd.onclick = function() {
          if (
            overlayAddPending ||
            !sourceAdd ||
            sourceAdd.disabled ||
            sourceAdd.getAttribute('aria-disabled') === 'true'
          ) return;
          overlayAddPending = true;
          overlayAdd.disabled = true;
          if (self.gallery) self.gallery.close();
          window.setTimeout(function() {
            if (
              sourceAdd.isConnected === false ||
              sourceAdd.disabled ||
              sourceAdd.getAttribute('aria-disabled') === 'true'
            ) return;
            sourceAdd.click();
          }, 80);
        };
      },
  
      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height", 
          `${window.innerHeight}px`
        );
      },
  
      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        let initialScrollPos;
  
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
        
        this.syncHeight();
              
        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;
        
        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');
  
        window.addEventListener('resize', this.syncHeight);
      
        this.gallery.listen('destroy', () => {
          window.removeEventListener('resize', this.syncHeight);
          document.documentElement.style.removeProperty('--window-inner-height');
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });
  
    return Photoswipe;
  })();
  
  
  /*============================================================================
    ProductRecommendations
  ==============================================================================*/
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults =  this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;
  
      document.addEventListener('recommendations:loaded', (e) => {
        // Lampshade cards already have one Collection-owned variant/media
        // controller. The legacy recommendation hover contract must not
        // change their active state or treat their standalone swatch as a link.
        this.colorImages = Array.from(this.el.querySelectorAll('.grid-product__color-image')).filter(image => {
          return !image.closest('.grid-product--lampshades');
        });
        if (this.colorImages.length) {
          this.swatches = Array.from(this.el.querySelectorAll('.color-swatch--with-image')).filter(swatch => {
            return !swatch.closest('.grid-product--lampshades');
          });
          this.colorSwatchHovering();
        }
      });
    }
  
    connectedCallback() {
      if (this.dataset.static === 'true') {
        // Static recommendation markup is already present when this custom
        // element is upgraded. Defer its initialisation until the current
        // theme.js task has completed so reinitProductGridItem has been
        // assigned further down this bundle.
        window.setTimeout(() => {
          if (typeof theme.reinitProductGridItem === 'function') {
            theme.reinitProductGridItem(this.el);
          }

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: this.el,
              intent: this.intent
            }
          }));
        }, 0);
        return;
      }

      fetch(this.url)
        .then(response => response.text())
        .then(text => {
  
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (!recommendations) {
          this.el.classList.add('hide');
          if (AOS) { AOS.refreshHard() }
          return;
        }
  
        this.placeholder.innerHTML = '';
        this.placeholder.innerHTML = recommendations.innerHTML;
  
        theme.reinitProductGridItem(this.el);
  
        this.slideshow = this.querySelector('[data-slideshow]');
  
        if (this.slideshow) {
          this.setupSlider();
        }
  
        document.dispatchEvent(new CustomEvent('recommendations:loaded', {
          detail: {
            section: this.el,
            intent: this.intent
          }
        }));
  
        })
        .catch(e => {
          console.error(e);
        });
    }
  
    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);
  
      let prevNextButtons = false;
      let pageDots = true;
  
      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }
  
      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }
  
    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
  
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };
  
          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }
  
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }
  
            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }
  
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  
  /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
  
    }
  
    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  
  /*============================================================================
    HotSpots
  ==============================================================================*/
  
  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.grid-product__color-image');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');
  
      this._bindEvents();
      this._setupQuickShop();
  
      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }
  
    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this._setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;
  
      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });
  
      // Set active image and swatch
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');
  
      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');
  
      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }
  
    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  
    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;
  
        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });
  
      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }
  
    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }
  
    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }
  
        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }
  
  customElements.define('hot-spots', HotSpots);
  
  /*============================================================================
    ImageCompare
  ==============================================================================*/
  
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');
  
      this.calculateSizes();
  
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);
  
      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);
  
      window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));
  
      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }
  
    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;
  
      this.buttonOffset = this.button.offsetWidth / 2;
  
      this.elWidth = this.el.offsetWidth;
  
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }
  
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }
  
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }
  
      if (e.target === this.button) {
        this.active = true;
      }
    }
  
    dragEnd(e) {
      this.initialX = this.currentX;
  
      this.active = false;
    }
  
    drag(e) {
      if (this.active) {
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }
  
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;
  
      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;
  
      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }
  
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }
  
  customElements.define('image-compare', ImageCompare);
  


  theme.Blog = (function() {

  

    function Blog(container) {

      this.tagFilters();

    }

  

    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function() {

        var filterBy = document.getElementById('BlogTagFilter');

  

        if (!filterBy) {

          return;

        }

  

        filterBy.addEventListener('change', function() {

          location.href = filterBy.value;

        });

      }

    });

  

    return Blog;

  })();

  
  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        heroImageContainer.classList.remove('loading', 'loading--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    function CollectionSidebar(container) {
      this.owner = container;
      this.container = container.querySelector('#CollectionSidebar');
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        if (!this.container) return;
        this.drawerStyle = this.container.dataset.style === 'drawer';
        var marked = this.owner.getAttribute('data-mekhann-plp') === 'lampshades';
        if (marked && this.drawer && !this.drawer.destroyed && this.drawer.drawer === this.container.querySelector('#FilterDrawer')) {
          this.refreshTriggers();
          return;
        }
        this.onUnload();
        this.drawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        theme.FilterDrawer = this.drawer;
      },

      refreshTriggers: function() {
        var drawer = this.drawer;
        if (!drawer) return;
        (drawer.openButtons || []).forEach(function(button) { button.removeEventListener('click', drawer.openListener); });
        drawer.openButtons = Array.from(this.owner.querySelectorAll(drawer.config.open));
        drawer.openButtons.forEach(function(button) {
          button.setAttribute('aria-expanded', drawer.isOpen ? 'true' : 'false');
          button.setAttribute('aria-controls', drawer.config.id);
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', drawer.openListener);
        });
        if (drawer.activeSource && !drawer.activeSource.isConnected) drawer.activeSource = drawer.openButtons[0] || null;
      },

      forceReload: function() { this.init(); },
      onSelect: function() {
        if (!this.drawer) return;
        if (!this.drawerStyle) { this.drawer.close(); return; }
        if (this.drawerStyle || theme.config.bpSmall) this.drawer.open();
      },
      onDeselect: function() { if (this.drawer) this.drawer.close(); },
      onUnload: function() {
        if (!this.drawer) return;
        this.drawer.destroy();
        if (theme.FilterDrawer === this.drawer) theme.FilterDrawer = null;
        this.drawer = null;
      }
    });
    return CollectionSidebar;
  })();

  theme.Collection = (function() {
  
    var selectors = {
      sortSelect: '#SortBy',
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a, [data-clear-filters]',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.context = container.getAttribute('data-context');
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {
  
        /* Prevent extra JS from running for featured collection on a collection template */
        if (this.context && this.context === 'featured-collection') {
          this.colorSwatchHovering();
        } else {
          this.initSort();
          this.colorSwatchHovering();
          this.initFilters();
          this.initPriceRange();
          this.sidebar.init();
        }
      },
  
      initSort: function() {
        if (this.sortSelect) this.sortSelect.off('change' + this.namespace);
        this.sortSelect = this.container.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },
  
      getSortValue: function() {
        return this.sortSelect.value || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        this.queryParams = new URLSearchParams(window.location.search);
  
        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists
  
        window.location.search = this.queryParams.toString();
      },
  
      colorSwatchHovering: function() {
        var self = this;

        this.container.querySelectorAll(selectors.colorSwatch).forEach(function(swatch) {
          if (swatch.dataset.mekhannSwatchBound === 'true') {
            return;
          }

          var gridItem = swatch.closest('.grid-product');
          var isLampshadesCard = gridItem &&
            gridItem.classList.contains('grid-product--lampshades') &&
            swatch.dataset.variantUrl;

          swatch.dataset.mekhannSwatchBound = 'true';

          if (isLampshadesCard) {
            // Request only the colour the customer is approaching. Keep the
            // real responsive IMG as the sole loader; do not warm every card
            // or every colour while the collection hero is still loading.
            var prepareSwatchImage = function(evt) {
              if (evt.type === 'pointerenter' && evt.pointerType === 'touch') return;
              self.prepareLampshadeSwatchImage(gridItem, swatch);
            };
            swatch.addEventListener('pointerenter', prepareSwatchImage);
            swatch.addEventListener('pointerdown', prepareSwatchImage);
            swatch.addEventListener('focus', prepareSwatchImage);
            swatch.addEventListener('click', function(evt) {
              evt.preventDefault();
              evt.stopPropagation();
              self.selectLampshadeSwatch(gridItem, swatch);
            });

            return;
          }

          swatch.addEventListener('mouseenter', function() {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var imageEl = gridItem && gridItem.querySelector('.grid-product__color-image--' + id);

            if (imageEl && image) {
              imageEl.style.backgroundImage = 'url(' + image + ')';
              imageEl.classList.add('is-active');
            }
          });

          swatch.addEventListener('mouseleave', function() {
            var id = swatch.dataset.variantId;
            var imageEl = gridItem && gridItem.querySelector('.grid-product__color-image--' + id);

            if (imageEl) {
              imageEl.classList.remove('is-active');
            }
          });
        });

        this.container.querySelectorAll('[data-mobile-product-gallery]').forEach(function(gallery) {
          self.initLampshadeMobileGallery(gallery);
        });
      },

      getLampshadeCardMedia: function(gridItem, selectedGroup, selectedSize, selectedMediaId) {
        if (!gridItem) {
          return null;
        }

        var mediaItems = Array.from(gridItem.querySelectorAll('[data-mobile-product-slide]')).map(function(slide) {
          var image = slide.querySelector('img');
          var imageUrl = image ? (image.currentSrc || image.src || image.dataset.src || '') : '';

          return {
            id: String(slide.dataset.mediaId || ''),
            group: String(slide.dataset.mediaGroup || 'all'),
            size: String(slide.dataset.mediaSize || 'all'),
            variantId: String(slide.dataset.variantId || ''),
            variantUrl: String(slide.dataset.variantUrl || ''),
            variantPrice: String(slide.dataset.variantPrice || ''),
            imageUrl: imageUrl,
            slide: slide
          };
        });

        // Multi-variant Size cards use Shopify's directly assigned featured
        // media as their slider anchors. Honour the current anchor before any
        // support-image grouping preference.
        if (gridItem.dataset.variantFeaturedSlider === 'true' && selectedMediaId) {
          var exactFeaturedMedia = mediaItems.find(function(item) {
            return item.id === String(selectedMediaId);
          });

          if (exactFeaturedMedia) {
            return exactFeaturedMedia;
          }
        }

        return theme.chooseMekhannMedia(mediaItems, selectedGroup, selectedSize, selectedMediaId);
      },

      previewLampshadeSwatch: function(gridItem, swatch) {
        var id = swatch.dataset.variantId;
        var selectedMedia = this.getLampshadeCardMedia(
          gridItem,
          swatch.dataset.mediaGroup || 'all',
          swatch.dataset.mediaSize || 'all',
          swatch.dataset.variantMediaId || ''
        );
        var image = selectedMedia && selectedMedia.imageUrl ? selectedMedia.imageUrl : swatch.dataset.variantImage;
        var imageEl = gridItem.querySelector('.grid-product__color-image--' + id);

        gridItem.querySelectorAll(selectors.colorSwatchImage).forEach(function(el) {
          el.classList.remove('is-active');
        });

        if (imageEl && image) {
          imageEl.style.backgroundImage = 'url(' + image + ')';
          imageEl.classList.add('is-active');
        }

        var gallery = gridItem.querySelector('[data-mobile-product-gallery]');
        if (gallery) {
          gallery.dataset.selectedMediaGroup = swatch.dataset.mediaGroup || 'all';
          gallery.dataset.selectedMediaSize = swatch.dataset.mediaSize || 'all';
          gallery.dataset.selectedMediaId = swatch.dataset.variantMediaId || '';
          this.initLampshadeMobileGallery(gallery, true);
        }
      },

      restoreLampshadeSwatch: function(gridItem) {
        var selectedVariantId = gridItem.dataset.selectedVariantId;

        gridItem.querySelectorAll(selectors.colorSwatchImage).forEach(function(el) {
          el.classList.remove('is-active');
        });

        if (!selectedVariantId) {
          return;
        }

        var selectedSwatch = gridItem.querySelector(
          selectors.colorSwatch + '[data-variant-id="' + selectedVariantId + '"]'
        );
        var selectedImage = gridItem.querySelector('.grid-product__color-image--' + selectedVariantId);
        var selectedMedia = selectedSwatch ? this.getLampshadeCardMedia(
          gridItem,
          selectedSwatch.dataset.mediaGroup || 'all',
          selectedSwatch.dataset.mediaSize || 'all',
          gridItem.dataset.selectedMediaId || selectedSwatch.dataset.variantMediaId || ''
        ) : null;
        var selectedImageUrl = selectedMedia && selectedMedia.imageUrl ?
          selectedMedia.imageUrl :
          (selectedSwatch ? selectedSwatch.dataset.variantImage : '');

        if (selectedSwatch && selectedImage && selectedImageUrl) {
          selectedImage.style.backgroundImage = 'url(' + selectedImageUrl + ')';
          selectedImage.classList.add('is-active');
        }

        var gallery = gridItem.querySelector('[data-mobile-product-gallery]');
        var variants = this.getLampshadeCardVariants(gridItem);
        var choice = variants && variants.find(function(item) { return item.id === selectedVariantId; });
        if (gallery && choice) {
          gallery.dataset.selectedMediaGroup = choice.mediaGroup || 'all';
          gallery.dataset.selectedMediaSize = this.getLampshadeGallerySizeScope(variants, choice);
          gallery.dataset.selectedMediaId = gridItem.dataset.selectedMediaId || choice.mediaId || '';
          this.initLampshadeMobileGallery(gallery, true);
        } else if (gallery && selectedSwatch) {
          gallery.dataset.selectedMediaGroup = selectedSwatch.dataset.mediaGroup || 'all';
          gallery.dataset.selectedMediaSize = selectedSwatch.dataset.mediaSize || 'all';
          gallery.dataset.selectedMediaId = gridItem.dataset.selectedMediaId || selectedSwatch.dataset.variantMediaId || '';
          this.initLampshadeMobileGallery(gallery, true);
        }
      },

      syncLampshadeSlideVariant: function(gridItem, gallery, slide) {
        if (!gridItem || !gallery || !slide) {
          return;
        }

        var variantId = slide.dataset.variantId || '';
        var variantUrl = slide.dataset.variantUrl || '';
        var variantPrice = slide.dataset.variantPrice || '';
        var mediaId = slide.dataset.mediaId || '';
        var mediaGroup = slide.dataset.mediaGroup || '';
        var variants = this.getLampshadeCardVariants(gridItem);
        var choice = variants && variants.find(function(item) { return item.id === variantId; });
        // A hidden/ineligible anchor cannot escape the active card filters.
        if (variants && variantId && !choice) return;
        if (choice) {
          variantUrl = choice.url;
          variantPrice = choice.price;
        }

        gallery.dataset.selectedMediaId = mediaId;
        gridItem.dataset.selectedMediaId = mediaId;

        if (!variantId || !variantUrl) {
          return;
        }

        gridItem.dataset.selectedVariantId = variantId;
        gridItem.dataset.selectedVariantUrl = variantUrl;
        gridItem.dataset.productModalUrl = variantUrl;
        gridItem.dataset.selectedVariantPrice = variantPrice;
        this.syncLampshadeSizeLabel(gridItem, slide.dataset.variantSizeLabel || '', slide.dataset.variantColourLabel || '');

        var cardPrice = gridItem.querySelector('[data-grid-product-current-price]');
        if (cardPrice && variantPrice) {
          cardPrice.textContent = variantPrice;
        }

        var displayUrl = theme.getMekhannDisplayUrl(variantUrl, mediaId);
        gridItem.querySelectorAll('[data-grid-product-link]').forEach(function(link) {
          link.setAttribute('href', displayUrl);
        });

        if (mediaGroup && mediaGroup !== 'common' && mediaGroup !== 'all') {
          gridItem.querySelectorAll('.grid-product__colors ' + selectors.colorSwatch).forEach(function(swatch) {
            var isSelected = swatch.dataset.mediaGroup === mediaGroup;
            swatch.classList.toggle('is-active', isSelected);
            swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
        }

        if (choice) {
          gridItem.dataset.plpCardExact = 'true';
          this.syncLampshadePriceDetails(gridItem, choice);
        }

        var holder = document.getElementById('QuickShopHolder-' + gridItem.dataset.productHandle);
        theme.syncGridQuickShopVariant(gridItem, holder);
      },

      getLampshadeCardVariants: function(gridItem) {
        if (!gridItem) return null;
        var source = gridItem.querySelector('[data-plp-card-variants]');
        if (!source) return null;
        if (gridItem.mekhannPLPVariants) return gridItem.mekhannPLPVariants;
        var variants = [];
        try {
          var parsed = JSON.parse(source.textContent);
          if (Array.isArray(parsed)) variants = parsed.filter(function(item) {
            return item && typeof item.id === 'string' && item.id &&
              typeof item.url === 'string' && item.url && typeof item.price === 'string' &&
              typeof item.size === 'string' && typeof item.colour === 'string';
          });
        } catch (error) {
          // Invalid local data must not manufacture a variant or escape filters.
        }
        gridItem.mekhannPLPVariants = variants;
        return variants;
      },

      getLampshadeGallerySizeScope: function(variants, choice) {
        var sizes = variants.map(function(item) { return item.size; }).filter(function(value, index, all) { return all.indexOf(value) === index; });
        return sizes.length === 1 ? (choice.mediaSize || 'all') : 'all';
      },

      setLampshadeImageStatus: function(gridItem, state) {
        var status = gridItem.querySelector('[data-plp-image-status]');
        var size = gridItem.querySelector('[data-plp-card-size]');
        if (!status && state && size) {
          status = document.createElement('span');
          status.className = 'mekhann-plp__image-status';
          status.setAttribute('data-plp-image-status', '');
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          size.insertAdjacentElement('afterend', status);
        }
        if (state) gridItem.dataset.plpImageState = state;
        else delete gridItem.dataset.plpImageState;
        if (!status) return;
        status.hidden = !state;
        status.textContent = state === 'loading' ? 'Loading image…' : state === 'error' ? 'Image unavailable' : '';
        if (state === 'error') {
          var hasColourChoice = gridItem.querySelector('.grid-product__colors button.color-swatch:not([disabled])');
          var retryHint = hasColourChoice ? 'Select the colour again to retry.' : 'Choose another image, then return to retry.';
          status.setAttribute('aria-label', 'Image unavailable. ' + retryHint);
        } else status.removeAttribute('aria-label');
      },

      cancelLampshadeImageRequest: function(gridItem) {
        if (gridItem && gridItem.mekhannImageRequest) gridItem.mekhannImageRequest.cancel();
      },

      getLampshadeImageSource: function(image) {
        // currentSrc may briefly lag a changed responsive attribute. All four
        // values must still match before reusing a completed decode.
        return JSON.stringify([image.currentSrc || '', image.getAttribute('src') || '',
          image.getAttribute('srcset') || '', image.getAttribute('sizes') || '']);
      },

      requestLampshadeCardVariant: function(gridItem, choice, swatch) {
        if (!this.isLampshadesPLP()) {
          this.applyLampshadeCardVariant(gridItem, choice, swatch);
          return Promise.resolve(true);
        }
        var variants = this.getLampshadeCardVariants(gridItem);
        var size = variants ? this.getLampshadeGallerySizeScope(variants, choice) : (choice.gallerySize || 'all');
        var media = this.getLampshadeCardMedia(gridItem, choice.mediaGroup || 'all', size, choice.mediaId || '');
        var image = media && media.slide && media.slide.querySelector('img');
        var gallery = gridItem.querySelector('[data-mobile-product-gallery]');
        var sameSelection = media && gridItem.dataset.selectedVariantId === choice.id && gridItem.dataset.selectedMediaId === media.id;
        var source = image && this.getLampshadeImageSource(image);
        var pending = gridItem.mekhannImageRequest;
        var intent = pending && pending.swatchIntent;
        // Share only this controller's still-owned, identical swatch request.
        // Changed media/source, native swipes and retired cards need a new gate.
        if (media && image && gallery && intent && pending.promise &&
            intent.owner === this && intent.gallery === gallery &&
            gridItem.isConnected && this.container.contains(gridItem) && gallery.contains(image) &&
            intent.choiceId === choice.id && intent.mediaId === media.id &&
            intent.image === image && intent.source === source) return pending.promise;
        this.cancelLampshadeImageRequest(gridItem);
        this.setLampshadeImageStatus(gridItem, '');
        if (!gallery) {
          this.applyLampshadeCardVariant(gridItem, choice, swatch);
          return Promise.resolve(true);
        }
        if (!image) {
          this.setLampshadeImageStatus(gridItem, 'error');
          return Promise.resolve(false);
        }

        var promise = this.waitForLampshadeCardImage(gridItem, image, function() {
          this.applyLampshadeCardVariant(gridItem, choice, swatch);
        }.bind(this), !sameSelection, sameSelection);
        var request = gridItem.mekhannImageRequest;
        if (request && request.promise === promise) {
          request.swatchIntent = {
            owner: this, gallery: gallery, choiceId: choice.id,
            mediaId: media.id, image: image, source: source
          };
        }
        return promise;
      },

      waitForLampshadeCardImage: function(gridItem, image, onReady, preserveCard, keepLoadedSlideVisible) {
        this.cancelLampshadeImageRequest(gridItem);
        if (!gridItem.isConnected || !this.container.contains(gridItem)) return Promise.resolve(false);
        if (image.complete && image.naturalWidth > 0 && !image.dataset.mekhannImageFailed &&
            image.mekhannPLPReadySource === this.getLampshadeImageSource(image)) {
          // Returning to a proven decoded source is synchronous. Do not
          // remove links, hide the image or publish a new busy state first.
          this.setLampshadeImageStatus(gridItem, '');
          if (onReady) onReady();
          return Promise.resolve(true);
        }
        var gallery = gridItem.querySelector('[data-mobile-product-gallery]');
        // One card owns one cancellable readiness request. Swatches retain the
        // old full card; native swipes already own the new correct selection.
        var self = this;
        var request;
        var promise = new Promise(function(resolve) {
          var done = false;
          var decoding = false;
          var decodedSource = null;
          var timer;
          var busyBefore = gallery.getAttribute('aria-busy');
          var visibilityBefore = image.style.getPropertyValue('visibility');
          var visibilityPriority = image.style.getPropertyPriority('visibility');
          // A native swipe or current-colour reselect owns this image. Keep a
          // loaded, non-failed image visible while its first decode is proved;
          // hiding it here adds a blank/reveal after the correct slide arrives.
          // Cold or failed images still wait concealed, and swatch commits
          // retain the old card until the existing readiness gate succeeds.
          if (!preserveCard && !(keepLoadedSlideVisible && image.complete && image.naturalWidth > 0 && !image.dataset.mekhannImageFailed)) {
            image.style.setProperty('visibility', 'hidden');
          }
          var links = (preserveCard ? Array.from(gridItem.querySelectorAll('[data-grid-product-link]')) : []).map(function(link) {
            var saved = { element: link, href: link.getAttribute('href'), disabled: link.getAttribute('aria-disabled') };
            link.removeAttribute('href');
            link.setAttribute('aria-disabled', 'true');
            return saved;
          });
          var blockNavigation = function(evt) {
            var link = evt.target.closest && evt.target.closest('[data-grid-product-link]');
            if (!link || !gridItem.contains(link)) return;
            evt.preventDefault();
            evt.stopPropagation();
          };
          request = { cancel: function() { finish('cancel'); } };
          gridItem.mekhannImageRequest = request;
          gallery.setAttribute('aria-busy', 'true');
          self.setLampshadeImageStatus(gridItem, 'loading');
          if (preserveCard) {
            gridItem.addEventListener('click', blockNavigation, true);
            gridItem.addEventListener('auxclick', blockNavigation, true);
          }

          function finish(outcome) {
            if (done) return;
            done = true;
            window.clearTimeout(timer);
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            gridItem.removeEventListener('click', blockNavigation, true);
            gridItem.removeEventListener('auxclick', blockNavigation, true);
            if (gridItem.mekhannImageRequest !== request) { resolve(false); return; }
            gridItem.mekhannImageRequest = null;
            if (!preserveCard) {
              if (visibilityBefore) image.style.setProperty('visibility', visibilityBefore, visibilityPriority);
              else image.style.removeProperty('visibility');
            }
            links.forEach(function(saved) {
              if (saved.href === null) saved.element.removeAttribute('href');
              else saved.element.setAttribute('href', saved.href);
              if (saved.disabled === null) saved.element.removeAttribute('aria-disabled');
              else saved.element.setAttribute('aria-disabled', saved.disabled);
            });
            if (busyBefore === null) gallery.removeAttribute('aria-busy');
            else gallery.setAttribute('aria-busy', busyBefore);
            if (!gridItem.isConnected || !self.container.contains(gridItem)) outcome = 'cancel';
            self.setLampshadeImageStatus(gridItem, outcome === 'error' ? 'error' : '');
            if (outcome === 'success') {
              delete image.dataset.mekhannImageFailed;
              if (decodedSource) image.mekhannPLPReadySource = decodedSource;
              if (onReady) onReady();
            }
            resolve(outcome === 'success');
          }
          function failed() {
            if (done) return;
            if (!gridItem.isConnected || !self.container.contains(gridItem)) { finish('cancel'); return; }
            image.dataset.mekhannImageFailed = 'true';
            delete image.mekhannPLPReadySource;
            finish('error');
          }
          function loaded() {
            if (done || decoding) return;
            if (!image.naturalWidth) { failed(); return; }
            if (typeof image.decode !== 'function') { finish('success'); return; }
            decoding = true;
            var decodingSource = self.getLampshadeImageSource(image);
            function changedSource() {
              if (decodingSource === self.getLampshadeImageSource(image)) return false;
              decoding = false;
              if (image.complete && image.naturalWidth > 0) loaded();
              return true;
            }
            try {
              image.decode().then(function() {
                if (done) return;
                if (changedSource()) return;
                if (image.complete && image.naturalWidth > 0) {
                  decodedSource = decodingSource;
                  finish('success');
                }
                else failed();
              }, function() {
                if (!done && !changedSource()) failed();
              });
            } catch (error) { if (!changedSource()) failed(); }
          }

          image.addEventListener('load', loaded);
          image.addEventListener('error', failed);
          // A failure deadline releases the old, correct card. It is not a
          // performance target and never commits an unready image.
          timer = window.setTimeout(failed, 10000);
          image.loading = 'eager';
          if (image.dataset.mekhannImageFailed === 'true' || image.complete && !image.naturalWidth &&
              (image.getAttribute('src') || image.getAttribute('srcset'))) {
            delete image.dataset.mekhannImageFailed;
            var source = image.getAttribute('src');
            var sources = image.getAttribute('srcset');
            image.removeAttribute('srcset');
            image.removeAttribute('src');
            if (sources) image.setAttribute('srcset', sources);
            if (source) image.setAttribute('src', source);
          }
          if (image.complete && image.naturalWidth > 0) loaded();
        });
        if (gridItem.mekhannImageRequest === request) request.promise = promise;
        return promise;
      },

      showLampshadeSlideImage: function(gridItem, slide) {
        if (!this.isLampshadesPLP() || !gridItem || !slide) return;
        var image = slide.querySelector('img');
        if (!image) return;
        return this.waitForLampshadeCardImage(gridItem, image, null, false, true);
      },

      prepareLampshadeGalleryImages: function(gallery, index) {
        if (!this.isLampshadesPLP()) return;
        // Only gallery interaction or a committed customer selection reaches
        // here. Prepare the current cell and its immediate swipe neighbours.
        var slides = Array.from(gallery.querySelectorAll('[data-mobile-product-slide]:not(.mekhann-mobile-slide--inactive)'));
        slides.slice(Math.max(0, index - 1), index + 2).forEach(function(slide) {
          var image = slide.querySelector('img');
          if (image) image.loading = 'eager';
        });
      },

      getLampshadeSwatchChoice: function(gridItem, swatch) {
        if (!gridItem || !swatch || swatch.disabled) return null;
        var variants = this.getLampshadeCardVariants(gridItem);
        if (variants) {
          var colour = swatch.dataset.variantColourLabel || '';
          var eligible = variants.filter(function(item) { return item.colour === colour; });
          // The Liquid swatch owns this colour's default eligible variant.
          // Choosing a colour never carries a local size lock into that colour.
          var choice = eligible.find(function(item) { return item.id === swatch.dataset.variantId; }) || eligible[0];
          return choice || null;
        }
        return {
          id: swatch.dataset.variantId || '', url: swatch.dataset.variantUrl || '',
          price: swatch.dataset.variantPrice || '', mediaId: swatch.dataset.variantMediaId || '',
          mediaGroup: swatch.dataset.mediaGroup || 'all', gallerySize: swatch.dataset.mediaSize || 'all',
          size: swatch.dataset.variantSizeLabel || '', colour: swatch.dataset.variantColourLabel || ''
        };
      },

      prepareLampshadeSwatchImage: function(gridItem, swatch) {
        if (!this.isLampshadesPLP() || !gridItem || !gridItem.isConnected || !this.container.contains(gridItem)) return;
        var choice = this.getLampshadeSwatchChoice(gridItem, swatch);
        if (!choice) return;
        var variants = this.getLampshadeCardVariants(gridItem);
        var size = variants ? this.getLampshadeGallerySizeScope(variants, choice) : (choice.gallerySize || 'all');
        var media = this.getLampshadeCardMedia(gridItem, choice.mediaGroup || 'all', size, choice.mediaId || '');
        var image = media && media.slide && media.slide.querySelector('img');
        if (image && image.loading !== 'eager') image.loading = 'eager';
      },

      selectLampshadeSwatch: function(gridItem, swatch) {
        var choice = this.getLampshadeSwatchChoice(gridItem, swatch);
        if (!choice) return;
        return this.requestLampshadeCardVariant(gridItem, choice, swatch);
      },

      syncLampshadePriceDetails: function(gridItem, choice) {
        var wrap = gridItem.querySelector('[data-grid-product-price-wrap]');
        var current = wrap && wrap.querySelector('[data-grid-product-current-price]');
        if (!current) return;
        // Modelled strings are formatted by Liquid, never by a second money formatter.
        Array.from(wrap.childNodes).forEach(function(node) { if (node !== current) node.remove(); });
        function append(className, value, before) {
          if (!value) return;
          var node = document.createElement('span');
          node.className = className;
          node.textContent = value;
          if (before) wrap.insertBefore(node, current); else wrap.appendChild(node);
        }
        if (choice.compareAtPrice) {
          append('visually-hidden', 'Regular price', true);
          append('grid-product__price--original', choice.compareAtPrice, true);
          append('visually-hidden', 'Sale price', true);
        }
        append('grid-product__price--savings', choice.saveText || '', false);
        append('product__unit-price', choice.unitPriceText || '', false);
      },

      applyLampshadeCardVariant: function(gridItem, choice, swatch) {
        var variantId = choice.id;
        var variantUrl = choice.url;
        if (!variantId || !variantUrl) return;
        var variants = this.getLampshadeCardVariants(gridItem);
        var mediaGroup = choice.mediaGroup || 'all';
        var mediaSize = variants ? this.getLampshadeGallerySizeScope(variants, choice) : (choice.gallerySize || 'all');
        var selectedMedia = gridItem.dataset.variantFeaturedSlider === 'true' ? null : this.getLampshadeCardMedia(
          gridItem, mediaGroup, mediaSize, choice.mediaId || ''
        );
        var mediaId = selectedMedia ? selectedMedia.id : (choice.mediaId || '');
        var price = choice.price || '';
        var displayUrl = theme.getMekhannDisplayUrl(variantUrl, mediaId);
        var gallery = gridItem.querySelector('[data-mobile-product-gallery]');
        var cardPrice = gridItem.querySelector('[data-grid-product-current-price]');
        var cardSize = gridItem.querySelector('[data-plp-card-size]');
        var sizeLabel = choice.size || '';
        var colourLabel = choice.colour || '';
        var sizeText = variants ? sizeLabel : (sizeLabel && colourLabel ? colourLabel + ' · ' + sizeLabel : sizeLabel);
        var unchanged = gridItem.dataset.selectedVariantId === variantId &&
          gridItem.dataset.selectedVariantUrl === variantUrl && gridItem.dataset.selectedVariantPrice === price &&
          gridItem.dataset.selectedMediaId === mediaId && (!swatch || swatch.getAttribute('aria-pressed') === 'true') &&
          (!variants || gridItem.dataset.plpCardExact === 'true') &&
          (!cardPrice || cardPrice.textContent.trim() === price.trim()) &&
          (!cardSize || cardSize.textContent.trim() === sizeText.trim() && cardSize.hidden === !sizeText) &&
          Array.from(gridItem.querySelectorAll('[data-grid-product-link]')).every(function(link) { return link.getAttribute('href') === displayUrl; }) &&
          (!gallery || (gallery.dataset.mekhannGalleryBound === 'true' || gallery.dataset.mekhannGalleryBound === 'static') &&
            gallery.dataset.selectedMediaId === mediaId && gallery.dataset.selectedMediaGroup === mediaGroup &&
            gallery.dataset.selectedMediaSize === mediaSize);
        if (unchanged) return;
        gridItem.dataset.selectedVariantId = variantId;
        gridItem.dataset.selectedVariantUrl = variantUrl;
        gridItem.dataset.productModalUrl = variantUrl;
        gridItem.dataset.selectedVariantPrice = price;
        gridItem.dataset.selectedMediaId = mediaId;
        if (variants) gridItem.dataset.plpCardExact = 'true';
        this.syncLampshadeSizeLabel(gridItem, sizeLabel, colourLabel);
        if (cardPrice && price) cardPrice.textContent = price;
        if (variants) this.syncLampshadePriceDetails(gridItem, choice);
        gridItem.querySelectorAll('.grid-product__colors ' + selectors.colorSwatch).forEach(function(el) {
          var isSelected = variants ? el.dataset.variantColourLabel === colourLabel : el === swatch;
          el.classList.toggle('is-active', isSelected);
          el.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        gridItem.querySelectorAll('[data-grid-product-link]').forEach(function(link) { link.setAttribute('href', displayUrl); });
        this.restoreLampshadeSwatch(gridItem);
        var holder = document.getElementById('QuickShopHolder-' + gridItem.dataset.productHandle);
        theme.syncGridQuickShopVariant(gridItem, holder);
      },

      syncLampshadeSizeLabel: function(gridItem, sizeLabel, colourLabel) {
        gridItem.dataset.selectedVariantSizeLabel = sizeLabel || '';
        gridItem.dataset.selectedVariantColourLabel = colourLabel || '';
        var size = gridItem.querySelector('[data-plp-card-size]');
        if (!size) return;
        size.textContent = this.getLampshadeCardVariants(gridItem) ? (sizeLabel || '') :
          (sizeLabel && colourLabel ? colourLabel + ' · ' + sizeLabel : (sizeLabel || ''));
        size.hidden = !sizeLabel;
        if (this.getLampshadeCardVariants(gridItem)) {
          size.setAttribute('role', 'status');
          size.setAttribute('aria-live', 'polite');
          size.setAttribute('aria-atomic', 'true');
        }
      },

      initLampshadeMobileGallery: function(gallery, force) {
        if (gallery.dataset.mekhannGalleryBound && !force) {
          return;
        }

        var track = gallery.querySelector('[data-mobile-product-track]');
        if (!track) {
          return;
        }

        var self = this;
        var gridItem = gallery.closest('.grid-product');

        gallery.dataset.mekhannGalleryBuild = 'V2.16-FOUNDER-REVIEW-2026-08-29';

        if (this.isLampshadesPLP() && !gallery.mekhannGalleryIntentHandler) {
          gallery.mekhannGalleryIntentHandler = function() {
            var active = Array.from(track.querySelectorAll('[data-mobile-product-slide]:not(.mekhann-mobile-slide--inactive)'));
            var selected = active.findIndex(function(slide) {
              return slide.classList.contains('is-selected') || slide.dataset.mediaId === gallery.dataset.selectedMediaId;
            });
            self.prepareLampshadeGalleryImages(gallery, Math.max(0, selected));
          };
          gallery.addEventListener('pointerdown', gallery.mekhannGalleryIntentHandler);
          gallery.addEventListener('focusin', gallery.mekhannGalleryIntentHandler);
        }

        if (gallery.mekhannGalleryObserver) {
          gallery.mekhannGalleryObserver.disconnect();
          gallery.mekhannGalleryObserver = null;
        }

        if (track.mekhannSlideshow && typeof track.mekhannSlideshow.destroy === 'function') {
          track.mekhannSlideshow.destroy();
          track.mekhannSlideshow = null;
        }

        var selectedGroup = gallery.dataset.selectedMediaGroup || 'all';
        var selectedSize = gallery.dataset.selectedMediaSize || 'all';
        var selectedMediaId = gallery.dataset.selectedMediaId || '';
        var productVariantCount = gridItem ? parseInt(gridItem.dataset.productVariantCount || '0', 10) : 0;
        var variantFeaturedSlider = gridItem && gridItem.dataset.variantFeaturedSlider === 'true';
        var selectedVariantId = gridItem ? String(gridItem.dataset.selectedVariantId || '') : '';
        var allSlides = Array.from(track.querySelectorAll('[data-mobile-product-slide]'));
        var eligibleVariants = this.getLampshadeCardVariants(gridItem);
        var eligibleVariantIds = eligibleVariants && eligibleVariants.map(function(item) { return item.id; });
        var matchingSlides = [];

        allSlides.forEach(function(slide) {
          var mediaGroup = slide.dataset.mediaGroup || 'all';
          var mediaSize = slide.dataset.mediaSize || 'all';
          var matchesColour = selectedGroup === 'all' ?
            mediaGroup === 'all' :
            mediaGroup === selectedGroup || (mediaGroup === 'common' && selectedSize === 'all');
          var matchesSize = selectedSize === 'all' || mediaSize === 'all' || mediaSize === selectedSize;
          var variantIsAvailable = slide.dataset.variantAvailable !== 'false';
          var isVariantAnchor = slide.dataset.variantAnchor === 'true';
          var isActive = variantFeaturedSlider ?
            (matchesColour && matchesSize && variantIsAvailable && isVariantAnchor) :
            (matchesColour && matchesSize && variantIsAvailable);

          if (eligibleVariantIds && slide.dataset.variantId && eligibleVariantIds.indexOf(String(slide.dataset.variantId)) === -1) isActive = false;
          if (isActive) {
            matchingSlides.push(slide);
          }
        });

        // A featured image should always be in product.media. If an old or
        // malformed assignment leaves no anchor, fail safely to one image
        // owned by the selected variant—never to another colour's gallery.
        if (variantFeaturedSlider && !matchingSlides.length && selectedVariantId) {
          var selectedVariantFallback = allSlides.find(function(slide) {
            return String(slide.dataset.variantId || '') === selectedVariantId &&
              slide.dataset.variantAvailable !== 'false' &&
              (!eligibleVariantIds || eligibleVariantIds.indexOf(selectedVariantId) !== -1);
          });

          if (selectedVariantFallback) {
            matchingSlides.push(selectedVariantFallback);
          }
        }

        // Shopify product-media order is not consistent across colours. Keep
        // the PLP commercial sequence deterministic: Medium first, then Large.
        // Moving only the visible anchors preserves every hidden support image
        // while giving Flickity the correct two-cell order.
        if (variantFeaturedSlider && selectedSize === 'all' && matchingSlides.length > 1) {
          var featuredSizeOrder = {
            medium: 0,
            large: 1
          };

          matchingSlides.sort(function(a, b) {
            var aSizeOrder = featuredSizeOrder[a.dataset.mediaSize];
            var bSizeOrder = featuredSizeOrder[b.dataset.mediaSize];
            var aOrder = typeof aSizeOrder === 'number' ? aSizeOrder : 99;
            var bOrder = typeof bSizeOrder === 'number' ? bSizeOrder : 99;
            return aOrder - bOrder;
          });
          matchingSlides.forEach(function(slide) {
            track.appendChild(slide);
          });
          allSlides = Array.from(track.querySelectorAll('[data-mobile-product-slide]'));
        }

        var selectedSlide = null;

        // Multi-variant Size cards open on their selected direct anchor. A
        // single sellable variant owns its complete gallery; source order is
        // the presentation order, so it opens on its first assigned image.
        if (variantFeaturedSlider && matchingSlides.length) {
          selectedSlide = matchingSlides.find(function(slide) {
            return String(slide.dataset.mediaId || '') === String(selectedMediaId);
          }) || matchingSlides[0];
        } else if (productVariantCount === 1 && matchingSlides.length) {
          selectedSlide = matchingSlides[0];
        } else {
          var selectedMedia = theme.chooseMekhannMedia(matchingSlides.map(function(slide) {
            return {
              id: String(slide.dataset.mediaId || ''),
              group: String(slide.dataset.mediaGroup || 'all'),
              size: String(slide.dataset.mediaSize || 'all'),
              slide: slide
            };
          }), selectedGroup, selectedSize, selectedMediaId);
          selectedSlide = selectedMedia ? selectedMedia.slide : null;
        }

        if (selectedSlide) {
          selectedMediaId = String(selectedSlide.dataset.mediaId || '');
          gallery.dataset.selectedMediaId = selectedMediaId;
          if (gridItem) {
            gridItem.dataset.selectedMediaId = selectedMediaId;
            // A single-variant card can open on its first source-order photo
            // instead of Shopify's featured media. Its title must open that
            // same photo without turning the initial price range into a choice.
            if (this.isLampshadesPLP() && gridItem.dataset.selectedVariantUrl) {
              var initialDisplayUrl = theme.getMekhannDisplayUrl(gridItem.dataset.selectedVariantUrl, selectedMediaId);
              gridItem.querySelectorAll('[data-grid-product-link]').forEach(function(link) {
                link.setAttribute('href', initialDisplayUrl);
              });
            }
          }
        }

        if (!matchingSlides.length && allSlides.length && !eligibleVariantIds) {
          matchingSlides.push(allSlides[0]);
        }

        var activeSlides = matchingSlides;

        allSlides.forEach(function(slide) {
          var isActive = activeSlides.indexOf(slide) !== -1;

          slide.classList.toggle('mekhann-mobile-slide--inactive', !isActive);
          if (isActive) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.classList.toggle(
            'grid-product__mobile-slide--selected',
            isActive && String(slide.dataset.mediaId) === String(selectedMediaId)
          );
        });

        var slides = allSlides.filter(function(slide) {
          return !slide.classList.contains('mekhann-mobile-slide--inactive');
        });

        var syncSelectedSlideFocus = function(selectedSlide) {
          if (!self.isLampshadesPLP()) return;
          allSlides.forEach(function(slide) {
            var isSelected = slide === selectedSlide;
            slide.setAttribute('tabindex', isSelected ? '0' : '-1');
            slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
          });
        };

        if (!slides.length) {
          syncSelectedSlideFocus(null);
          return;
        }

        var initialIndex = slides.findIndex(function(slide) {
          return String(slide.dataset.mediaId) === String(selectedMediaId);
        });
        if (initialIndex < 0) {
          initialIndex = 0;
          slides[0].classList.add('grid-product__mobile-slide--selected');
        }
        syncSelectedSlideFocus(slides[initialIndex]);

        if (slides.length === 1) {
          gallery.dataset.mekhannGalleryBound = 'static';
          return;
        }

        var mountGallery = function() {
          gallery.dataset.mekhannGalleryBound = 'true';
          if (force) self.prepareLampshadeGalleryImages(gallery, initialIndex);
          var skipInitialVariantSync = true;

          track.mekhannSlideshow = new theme.Slideshow(track, {
            adaptiveHeight: false,
            callbacks: {
              onChange: function(index) {
                syncSelectedSlideFocus(slides[index]);
                if (skipInitialVariantSync && index === initialIndex) {
                  skipInitialVariantSync = false;
                  return;
                }
                skipInitialVariantSync = false;
                self.cancelLampshadeImageRequest(gridItem);
                self.setLampshadeImageStatus(gridItem, '');
                self.prepareLampshadeGalleryImages(gallery, index);
                var visibleSlides = Array.from(
                  track.querySelectorAll('[data-mobile-product-slide]:not(.mekhann-mobile-slide--inactive)')
                );
                self.syncLampshadeSlideVariant(gridItem, gallery, visibleSlides[index]);
                self.showLampshadeSlideImage(gridItem, visibleSlides[index]);
              }
            },
            cellSelector: '[data-mobile-product-slide]:not(.mekhann-mobile-slide--inactive)',
            draggable: true,
            dragThreshold: 18,
            initialIndex: initialIndex,
            pageDots: true,
            prevNextButtons: window.matchMedia('(min-width: 769px)').matches,
            setGallerySize: true,
            wrapAround: false,
          });
        };

        // A customer-triggered swatch change must finish in the same task.
        // Waiting for a new IntersectionObserver callback after destroying the
        // previous Flickity instance creates a visible one-frame state with no
        // arrows/dots and only one slide. Initial off-screen galleries remain
        // lazy, but forced rebuilds mount synchronously and do not flicker.
        if (force) {
          mountGallery();
        } else if ('IntersectionObserver' in window) {
          gallery.dataset.mekhannGalleryBound = 'pending';

          var observer = new IntersectionObserver(function(entries) {
            // Disconnect does not retire a callback already queued by the
            // browser. Only the current connected collection owner may mount.
            if (gallery.mekhannGalleryObserver !== observer) return;
            if (!gallery.isConnected || !self.container.contains(gallery)) {
              observer.disconnect();
              gallery.mekhannGalleryObserver = null;
              return;
            }
            if (!entries[0].isIntersecting) {
              return;
            }

            observer.disconnect();
            gallery.mekhannGalleryObserver = null;
            mountGallery();
          }, {rootMargin: '200px 0px'});

          gallery.mekhannGalleryObserver = observer;
          observer.observe(gallery);
        } else {
          mountGallery();
        }
      },
  
      /*====================
        Collection filters: one request owner and one mounted view.
      ====================*/
      initFilters: function() {
        this.unbindFilterControls();
        this.bindBackButton();
        this._filterForms = Array.from(this.container.querySelectorAll(selectors.tagsForm));
        this._filterTags = Array.from(this.container.querySelectorAll(selectors.activeTags));
        this._formListener = this.onFormSubmit.bind(this);
        this._tagListener = this.tagClick.bind(this);
        this._filterForms.forEach(function(form) { form.addEventListener('input', this._formListener); }.bind(this));
        this._filterTags.forEach(function(tag) { tag.addEventListener('click', this._tagListener); }.bind(this));
        this._resultButtons = Array.from(this.container.querySelectorAll('[data-plp-show-results]'));
        this._resultListener = this.showFilterResults.bind(this);
        this._resultButtons.forEach(function(button) { button.addEventListener('click', this._resultListener); }.bind(this));
        if (this.isLampshadesPLP() && !this._drawerStatusListener) {
          this._drawerStatusListener = this.refreshCollectionStatus.bind(this);
          document.addEventListener('drawerOpen.FilterDrawer', this._drawerStatusListener);
          document.addEventListener('drawerClose.FilterDrawer', this._drawerStatusListener);
          this._panelMedia = window.matchMedia('(min-width: 1024px)');
          this._panelMediaListener = function(evt) {
            var drawer = this.sidebar && this.sidebar.drawer;
            if (evt.matches && drawer && drawer.isOpen && !this.sidebar.drawerStyle) {
              drawer.close(null, true);
              var target = this.container.querySelector('.collection-sidebar .collapsible-trigger');
              if (target) target.focus({ preventScroll: true });
            }
          }.bind(this);
          this._panelMedia.addEventListener('change', this._panelMediaListener);
        }
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
          if (!this._resizeListener) this._resizeListener = theme.utils.debounce(500, this.setFilterStickyPosition.bind(this));
          window.off('resize' + this.namespace);
          window.on('resize' + this.namespace, this._resizeListener);
        }
        if (!this._policyChecked) {
          this._policyChecked = true;
          var current = new URLSearchParams(window.location.search);
          var clean = this.cleanCollectionParams(current);
          if (clean.toString() !== current.toString()) {
            this.renderCollectionPage(clean, true, { replaceHistory: true, replaceParams: true });
          }
        }
      },

      unbindFilterControls: function() {
        (this._filterForms || []).forEach(function(form) { form.removeEventListener('input', this._formListener); }.bind(this));
        (this._filterTags || []).forEach(function(tag) { tag.removeEventListener('click', this._tagListener); }.bind(this));
        (this._resultButtons || []).forEach(function(button) { button.removeEventListener('click', this._resultListener); }.bind(this));
        this._filterForms = [];
        this._filterTags = [];
        this._resultButtons = [];
      },

      cleanCollectionParams: function(params) {
        var clean = new URLSearchParams(params);
        if (this.container.querySelector('[data-filter-package="lampshades"]')) {
          var retired = ['filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability'];
          var changed = retired.some(function(key) { return clean.has(key); });
          retired.forEach(function(key) { clean.delete(key); });
          if (changed) clean.delete('page');
        }
        return clean;
      },

      initPriceRange: function() {
        this.container.querySelectorAll(selectors.priceRange).forEach(function(el) {
          new theme.PriceRange(el, { onChange: this.renderFromFormData.bind(this) });
        }.bind(this));
      },

      captureFilterFocus: function(element) {
        var drawer = this.sidebar && this.sidebar.drawer;
        var drawerOpen = drawer && drawer.isOpen;
        this._filterScrollIntent = element || null;
        this._filterFocus = {
          drawer: !!drawerOpen,
          name: element && element.name,
          value: element && element.value,
          id: element && element.id,
          results: !element || !element.name
        };
        if (drawerOpen && !this.isLampshadesPLP()) drawer.close();
      },

      isLampshadesPLP: function() {
        return this.container.getAttribute('data-mekhann-plp') === 'lampshades';
      },

      tagClick: function(evt) {
        var el = evt.currentTarget;
        if (el.classList.contains('no-ajax')) return;
        evt.preventDefault();
        // PLP19-R8: this action belongs to the open filter panel. Its response
        // can detach the clicked chip before the window outside-click handler.
        if (this.isLampshadesPLP() && el.closest('[data-plp-filter-drawer]')) evt.stopPropagation();
        this.captureFilterFocus(el);
        var params = new URLSearchParams(this._desiredParams || window.location.search);
        if (el.hasAttribute('data-clear-filters')) {
          Array.from(new Set(Array.from(params.keys()))).forEach(function(key) {
            if (key.indexOf('filter.') === 0 || key === 'page') params.delete(key);
          });
        } else if (el.dataset.filterParam) {
          var key = el.dataset.filterParam;
          var retained = params.getAll(key).filter(function(value) { return value !== el.dataset.filterValue; });
          params.delete(key);
          retained.forEach(function(value) { params.append(key, value); });
          params.delete('page');
        } else {
          var url = new URL(el.href, window.location.origin);
          params = this.ajaxRenderer.getUpdatedParams(params, new URLSearchParams(url.search));
        }
        this.syncFilterInputs(params);
        this.renderCollectionPage(params, true, { replaceParams: true });
      },

      syncFilterInputs: function(params) {
        this.container.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
          input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
        });
      },

      onFormSubmit: function(evt) {
        var el = evt.target;
        if (el.classList.contains('no-ajax')) return;
        evt.preventDefault();
        this.captureFilterFocus(el);
        // Keep desktop and drawer forms in the same draft state while a request
        // is pending. A second input is accepted and supersedes the first GET.
        if (el.type === 'checkbox') {
          var params = new URLSearchParams(this._desiredParams || window.location.search);
          var selected = params.getAll(el.name).filter(function(value) { return value !== el.value; });
          if (el.checked) selected.push(el.value);
          params.delete(el.name);
          selected.forEach(function(value) { params.append(el.name, value); });
          params.delete('page');
          this.syncFilterInputs(params);
          this.renderCollectionPage(params, true, { replaceParams: true });
          return;
        }
        this.renderFromFormData(new FormData(el.closest('form')));
      },

      renderFromFormData: function(formData) {
        var params = this.ajaxRenderer.getUpdatedParams(new URLSearchParams(window.location.search), new URLSearchParams(formData));
        return this.renderCollectionPage(params, true, { replaceParams: true });
      },

      fetchOpenCollasibleFilters: function() {
        return Array.from(this.container.querySelectorAll(selectors.sidebar + ' ' + selectors.trigger + '.' + classes.isOpen))
          .map(function(trigger) { return trigger.dataset.collapsibleId; });
      },

      disposeGrid: function(scope) {
        if (!scope) return;
        scope.querySelectorAll('.grid-product--lampshades').forEach(this.cancelLampshadeImageRequest.bind(this));
        scope.querySelectorAll('[data-mobile-product-gallery]').forEach(function(gallery) {
          if (gallery.mekhannGalleryIntentHandler) {
            gallery.removeEventListener('pointerdown', gallery.mekhannGalleryIntentHandler);
            gallery.removeEventListener('focusin', gallery.mekhannGalleryIntentHandler);
            gallery.mekhannGalleryIntentHandler = null;
          }
          if (gallery.mekhannGalleryObserver) {
            gallery.mekhannGalleryObserver.disconnect();
            gallery.mekhannGalleryObserver = null;
          }
          var track = gallery.querySelector('[data-mobile-product-track]');
          if (track && track.mekhannSlideshow) {
            track.mekhannSlideshow.destroy();
            track.mekhannSlideshow = null;
          }
        });
        if (this.isLampshadesPLP()) {
          // Flickity destroy reconnects slides before this scope is replaced.
          // Retire native image owners after that move, including reopened ones.
          scope.querySelectorAll('image-element').forEach(function(image) {
            if (typeof image.mekhannDisposeObserver === 'function') image.mekhannDisposeObserver();
          });
        }
      },

      onReplaceAjaxContent: function(newDom, section) {
        var newContentEl = newDom.getElementById(section.nodeId);
        var current = document.getElementById(section.nodeId);
        if (!newContentEl || !current) throw new Error('Collection section is no longer available');
        if (this.isLampshadesPLP()) {
          if (!newContentEl.querySelector('.collection-grid__wrapper')) throw new Error('Collection results are missing');
          if (current.querySelector('[data-plp-filter-drawer]') &&
              (!newContentEl.querySelector('[data-plp-panel-form]') || !newContentEl.querySelector('[data-plp-show-results]'))) {
            throw new Error('Filter response is incomplete');
          }
        }
        var focus = document.activeElement;
        var closeOwnsFocus = this._filterFocus && (this._filterFocus.drawer || this._filterFocus.retry) &&
          (!focus || focus === document.body || focus === document.documentElement);
        this._focusWasInGrid = current.contains(focus) || closeOwnsFocus;
        var viewport = this._filterViewport;
        if (viewport) {
          // Decide ownership before replacement can clamp the document scroll.
          viewport.owned = viewport.source === focus && viewport.source.isConnected &&
            Math.abs(window.pageYOffset - viewport.pageY) <= 1 &&
            this._panelMedia && this._panelMedia.matches &&
            !(this.sidebar && this.sidebar.drawer && this.sidebar.drawer.isOpen);
          if (viewport.source !== focus) this._focusWasInGrid = false;
        }
        var sidebarScroll = this.isLampshadesPLP() && this._panelMedia && this._panelMedia.matches ?
          ['.grid__item--sidebar', '.collection-sidebar'].map(function(selector) {
            var element = current.querySelector(selector);
            return { selector: selector, top: element ? element.scrollTop : 0 };
          }) : [];
        var states = {};
        current.querySelectorAll('.collapsible-trigger[data-collapsible-id]').forEach(function(trigger) {
          states[trigger.getAttribute('aria-controls')] = trigger.classList.contains('is-open');
        });
        newContentEl.querySelectorAll('.collapsible-trigger[data-collapsible-id]').forEach(function(trigger) {
          var id = trigger.getAttribute('aria-controls');
          if (!Object.prototype.hasOwnProperty.call(states, id)) return;
          var open = states[id];
          var content = newDom.getElementById(id);
          trigger.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (content) { content.classList.toggle('is-open', open); content.style.height = open ? 'auto' : '0px'; }
        });
        this.unbindFilterControls();
        this.disposeGrid(current);
        var drawer = this.sidebar && this.sidebar.drawer;
        var incomingDrawer = newContentEl.querySelector('[data-plp-filter-drawer]');
        var preserved = this.isLampshadesPLP() && drawer && drawer.drawer && incomingDrawer;
        if (preserved) {
          // Keep the native controller, close button and footer mounted. Only
          // the server-owned form contents and confirmed result count change.
          var oldForm = drawer.drawer.querySelector('[data-plp-panel-form]');
          var newForm = incomingDrawer.querySelector('[data-plp-panel-form]');
          var oldButton = drawer.drawer.querySelector('[data-plp-show-results]');
          var newButton = incomingDrawer.querySelector('[data-plp-show-results]');
          if (!oldForm || !newForm || !oldButton || !newButton) throw new Error('Filter response is incomplete');
          var scrollTop = oldForm.scrollTop;
          oldForm.innerHTML = newForm.innerHTML;
          oldForm.scrollTop = scrollTop;
          oldButton.dataset.plpResultsCount = newButton.dataset.plpResultsCount;
          oldButton.textContent = newButton.textContent;
          incomingDrawer.replaceWith(drawer.drawer);
          current.replaceChildren.apply(current, Array.from(newContentEl.childNodes));
        } else {
          this.sidebar.onUnload();
          current.innerHTML = newContentEl.innerHTML;
        }
        this.sidebar.container = this.container.querySelector('#CollectionSidebar');
        sidebarScroll.forEach(function(state) {
          var element = current.querySelector(state.selector);
          if (element) element.scrollTop = state.top;
        });
      },

      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) el.style.height = 'auto';
        el.classList.add(classes.isOpen);
      },

      getCollectionStatus: function() {
        if (this.isLampshadesPLP()) {
          var drawer = this.sidebar && this.sidebar.drawer;
          var selected = this.container.querySelector(drawer && drawer.isOpen ? '[data-plp-panel-status]' : '[data-plp-results-status]');
          if (selected) return selected;
        }
        if (this._collectionStatus && this._collectionStatus.isConnected) return this._collectionStatus;
        var status = document.createElement('div');
        status.className = 'collection-filter__status visually-hidden';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        var content = this.container.querySelector('#CollectionAjaxContent');
        this.container.insertBefore(status, content || this.container.firstChild);
        this._collectionStatus = status;
        return status;
      },

      setCollectionStatus: function(message, visible, retryOptions) {
        this._statusState = { message: message, visible: visible, retry: retryOptions };
        var status = this.getCollectionStatus();
        this.container.querySelectorAll('[data-plp-panel-status], [data-plp-results-status]').forEach(function(el) {
          if (el !== status) { el.textContent = ''; el.setAttribute('aria-live', 'off'); }
        });
        status.setAttribute('aria-live', 'polite');
        status.classList.toggle('visually-hidden', !visible);
        status.textContent = message;
        if (retryOptions) {
          var retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'collection-filter__retry';
          retry.textContent = 'Try again';
          retry.addEventListener('click', function(evt) {
            // This button is replaced by the pending status synchronously.
            // Do not let its detached target reach the drawer outside-click handler.
            evt.stopPropagation();
            this.captureFilterFocus(retry);
            this._filterFocus.retry = true;
            this.renderCollectionPage(retryOptions.params, retryOptions.updateURLHash, retryOptions.options);
          }.bind(this));
          status.appendChild(document.createTextNode(' '));
          status.appendChild(retry);
        }
        return status;
      },

      refreshCollectionStatus: function() {
        var state = this._statusState;
        if (state) this.setCollectionStatus(state.message, state.visible, state.retry);
      },

      updateResultsButton: function() {
        this.container.querySelectorAll('[data-plp-show-results]').forEach(function(button) {
          var count = Number(button.dataset.plpResultsCount || 0);
          button.disabled = !!(this._filterPending || this._filterFailed);
          button.textContent = this._filterPending ? 'Updating selection…' : this._filterFailed ? 'Show results' :
            'Show ' + count + (count === 1 ? ' lampshade' : ' lampshades');
        }.bind(this));
      },

      showFilterResults: function(evt) {
        evt.preventDefault();
        if (this._filterPending || this._filterFailed) return;
        var drawer = this.sidebar && this.sidebar.drawer;
        if (drawer) drawer.close(null, true);
        var results = this.container.querySelector(selectors.collectionGrid);
        if (results) { results.setAttribute('tabindex', '-1'); results.focus({ preventScroll: true }); }
        this.updateScroll(true);
      },

      renderCollectionPage: function(searchParams, updateURLHash = true, options = {}) {
        var self = this;
        var requestId = this._requestId = (this._requestId || 0) + 1;
        var params = this.cleanCollectionParams(searchParams);
        this._desiredParams = new URLSearchParams(params);
        var lastFocus = this._filterFocus;
        this._filterPending = true;
        this._filterFailed = false;
        this.startLoading();
        this.updateResultsButton();
        this.setCollectionStatus('Updating selection…', this.isLampshadesPLP());
        var viewport = this.captureFilterViewport(this._filterScrollIntent);
        this._filterScrollIntent = null;
        this._filterViewport = viewport;
        return this.ajaxRenderer.renderPage(window.location.pathname, params, updateURLHash, options)
          .then(function(result) {
            if (requestId !== self._requestId || !result.applied) return result;
            self._filterPending = false;
            self.init();
            theme.reinitProductGridItem(self.container);
            self.updateScroll(false);
            var count = self.container.querySelectorAll('.collection-grid__wrapper .grid--uniform > .grid__item').length;
            var isLampshades = self.isLampshadesPLP();
            var emptyMessage = isLampshades ? 'No lampshades match these filters.' : 'No results match this selection. Clear your filters to see all results.';
            var visibleEmptyState = self.container.querySelector('[data-collection-empty]');
            self.setCollectionStatus(count ? 'Selection updated.' : emptyMessage, !count && !visibleEmptyState);
            self.restoreFilterFocus(lastFocus);
            self.restoreFilterViewport(viewport);
            document.dispatchEvent(new CustomEvent('collection:reloaded'));
            return result;
          }).catch(function(error) {
            if (requestId !== self._requestId) return { applied: false, stale: true };
            self._filterFailed = true;
            self.setCollectionStatus('We couldn’t update the selection. Please try again.', true, {
              params: params, updateURLHash: updateURLHash, options: options
            });
            return { applied: false, error: error };
          }).finally(function() {
            if (requestId !== self._requestId) return;
            self._filterViewport = null;
            self._filterPending = false;
            self.updateResultsButton();
            var grid = self.container.querySelector(selectors.collectionGrid);
            if (grid) {
              grid.classList.remove('unload', 'is-filter-updating');
              grid.removeAttribute('aria-busy');
              var products = grid.querySelector('.grid--uniform');
              if (products) products.removeAttribute('aria-busy');
            }
          });
      },

      restoreFilterFocus: function(saved) {
        if (!saved || !this._focusWasInGrid) return;
        var drawer = this.sidebar && this.sidebar.drawer;
        // A user who closed the panel while waiting owns that decision.
        if (saved.drawer && drawer && !drawer.isOpen && this.isLampshadesPLP()) return;
        var scope = saved.drawer && drawer && drawer.isOpen ? drawer.drawer : this.container;
        var target;
        if (saved.name) target = Array.from(scope.querySelectorAll('input')).find(function(input) {
          return input.name === saved.name && input.value === saved.value && input.getClientRects().length;
        });
        if (!target && saved.drawer && drawer && drawer.isOpen) target = drawer.drawer.querySelector('.js-drawer-close');
        if (!target) {
          target = this.container.querySelector(selectors.collectionGrid);
          if (target) target.setAttribute('tabindex', '-1');
        }
        if (target) target.focus({ preventScroll: true });
      },

      captureFilterViewport: function(source) {
        var drawer = this.sidebar && this.sidebar.drawer;
        if (!this.isLampshadesPLP() || !this._panelMedia || !this._panelMedia.matches ||
            (drawer && drawer.isOpen) || !source || !source.isConnected ||
            !this.container.contains(source) || document.activeElement !== source) return null;
        return { source: source, pageY: window.pageYOffset, owned: false };
      },

      restoreFilterViewport: function(viewport) {
        if (!viewport || !viewport.owned || !this._panelMedia || !this._panelMedia.matches) return;
        var drawer = this.sidebar && this.sidebar.drawer;
        if (drawer && drawer.isOpen) return;
        var grid = this.container.querySelector(selectors.collectionGrid);
        if (!grid) return;
        var header = document.querySelector('.site-header');
        var visibleTop = theme.config.stickyHeader && header ?
          Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom)) : 0;
        // PLP19-R9: narrowing a long grid can clamp the page into the footer.
        // Recover only that lost-results case; ordinary filter updates stay put.
        if (grid.getBoundingClientRect().bottom <= visibleTop) this.updateScroll(true);
      },

      bindBackButton: function() {
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function() {
          this._filterFocus = null;
          this._filterScrollIntent = null;
          var original = new URLSearchParams(window.location.search);
          var clean = this.cleanCollectionParams(original);
          var retired = clean.toString() !== original.toString();
          this.renderCollectionPage(clean, retired, { replaceParams: true, replaceHistory: retired });
        }.bind(this));
      },

      updateScroll: function(force) {
        if (this.isLampshadesPLP() && !force) return;
        var anchor = this.container.querySelector('[data-scroll-to]');
        if (!anchor) return;
        var top = anchor.getBoundingClientRect().top + window.pageYOffset;
        if (!theme.config.bpSmall) top -= 15;
        var header = document.querySelector('.site-header');
        if (theme.config.stickyHeader && header) top -= header.offsetHeight;
        window.scrollTo({ top: Math.max(0, top) });
      },

      setFilterStickyPosition: function() {
        var header = document.querySelector('.site-header');
        var top = (header ? header.offsetHeight : 0) + 10 + 'px';
        var filters = this.container.querySelector(selectors.filters);
        if (filters) filters.style.top = top;
        var sidebar = this.container.querySelector('.grid__item--sidebar');
        if (sidebar) {
          sidebar.style.top = top;
          // The scroll box must use the same offset as its sticky owner.
          // Otherwise lower filter options can sit below the viewport.
          if (this.isLampshadesPLP()) sidebar.style.setProperty('--mekhann-plp-sidebar-top', top);
        }
      },

      forceReload: function() { this.init(); },

      onUnload: function() {
        this._requestId = (this._requestId || 0) + 1;
        this.ajaxRenderer.destroy();
        this.unbindFilterControls();
        document.removeEventListener('drawerOpen.FilterDrawer', this._drawerStatusListener);
        document.removeEventListener('drawerClose.FilterDrawer', this._drawerStatusListener);
        if (this._panelMedia) this._panelMedia.removeEventListener('change', this._panelMediaListener);
        this._drawerStatusListener = null;
        window.off('resize' + this.namespace);
        window.off('popstate' + this.namespace);
        if (this.sortSelect) this.sortSelect.off('change' + this.namespace);
        this.disposeGrid(this.container);
        this.sidebar.onUnload();
      },

      startLoading: function() {
        var grid = this.container.querySelector(selectors.collectionGrid);
        if (grid) {
          grid.classList.add(this.isLampshadesPLP() ? 'is-filter-updating' : 'unload');
          var busyTarget = this.isLampshadesPLP() ? grid.querySelector('.grid--uniform') || grid : grid;
          busyTarget.setAttribute('aria-busy', 'true');
        }
      },

    });
  
    return Collection;
  })();
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
        this.hoverMenu();
      },
  
      hoverMenu: function() {
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
  
        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;
  
          summary.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = summaryLink;
          });
  
          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
  
          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        if (theme.NavDrawer && typeof theme.NavDrawer.destroy === 'function') theme.NavDrawer.destroy();
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        this.navDrawer = theme.NavDrawer;
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            this.cartDrawer = new theme.CartDrawer();
          }
        }
  
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onUnload: function() {
        if (this.cartDrawer && typeof this.cartDrawer.destroy === 'function') this.cartDrawer.destroy();
        if (this.navDrawer && typeof this.navDrawer.destroy === 'function') this.navDrawer.destroy();
        else if (this.navDrawer) this.navDrawer.close();
        theme.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        sizeOptionIndex: null,
        currentSizeScope: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      // Expose the owning Product controller to the Mekhann readiness gate. This
      // permits direct Flickity selection without clicking a thumbnail anchor.
      this.container.mekhannProductInstance = this;
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.setupMekhannMediaFit();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },

      // V2.25: keep the original large image column and intrinsic media ratio.
      // Carousel measurement follows loading/selection, never a viewport cap.
      setupMekhannMediaFit: function() {
        if (this.inModal || this.container.dataset.mekhannPdpSystem !== 'modular-v1') return;
        if (this.mekhannMediaFitCleanup) this.mekhannMediaFitCleanup();
        var section = this.container;
        var main = this.cache.mainSlider;
        var self = this;
        var frame = 0;
        var stopped = false;
        var lastWidth = 0;
        var decoded = new WeakSet();
        section.style.removeProperty('--mekhann-pdp-media-max-height');
        var measure = function() {
          frame = 0;
          if (stopped || !section.isConnected) return;
          var selected = main.querySelector('.flickity-slider .is-selected') || main.querySelector('.starting-slide') || main.querySelector('.product-main-slide');
          var image = selected && selected.querySelector('img');
          if (image) {
            // Newly selected lazy images become immediate only after intent.
            image.loading = 'eager';
            if (!decoded.has(image) && typeof image.decode === 'function') {
              decoded.add(image);
              image.decode().then(schedule).catch(function() {});
            }
          }
          if (self.flickity && typeof self.flickity.resize === 'function') self.flickity.resize();
        };
        var schedule = function() {
          if (!frame && !stopped) frame = window.requestAnimationFrame(measure);
        };
        var imageState = function(evt) {
          var image = evt.target;
          if (!image || image.tagName !== 'IMG') return;
          var slide = image.closest('.product-main-slide');
          var message = slide && slide.querySelector('[data-mekhann-media-error]');
          var failed = evt.type === 'error';
          if (message) {
            message.hidden = !failed;
            var retryButton = message.querySelector('[data-mekhann-media-retry]');
            if (retryButton) retryButton.disabled = false;
          }
          if (slide) slide.classList.toggle('mekhann-media-load-failed', failed);
          if (!failed) schedule();
        };
        var retry = function(evt) {
          var button = evt.target.closest('[data-mekhann-media-retry]');
          if (!button || !main.contains(button)) return;
          var slide = button.closest('.product-main-slide');
          var image = slide && slide.querySelector('img');
          if (!image) return;
          var source = image.getAttribute('src');
          var sources = image.getAttribute('srcset');
          button.disabled = true;
          decoded.delete(image);
          image.removeAttribute('srcset');
          image.removeAttribute('src');
          if (sources) image.setAttribute('srcset', sources);
          image.setAttribute('src', source);
        };
        main.addEventListener('load', imageState, true);
        main.addEventListener('error', imageState, true);
        main.addEventListener('click', retry);
        main.querySelectorAll('img').forEach(function(image) {
          if (image.complete && image.getAttribute('src') && image.naturalWidth === 0) imageState({ target: image, type: 'error' });
        });
        window.addEventListener('resize', schedule);
        window.addEventListener('orientationchange', schedule);
        window.addEventListener('load', schedule);
        var observer = window.ResizeObserver ? new window.ResizeObserver(function(entries) {
          var width = entries[0] && entries[0].contentRect.width;
          if (width && width !== lastWidth) { lastWidth = width; schedule(); }
        }) : null;
        if (observer) observer.observe(main);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
        this.scheduleMekhannMediaLayout = schedule;
        this.mekhannMediaFitCleanup = function() {
          stopped = true;
          if (frame) window.cancelAnimationFrame(frame);
          main.removeEventListener('load', imageState, true);
          main.removeEventListener('error', imageState, true);
          main.removeEventListener('click', retry);
          window.removeEventListener('resize', schedule);
          window.removeEventListener('orientationchange', schedule);
          window.removeEventListener('load', schedule);
          if (observer) observer.disconnect();
          self.scheduleMekhannMediaLayout = null;
        };
        measure();
      },

      applyMekhannInitialMedia: function(sliderArgs) {
        // A PLP media link is initial navigation intent, not a later slide
        // change. Resolve it once inside the active colour/size cell set,
        // before Flickity and its thumbnail navigation are constructed.
        if (this.inModal || this.mekhannInitialMediaResolved) return;
        this.mekhannInitialMediaResolved = true;
        var isMekhannPdp = this.container.dataset.productTemplate === 'lampshade' ||
          this.container.dataset.mekhannPdpSystem === 'modular-v1';
        if (!isMekhannPdp) return;

        var requestedMediaId = '';
        try {
          requestedMediaId = new URL(window.location.href).searchParams.get('media') || '';
        } catch (error) {
          return;
        }
        if (!requestedMediaId) return;

        var visibleSlides = Array.from(this.cache.mainSlider.querySelectorAll(sliderArgs.cellSelector || selectors.slide));
        var requestedIndex = visibleSlides.findIndex(function(slide) {
          return String(slide.dataset.mediaId || '') === requestedMediaId;
        });
        if (requestedIndex < 0) return;

        sliderArgs.initialIndex = requestedIndex;
        this.settings.currentSlideIndex = requestedIndex;
      },

      restoreMekhannSlideOrder: function() {
        var isMekhannPdp = this.container.dataset.productTemplate === 'lampshade' ||
          this.container.dataset.mekhannPdpSystem === 'modular-v1';
        if (this.inModal || !isMekhannPdp || !(this.settings.imageSetName || this.settings.sizeOptionIndex)) return;

        // Flickity appends filtered cells after excluded siblings on destroy.
        // Restore Liquid's product.media order before assigning new filtered
        // indices, so the main gallery and unchanged thumbnail order agree.
        var slides = Array.from(this.cache.mainSlider.children).filter(function(slide) {
          return slide.matches(selectors.slide);
        });
        var indices = slides.map(function(slide) { return slide.getAttribute('data-index'); });
        if (indices.some(function(index) { return !/^\d+$/.test(index || '') || !Number.isSafeInteger(Number(index)); }) ||
          new Set(indices.map(Number)).size !== slides.length) return;

        slides.sort(function(a, b) { return Number(a.dataset.index) - Number(b.dataset.index); });
        var mainSlider = this.cache.mainSlider;
        slides.forEach(function(slide) { mainSlider.appendChild(slide); });
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // initProductSlider runs once after form and media setup. Variant
        // changes keep using updateImageSet once their listeners are bound.
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
  
        if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
        var cushionPadPrice = parseInt(this.container.getAttribute('data-cushion-pad-price'), 10) || 0;

        // Internal fitting products must never enter customer-facing history.
        if (theme.recentlyViewed.shouldExclude(handle)) {
          if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
            delete theme.recentlyViewed.recent[handle];
          }

          theme.recentlyViewed.saveHistory();
          return;
        }

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
          cushionPadPrice: cushionPadPrice
        };
  
        theme.recentlyViewed.saveHistory();
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new theme.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // Image-set colour and Mekhann size scope share one slider rebuild so a
        // Size change within the same colour cannot retain the other size's
        // context frame.
        var sizeWrapper = Array.from(this.container.querySelectorAll('.variant-input-wrap[data-handle]')).find(function(wrapper) {
          return wrapper.dataset.handle === 'size';
        });
        if (sizeWrapper) {
          this.settings.sizeOptionIndex = sizeWrapper.dataset.index;
        }

        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
          } else {
            this.settings.imageSetName = null;
          }
        }

        if (this.settings.imageSetName || this.settings.sizeOptionIndex) {
          this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this));
        }
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        new theme.AjaxProduct(this.cache.form);
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
  
        if (!cartBtn) return;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
        if (window.MekhannPdpCarrier && typeof window.MekhannPdpCarrier.syncControls === 'function') {
          window.MekhannPdpCarrier.syncControls(cartBtn);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) return;

        // Price/savings blocks are optional in supported product configurations.
        var cache = this.cache;
        var onSale = variant.compare_at_price > variant.price;
        if (cache.price) {
          cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
          cache.price.classList.toggle(classes.onSale, onSale);
        }
        if (cache.priceWrapper) cache.priceWrapper.classList.toggle(classes.hidden, !onSale);
        if (cache.priceA11y) cache.priceA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
        if (cache.comparePriceA11y) cache.comparePriceA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
        if (cache.comparePrice && onSale) {
          cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
        }
        if (cache.savePrice) {
          cache.savePrice.classList.toggle(classes.hidden, !onSale);
          if (onSale) {
            var savings = variant.compare_at_price - variant.price;
            savings = theme.settings.saveType == 'percent'
              ? Math.round(savings * 100 / variant.compare_at_price) + '%'
              : theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      getMekhannPreferredSlide: function(variant, slides, selectedGroup, sizeScope) {
        if (!slides || !slides.length) {
          return null;
        }

        var featuredMediaId = variant && variant.featured_media ? variant.featured_media.id : '';
        var mediaItems = Array.from(slides).map(function(slide) {
          return {
            id: String(slide.dataset.mediaId || ''),
            group: String(slide.dataset.group || 'all'),
            size: String(slide.dataset.mekhannSizeScope || 'all'),
            slide: slide
          };
        });
        var preferredMedia = theme.chooseMekhannMedia(
          mediaItems,
          selectedGroup || 'all',
          sizeScope || 'all',
          featuredMediaId
        );

        return preferredMedia ? preferredMedia.slide : null;
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var sizeScope = this.settings.currentSizeScope = this.getMekhannSizeScope(variant);
        var set = this.settings.imageSetName + '_' + setValue;
        var commonSet = this.settings.imageSetName + '_common';
        var cellSelector = this.getMekhannMediaCellSelector([set, commonSet], sizeScope);
        var matchingSlides = Array.from(this.cache.mainSlider.querySelectorAll(cellSelector));
        var preferredSlide = this.getMekhannPreferredSlide(variant, matchingSlides, set, sizeScope);
        var initialIndex = preferredSlide ? matchingSlides.indexOf(preferredSlide) : 0;
  
        this.settings.currentSlideIndex = initialIndex;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: cellSelector,
          imageSet: set,
          sizeScope: sizeScope,
          initialIndex: this.settings.currentSlideIndex
        }
      },

      mekhannSizeArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        var sizeScope = this.settings.currentSizeScope = this.getMekhannSizeScope(variant);
        var cellSelector = this.getMekhannMediaCellSelector([], sizeScope);
        var matchingSlides = Array.from(this.cache.mainSlider.querySelectorAll(cellSelector));
        var preferredSlide = this.getMekhannPreferredSlide(variant, matchingSlides, 'all', sizeScope);
        var initialIndex = preferredSlide ? matchingSlides.indexOf(preferredSlide) : 0;

        this.settings.currentSlideIndex = initialIndex;

        return {
          cellSelector: cellSelector,
          sizeScope: sizeScope,
          initialIndex: initialIndex
        };
      },

      getMekhannSizeScope: function(variant) {
        if (!variant || !this.settings.sizeOptionIndex) {
          return 'all';
        }

        var sizeValue = variant[this.settings.sizeOptionIndex];
        return sizeValue ? this.getImageSetName(sizeValue) : 'all';
      },

      getMekhannMediaCellSelector: function(groups, sizeScope) {
        var sizeScopes = sizeScope && sizeScope !== 'all' ? ['all', sizeScope] : ['all'];
        var selectors = [];

        if (groups && groups.length) {
          groups.forEach(function(group) {
            if (!sizeScope || sizeScope === 'all') {
              selectors.push('[data-group="' + group + '"][data-mekhann-size-scope]');
            } else {
              sizeScopes.forEach(function(scope) {
                selectors.push('[data-group="' + group + '"][data-mekhann-size-scope="' + scope + '"]');
              });
            }
          });
        } else if (sizeScope && sizeScope !== 'all') {
          sizeScopes.forEach(function(scope) {
            selectors.push('[data-mekhann-size-scope="' + scope + '"]');
          });
        } else {
          selectors.push('[data-mekhann-size-scope]');
        }

        return selectors.join(', ');
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.settings.imageSetName ? this.getImageSetName(variant[this.settings.imageSetIndex]) : null;
        var sizeScope = this.getMekhannSizeScope(variant);
  
        // Already on the current colour and Size boundary.
        if (this.settings.currentImageSet === setValue && this.settings.currentSizeScope === sizeScope) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set, sizeScope) {
        var commonSet = this.settings.imageSetName + '_common';
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          var belongsToSet = thumb.dataset.group === set || thumb.dataset.group === commonSet;
          var thumbSizeScope = thumb.dataset.mekhannSizeScope || 'all';
          var belongsToSize = sizeScope === 'all' || thumbSizeScope === 'all' || thumbSizeScope === sizeScope;
          thumb.classList.toggle(classes.hidden, !belongsToSet || !belongsToSize);
        });
      },

      updateMekhannSizeThumbs: function(sizeScope) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          var thumbSizeScope = thumb.dataset.mekhannSizeScope || 'all';
          var belongsToSize = sizeScope === 'all' || thumbSizeScope === 'all' || thumbSizeScope === sizeScope;
          thumb.classList.toggle(classes.hidden, !belongsToSize);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];
  
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > this.settings.inventoryThreshold || variantInventoryObject.policy === 'continue') {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(variant, variantInventoryObject);
  
          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(variant, variantInventoryObject) {
        const { quantity, policy } = variantInventoryObject || {};
        if (!this.settings.inventory) {
          return;
        }
  
        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');
  
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && policy !== 'continue') {
          el.parentNode.classList.add('inventory--low');
          if (quantity > 1) {
            el.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
          } else {
            el.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
          }
        } else {
          el.parentNode.classList.remove('inventory--low');
          el.textContent = theme.strings.inStockLabel;
        }
  
        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
  
        if (!el) {
          return;
        }
  
        var salesPoint = el.closest('.product-block');
        var textEl = el.querySelector('.js-incoming-text');
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.videoId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      initVimeoVideo: function(div) {
        videoObjects[div.id] = new theme.VimeoPlayer(
          div.id,
          div.dataset.videoId,
          {
            videoParent: selectors.videoParent,
            autoplay: false,
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
          }
        )
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        if (!variant || !variant.featured_media) {
          return;
        }

        var hasMekhannMediaFilter = this.settings.imageSetName || this.settings.sizeOptionIndex;
        var visibleSlides = hasMekhannMediaFilter ?
          Array.from(this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')) :
          Array.from(this.cache.mainSlider.querySelectorAll('.product-main-slide'));
        var sizeScope = this.getMekhannSizeScope(variant);
        var selectedGroup = 'all';

        if (this.settings.imageSetName && this.settings.imageSetIndex != null) {
          selectedGroup = this.settings.imageSetName + '_' + this.getImageSetName(variant[this.settings.imageSetIndex]);
        }

        var preferredSlide = this.getMekhannPreferredSlide(variant, visibleSlides, selectedGroup, sizeScope);
        var imageIndex = preferredSlide ? visibleSlides.indexOf(preferredSlide) : -1;

        // Filtered Flickity cells have their own zero-based order. Never use
        // the thumbnail's original product-media index here.
        if (this.flickity) {
          if (imageIndex >= 0) {
            this.flickity.goToSlide(imageIndex);
          }
          return;
        }

        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        if (newImage && typeof this.getThumbIndex(newImage) !== 'undefined') {
          this.settings.currentSlideIndex = this.getThumbIndex(newImage);
        }
      },
  
      initProductSlider: function(variant) {
        // Fail open if an interrupted parser did not reach the matching inline
        // entry reconciliation. The guard never waits for an image or network.
        if (this.cache.mainSlider.dataset.mekhannEntryPending === 'true') {
          this.cache.mainSlider.style.removeProperty('visibility');
          delete this.cache.mainSlider.dataset.mekhannEntryPending;
        }
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
          this.flickity = null;
          this.restoreMekhannSlideOrder();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: false, // intrinsic wrappers reserve the correct selected media ratio
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onChange: this.onSlideChange.bind(this)
          }
        };

        var mekhannPdpSection = this.container && this.container.closest &&
          this.container.closest('.product-section[data-mekhann-pdp-system="modular-v1"]');

        if (mekhannPdpSection) {
          var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          var desktopDrag = String(mekhannPdpSection.dataset.mekhannDesktopDrag || 'false').toLowerCase();
          var desktopDragEnabled = /^(true|1|on|enabled)$/.test(desktopDrag);
          mainSliderArgs.dragThreshold = 12;
          mainSliderArgs.draggable = hasFinePointer ? desktopDragEnabled : true;
        } else if (this.container && this.container.closest &&
          this.container.closest('.product-section[data-product-template="lampshade"]')) {
          var legacyHasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          mainSliderArgs.dragThreshold = 12;
          mainSliderArgs.draggable = !legacyHasFinePointer;
        }
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet, mainSliderArgs.sizeScope);
        } else if (this.settings.sizeOptionIndex) {
          var sizeSetArgs = this.mekhannSizeArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, sizeSetArgs);
          this.updateMekhannSizeThumbs(mainSliderArgs.sizeScope);
        }

        this.applyMekhannInitialMedia(mainSliderArgs);
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
        // Flickity's ready callback can fire inside its constructor. Media
        // preparation needs the assigned owner (including filtered first video).
        this.onSliderInit(this.cache.mainSlider.querySelector(selectors.currentSlide));
        this.cache.mainSlider.setAttribute('data-mekhann-gallery-ready', 'true');
        if (this.scheduleMekhannMediaLayout) this.scheduleMekhannMediaLayout();
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (slide && (this.settings.imageSetName || this.settings.sizeOptionIndex)) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
        if (this.scheduleMekhannMediaLayout) this.scheduleMekhannMediaLayout();

        var hasMekhannMediaFilter = this.settings.imageSetName || this.settings.sizeOptionIndex;
        var visibleSlides = hasMekhannMediaFilter ?
          this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide') :
          null;
        var prevSlide = hasMekhannMediaFilter ?
          visibleSlides[this.settings.currentSlideIndex] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
        var nextSlide = hasMekhannMediaFilter ?
          visibleSlides[index] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');

        if (!prevSlide || !nextSlide) {
          return;
        }
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        if (!slide) return;
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId] && videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        if (!slide) return;
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          if (this.flickity) this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId] && videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          var modelButton = slide.querySelector('.shopify-model-viewer-ui__button');
          var closeButton = slide.querySelector('.product-single__close-media');
          if (modelButton) modelButton.setAttribute('tabindex', 0);
          if (closeButton) closeButton.setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el ? el.getAttribute('data-index') : 0;
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;
  
          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);
  
            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');
  
              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }
  
              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });
  
            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }
  
            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');
  
            this.cacheElements();
  
            this.formSetup();
            this.initProductSlider();
            this.updateModalProductInventory();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));
  
          this.productSetup();
          this.videoSetup();
  
          // Gallery creation waits for the fetched form above, so the first
          // selection already has its colour and size boundaries.
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        AOS.refreshHard();
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },
  
      onUnload: function() {
        if (this.mekhannMediaFitCleanup) this.mekhannMediaFitCleanup();
        theme.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  theme.RecentlyViewed = (function() {
    var cacheContext = null;
    var pending = Object.create(null);

    function storefrontRoot() {
      var root = theme.routes && theme.routes.home || '/';
      return root.replace(/\/?$/, '/');
    }

    function priceContext() {
      var shopify = window.Shopify || {};
      return JSON.stringify([
        window.location.host,
        storefrontRoot(),
        shopify.country || '',
        shopify.currency && shopify.currency.active || '',
        shopify.locale || document.documentElement.lang || ''
      ]);
    }

    function currentCache() {
      var context = priceContext();
      if (context !== cacheContext) {
        cacheContext = context;
        theme.recentlyViewed.productInfo = {};
        pending = Object.create(null);
      }
      return context;
    }

    function validProduct(product, handle) {
      return product && typeof product === 'object' && !Array.isArray(product) &&
        typeof product.handle === 'string' && product.handle !== 'undefined' &&
        (!handle || product.handle === handle) &&
        typeof product.title === 'string' && Array.isArray(product.variants) &&
        product.variants.every(function(variant) { return variant && typeof variant === 'object' && !Array.isArray(variant); }) &&
        ['price', 'price_min', 'price_max'].every(function(key) {
          return typeof product[key] === 'number' && Number.isFinite(product[key]) && product[key] >= 0;
        }) && (product.featured_image == null || typeof product.featured_image === 'string');
    }

    function RecentlyViewed(container) {
      if (!container) { return; }
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
      this.imageSizes = this.container.getAttribute('data-image-sizes');
      this.initialized = false;
      this.unloaded = false;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (this.initialized || this.unloaded) { return; }
        this.initialized = true;
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
        if (!this.outputContainer) { return; }

        var self = this;
        var context = currentCache();
        var limit = Math.max(1, Math.min(10, Math.floor(Number(this.container.getAttribute('data-recent-count')) || 5)));
        theme.recentlyViewed.trimHistory();
        // Recent history is insertion ordered. Select newest candidates before
        // fetching; only bounded replacements are allowed for missing products.
        var handles = Object.keys(theme.recentlyViewed.recent).reverse().filter(function(handle) {
          return handle !== self.handle && !theme.recentlyViewed.shouldExclude(handle);
        }).slice(0, limit * 2);
        if (!handles.length) {
          this.container.classList.add('hide');
          return;
        }

        var cursor = 0;
        var active = 0;
        var found = 0;
        var products = [];
        function isCurrent() { return !self.unloaded && context === priceContext(); }
        function queueRender() {
          if (!isCurrent() || self.recentRenderTimer) { return; }
          self.recentRenderTimer = window.setTimeout(function() {
            self.recentRenderTimer = null;
            if (!isCurrent()) { return; }
            // setupOutput expects oldest first and reverses for display.
            var ready = products.filter(Boolean).slice(0, limit).reverse();
            self.captureProductDetails(ready);
            self.setupOutput(ready);
          }, 0);
        }
        function settle(index, product) {
          active -= 1;
          if (!isCurrent()) { return; }
          if (product) {
            products[index] = product;
            found += 1;
            queueRender();
          }
          pump();
          if (!active && (found >= limit || cursor >= handles.length)) { queueRender(); }
        }
        function pump() {
          if (!isCurrent()) { return; }
          // Three simultaneous reads; no speculative reads once enough
          // products plus in-flight candidates can fill the visible cards.
          while (active < 3 && cursor < handles.length && found + active < limit) {
            (function(index) {
              active += 1;
              self.getProductInfo(handles[index]).then(function(product) {
                settle(index, product);
              }, function() { settle(index, null); });
            })(cursor++);
          }
        }
        pump();
      },

      getProductInfo: function(handle) {
        var context = currentCache();
        if (typeof handle !== 'string' || !handle || handle === 'undefined' || /[/?#]/.test(handle) ||
            theme.recentlyViewed.shouldExclude(handle)) {
          return Promise.resolve(null);
        }
        var cache = theme.recentlyViewed.productInfo;
        if (Object.prototype.hasOwnProperty.call(cache, handle) && validProduct(cache[handle], handle)) {
          return Promise.resolve(cache[handle]);
        }
        if (pending[handle]) { return pending[handle]; }

        var controller = window.AbortController ? new window.AbortController() : null;
        var timer;
        var timeout = new Promise(function(resolve) {
          timer = window.setTimeout(function() {
            if (controller) { controller.abort(); }
            resolve(null);
          }, 3000);
        });
        var request = Promise.resolve().then(function() {
          return fetch(storefrontRoot() + 'products/' + encodeURIComponent(handle) + '.js',
            controller ? { signal: controller.signal } : {});
        }).then(function(response) {
          if (!response.ok) { return null; }
          return response.json();
        }).then(function(product) {
          return validProduct(product, handle) && !theme.recentlyViewed.shouldExclude(product) ? product : null;
        }).catch(function() { return null; });
        var requestMap = pending;
        var settled = Promise.race([request, timeout]).then(function(product) {
          window.clearTimeout(timer);
          delete requestMap[handle];
          if (context !== priceContext()) { return null; }
          if (product) { cache[handle] = product; }
          return product;
        });
        requestMap[handle] = settled;
        return settled;
      },

      setupOutput: function(products) {
        var allProducts = [];
        var limit = Number(this.container.getAttribute('data-recent-count')) || 5;
        products.forEach(function(rawProduct) {
          if (!validProduct(rawProduct) || theme.recentlyViewed.shouldExclude(rawProduct) || rawProduct.handle === this.handle) {
            return;
          }
          // Formatting must never mutate the raw price cache. Otherwise a
          // later render can add the cushion pad amount for a second time.
          var product = Object.assign({}, rawProduct);
          var recentProduct = theme.recentlyViewed.recent[product.handle] || {};
          var cushionPadPrice = Number(recentProduct.cushionPadPrice) || 0;
          if (cushionPadPrice > 0) {
            product.price += cushionPadPrice;
            product.price_min += cushionPadPrice;
            product.price_max += cushionPadPrice;
          }
          var savedVariant = String(recentProduct.url || '').match(/[?&]variant=(\d+)(?:&|$)/);
          product.url = storefrontRoot() + 'products/' + encodeURIComponent(product.handle) +
            (savedVariant ? '?variant=' + savedVariant[1] : '');
          var widths = [180, 360, 540, 720, 900];
          product.image_responsive_url = theme.Images.buildImagePath(product.featured_image);
          product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths);
          product.image_aspect_ratio = recentProduct.aspectRatio;

          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit !== '') { product.unit_price += '/' + baseUnit; }
          }
          allProducts.unshift(product);
        }.bind(this));

        if (!allProducts.length) {
          this.outputContainer.innerHTML = '';
          this.container.classList.add('hide');
          return;
        }
        var visibleProducts = allProducts.slice(0, limit);
        var cards = this.renderedRecentCards || (this.renderedRecentCards = Object.create(null));
        var changed = false;
        var keep = Object.create(null);
        visibleProducts.forEach(function(product, index) {
          keep[product.handle] = true;
          var card = cards[product.handle];
          if (!card) {
            var holder = document.createElement('div');
            holder.innerHTML = theme.buildProductGridItem([product], this.gridItemWidth, this.rowOf, this.imageSizes);
            card = holder.firstElementChild;
            if (!card) { return; }
            card.setAttribute('data-mekhann-recent-handle', product.handle);
            cards[product.handle] = card;
          }
          // Insert only the newly arrived card. Existing links, focus and
          // image elements survive progressive results without reinitializing.
          var position = this.outputContainer.children[index] || null;
          if (position !== card) {
            this.outputContainer.insertBefore(card, position);
            changed = true;
          }
        }.bind(this));
        Object.keys(cards).forEach(function(handle) {
          if (!keep[handle]) {
            cards[handle].remove();
            delete cards[handle];
            changed = true;
          }
        });
        this.container.classList.remove('hide');
        if (changed && typeof AOS !== 'undefined' && AOS &&
            (this.outputContainer.matches('[data-aos]') || this.outputContainer.querySelector('[data-aos]'))) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function(products) {
        currentCache();
        products.forEach(function(product) {
          if (validProduct(product) && !theme.recentlyViewed.shouldExclude(product)) {
            theme.recentlyViewed.productInfo[product.handle] = product;
          }
        });
        // Price payloads are deliberately page-local. New documents request
        // fresh presentment prices, never an old unscoped session cache.
      },

      onUnload: function() {
        this.unloaded = true;
        window.clearTimeout(this.recentRenderTimer);
        this.recentRenderTimer = null;
      }
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop();
    }

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    try {
      var storedRecent = JSON.parse(window.localStorage.getItem('theme-recent') || '{}');
      if (storedRecent && typeof storedRecent === 'object' && !Array.isArray(storedRecent)) {
        Object.keys(storedRecent).forEach(function(handle) {
          var entry = storedRecent[handle];
          if (handle !== '__proto__' && handle !== 'constructor' && handle !== 'hasOwnProperty' &&
              entry && typeof entry === 'object' && !Array.isArray(entry)) {
            theme.recentlyViewed.recent[handle] = entry;
          }
        });
        theme.recentlyViewed.saveHistory();
      }
    } catch (error) {
      // Broken optional history must not abort product/gallery initialization.
      theme.recentlyViewed.recent = {};
    }
  }

  // Ignore legacy session product payloads: they have neither reliable
  // parsed objects nor country/currency context. The page-local cache is
  // populated by RecentlyViewed from current storefront responses only.
  theme.recentlyViewed.productInfo = {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.documentElement.setAttribute('data-mekhann-theme-pdp-build', 'V2.27-PDP-2026-09-10');
    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();
